import axios from "axios"
import { downloadSystemConfigFile } from "../../http/UAM/systemConfig.helper";
import ToastDialog from "components/Common/ToastDialog"
import withRouter from "components/Common/withRouter"
import { useFormik, FieldArray, FormikProvider, } from "formik"
import PropTypes from "prop-types"
import React, { useEffect, useState, useCallback } from "react"
import { useNavigate } from 'react-router-dom'
import Loader from "react-spinner-loader"
import * as Yup from "yup"
import "./main.scss"
import Select from "react-select"
import { useDropzone } from 'react-dropzone'
import API_SERVICES from "constants/app.constants";
import { callGetCIUser, callAssignDealFinancier, callAssignToMeDealFinancier } from "../../http/fundLync/dealFinancier";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { format, parse } from 'date-fns';

import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
  Modal,
  ModalHeader,
  Button,
  Table
} from "reactstrap"

//Import Breadcrumb
import { decryptedValue, isPermission, uId } from "common/utility"
import { callBankList, callFinancierList, callReferredFinancierList } from "http/fundLync/common.helper"
import { confirmAlert } from 'react-confirm-alert'
import { editDeal, editDealDraft, getDealInfo ,allEntity} from "../../http/fundLync/deal.helper"
import { getDropDownList } from "../../http/fundLync/dropdown.helper"
import { getOneEntity, callGetState, callGetCity, getCpAnchor } from '../../http/fundLync/entityAndAddress.helper'

//redux
import { API_URL } from "../../http/url.helper"

import {
  addShareholding,
  editShareholding,
  getShareholdingList,
} from "http/fundLync/entityAndAddress.helper";
import { formatDateString1 } from "../EntityDashboard/borrowingProfile"
const EditDeal = props => {
  document.title = "Entity | FundLync"
  const navigate = useNavigate();
  const currentDate = new Date().toISOString().split("T")[0];
  const urlParams = new URLSearchParams(window.location.search);
  const encodedId = urlParams.get("id");
  const decodedId = atob(encodedId);
  const user = decryptedValue(localStorage.getItem("user"));
  const [toastInfo, setToastInfo] = useState({ showToast: false });
  const [isAdmin, setIsAdmin] = useState(false);
  const [entity, setEntity] = useState([])
  const [entityList, setEntityList] = useState([])
  const [isOpen, setIsOpen] = useState(false);
  const [tenureList, setTenureList] = useState([])
  const [loanTypeList, setLoanTypeList] = useState([])
  const [securityCoverList, setSecurityCoverList] = useState([])
  const [guaranteeList, setGuaranteeList] = useState([])
  const [entityArrangeList, setEntityArrangeList] = useState([])
  const [entityGuaranteeList, setEntityGuaranteeList] = useState([])
  const [entityArrangeListForVendor, setEntityArrangeListForVendor] = useState([])
  const [endUseList, setEndUseList] = useState([])
  const [primarySecurityList, setPrimarySecurityList] = useState([])
  const [typeOfChargeList, setTypeOfChargeList] = useState([])
  const [isSelectedDpo, setIsSelectedDpo] = useState(false)
  const [selectedMulti1, setSelectedMulti1] = useState([]);
  const [selectedMulti2, setSelectedMulti2] = useState([]);
  const [selectedMulti3, setSelectedMulti3] = useState([]);
  const [selectedMulti4, setSelectedMulti4] = useState([]);
  const [selectedMulti5, setSelectedMulti5] = useState([]);
  const [selectedMulti6, setSelectedMulti6] = useState([]);
  const [selectedMulti7, setSelectedMulti7] = useState([]);
  const [selectedMulti8, setSelectedMulti8] = useState([]);
  const [selectedPrefFinancierMulti1, setSelectedPrefFinancierMulti1] = useState([]);
  const [selectedPrefFinancierMulti2, setSelectedPrefFinancierMulti2] = useState([]);
  const [selectedPrefFinancierMulti3, setSelectedPrefFinancierMulti3] = useState([]);
  const [selectedPrefFinancierMulti4, setSelectedPrefFinancierMulti4] = useState([]);
  const [selectedPrefFinancierMulti5, setSelectedPrefFinancierMulti5] = useState([]);
  const [selectedPrefFinancierMulti6, setSelectedPrefFinancierMulti6] = useState([]);
  const [selectedPrefFinancierMulti7, setSelectedPrefFinancierMulti7] = useState([]);
  const [selectedPrefFinancierMulti8, setSelectedPrefFinancierMulti8] = useState([]);
  const [selectedOption, setSelectedOption] = useState('');
  const [selectedFldg, setSelectedFldg] = useState('');
  const [selectedGuarantee, setSelectedGuarantee] = useState('');
  const [dealerfinancingArrangement, setDealerfinancingArrangement] = useState('');
  const [vendorfinancingArrangement, setVendorfinancingArrangement] = useState('');
  const [cashDiscount, setCashDiscount] = useState('');
  const [vendorPays, setVendorPays] = useState('');
  const [selectedBusinessRequirement, setSelectedBusinessRequirement] = useState('');
  const [error, setError] = useState('');
  const [errorBusiness, setErrorBusiness] = useState('');
  const [errorfinancing, setErrorfinancing] = useState('');
  const [errorfinancingVendor, setErrorfinancingVendor] = useState('');
  const [errorCashDiscount, setErrorCashDiscount] = useState('');
  const [errorFldg, setErrorFldg] = useState('');
  const [errorSecured, setErrorSecured] = useState('');
  const [errorGuarantee, setErrorGuarantee] = useState('');
  const [errorvendorPays, setErrorvendorPays] = useState('');
  const [selectedIsSecured, setSelectedIsSecured] = useState('');
  const [loader, setLoader] = useState(false)
  const [bankList, setBankList] = useState([]);
  const [selectedFinType, setSelectedFinType] = useState('');
  const [selectedPrefFinType, setSelectedPrefFinType] = useState("");
  const [errorSelectedFinancier, setErrorSelectedFinancier] = useState('');
  const [isApprovePermission, setIsApprovePermission] = useState(false)
  const [isfullAccess, setIsfullAccess] = useState(false)
  const [isLoanAgainstProperty, setIsLoanAgainstProperty] = useState(false)
  const [isPasswordBankStatement, setIsPasswordBankStatement] = useState('')
  const [isOtherIncomeSource, setIsOtherIncomeSource] = useState('')
  const [isPasswordError, setIsPasswordError] = useState('')
  const [isIncomeError, setIsIncomeError] = useState('')
  const [isCoBorrower, setIsCoBorrower] = useState('')
  const [isCoBorrowerError, setIsCoBorrowerError] = useState('')
  const [coBorrowerIncomeType, setCoBorrowerIncomeType] = useState('')
  const [incomeCoBorrowerError, setIncomeCoBorrowerError] = useState('')
  const [coBorrowerOfPropList, setCoBorrowerOfPropList] = useState([]);
  const [selectedBankName, setSelectedBankName] = useState('');
  const [isEquipmentFinance, setIsEquipmentFinance] = useState(false)
  const [selectedEquipment, setSelectedEquipment] = useState('');
  const [equipmentError, setEquipmentError] = useState('');
  const [selectedSubEquipment, setSelectedSubEquipment] = useState('');
  const [subEquipmentError, setSubEquipmentError] = useState('');
  const [selectedEquipmentType, setSelectedEquipmentType] = useState('');
  const [equipmentTypeError, setEquipmentTypeError] = useState('');

  const [uploadProgressCma, setUploadProgressCma] = useState(0)
  const [uploadProgressBankStat, setUploadProgressBankStat] = useState(0)
  const [uploadProgressCoBoPan, setUploadProgressCoBoPan] = useState(0)
  const [uploadProgressCoBoItr, setUploadProgressCoBoItr] = useState(0)

  const [errorMessageCma, setErrorMessageCma] = useState(null)
  const [errorMessageBankStat, setErrorMessageBankStat] = useState(null)
  const [errorMessageCoBoPan, setErrorMessageCoBoPan] = useState(null)
  const [errorMessageCoBoItr, setErrorMessageCoBoItr] = useState(null)
  const [isAssignmentPermisssion, setIsAssignmentPermisssion] = useState(false)
  const [isAssignmentForMePermisssion, setIsAssignmentForMePermisssion] = useState(false)
  const [assignmodal, setAssignmodal] = useState(false);
  const [userList, setUserList] = useState([]);
  const [modal, setModal] = useState(false);
  const [publicSectorBankList, setPublicSectorBankList] = useState([]);
  const [privateSectorBankList, setPrivateSectorBankList] = useState([]);
  const [NBFCList, setNBFCList] = useState([]);
  const [publicFinancier, setPublicFinancier] = useState([]);
  const [privateFinancier, setPrivateFinancier] = useState([]);
  const [nbfcFinancier, setNbfcFinancier] = useState([]);
  const [preferredPublicFinancier, setPreferredPublicFinancier] = useState([]);
  const [preferredPrivateFinancier, setPreferredPrivateFinancier] = useState([]);
  const [preferredNbfcFinancier, setPreferredNbfcFinancier] = useState([]);

  const [dealStatusBucketList, setDealStatusBucketList] = useState([]);
  const [anchorList, setAnchorList] = useState([]);

  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectedProductsType, setSelectedProductsType] = useState([]);
  const [dealDetail, setDealDetail] = useState({})
  const [valuationDone, setValuationDone] = useState("");
  const [selectEquityType, setSelectEquityType] = useState("");
  const [selectFreshOrDiluted, setSelectFreshOrDiluted] = useState("");
  const [selectdebenturesSecuredOrUnsecured, setSelectdebenturesSecuredOrUnsecured] = useState("");
  const [selectdebenturesRatedOrUnrated, setSelectdebenturesRatedOrUnrated] = useState("");
  const [selectCommercialRatedOrUnrated, setSelectCommercialRatedOrUnrated] = useState("");
  const [selectPoolPSLorNonPSL, setSelectpoolPSLorNonPSL] = useState("");
  const [selectPoolRatedOrUnrated, setSelectpoolRatedOrUnrated] = useState("");

  const [valuationDoneError, setValuationDoneError] = useState("");
  const [selectEquityTypeError, setSelectEquityTypeError] = useState("");
  const [selectFreshOrDilutedError, setSelectFreshOrDilutedError] = useState("");
  const [selectdebenturesSecuredOrUnsecuredError, setSelectdebenturesSecuredOrUnsecuredError] = useState("");
  const [selectdebenturesRatedOrUnratedError, setSelectdebenturesRatedOrUnratedError] = useState("");
  const [selectCommercialRatedOrUnratedError, setSelectCommercialRatedOrUnratedError] = useState("");
  const [selectPoolPSLorNonPSLError, setSelectpoolPSLorNonPSLError] = useState("");
  const [selectPoolRatedOrUnratedError, setSelectpoolRatedOrUnratedError] = useState("");
  const [referredFinancierList, setReferredFinancierList] = useState([]);
  const [refferedFinModal, setRefferedFinModal] = useState(false);
  const [preferredFinModal, setPreferredFinModal] = useState(false);
  const [isShowRecommendFinancier, setIsShowRecommendFinancier] = useState(false);
  const [selectedAnchorName, setSelectedAnchorName] = useState("");
  const [hasOpenedBefore, setHasOpenedBefore] = useState(true);
  const [prospectiveProductList, setProspectiveProductList] = useState([]);
  const [prosposalTypeList, setProsposalTypeList] = useState([]);
  const [partnerProgramList, setPartnerProgramList] = useState([]);
  const [selectedDealType, setDealType] = useState("");
  
  const [rows, setRows] = useState([
    {
      propertyNature: "",
      propertyOwner: "",
      propertyStatus: "",
      propertyValue: "",
      propertyAge: "",
      address: "",
      city: "",
      pincode: "",
      state: "",
      parentDeed: "",
      saleDeed: "",
      utilityBills: "",
      propertyTax: ""
    },
  ]);

  const [shareholdingList, setShareholdingList] = useState([]);
  const [percentageholdingValue, setPercentageholdingValue] = useState(0);

  const [productInfo,setProductInfo] = useState([
    {
      product: '',
      productType: '',
      subProduct: [],
      integrationFeesType: '',
      integrationFeesFrequency: '',
      integrationFeesOccurrence: '',
      integrationFeesValue: '',
      syndicationFeesType: '',
      syndicationFeesFrequency: '',
      syndicationFeesOccurrence: '',
      syndicationFeesValue: '',
      platformChargesType: '',
      platformChargesFrequency: '',
      platformChargesOccurrence: '',
      platformChargesValue: '',
      platformChargesBenchmarkRate: '',
      platformChargesMarkupOverBenchmark: '',
      platformChargesBenchmark:'',
      platformChargesNVG:''
    }
  ]);

  const [productSettingObj, setProductSettingObj] = useState(
    {
      "requested_loan_amount": false,
      "vendor_payment_schedule": false,
      "business_requirement": false,
      "business_requirement2": false,
      "existing_vendor_financing": false,
      "guarantee_offer_to_lender": false,
      "monthly_purchases_value": false,
      "dealer_credit_period": false,
      "existing_dealer_financing": false,
      "geographical_sales_distribution": false,
      "dealer_cash_discounts": false,
      "default_guarantee_offer_fldg": false,
      "monthly_sales": false,
      "interest_rate": false,
      "loan_tenure": false,
      "loan_type": false,
      "guarantee": false,
      "is_loan_secured": false,
      "security_cover": false,
      "end_use": false,
      "primary_security": false,
      "charge_type": false,
      "cma_documents": false,
      "equipment_category": false,
      "equipment_sub_category": false,
      "equipment_type": false,
      "bank_name": false,
      "bank_statement": false,
      "statement_password": false,
      "other_income_source": false,
      "income_tax_returns_contribution": false,
      "co_borrower": false,
      "property_list": false,
      "isValuationDone": false,
      "investorsType": false,
      "equityType": false,
      "purposeOfRaisingEquity": false,
      "freshOrDiluted": false,
      "dilutedEquityHolder": false,
      "capexEquipmentImported": false,
      "bankAvalizingBill": false,
      "loan_tenure": false,
      "debenturesSecuredOrUnsecured": false,
      "debenturesRatedOrUnrated": false,
      "purposeOfIssuingDebentures": false,
      "purposeOfIssuingCommercial": false,
      "commercialRatedOrUnrated": false,
      "coupon": false,
      "poolPSLorNonPSL": false,
      "poolRatedOrUnrated": false,
      "desiredCoupon": false,
      "poolAgeing": false,
      "shareHoldingPattern":false
    }
  )

  let productSetting = {
    "Payable Financing": {
      "requested_loan_amount": true,
      "vendor_payment_schedule": true,
      "business_requirement": true,
      "existing_vendor_financing": true,
      "guarantee_offer_to_lender": true,
      "monthly_purchases_value": true,
    },
    "Receivable Financing": {
      "requested_loan_amount": true,
      "dealer_credit_period": true,
      "business_requirement2": true,
      "existing_dealer_financing": true,
      "geographical_sales_distribution": true,
      "dealer_cash_discounts": true,
      "default_guarantee_offer_fldg": true,
      "monthly_sales": true,
    },
    "WCDL": {
      "requested_loan_amount": true,
      "interest_rate": true,
      "loan_tenure": true,
      "loan_type": true,
      "guarantee": true,
      "is_loan_secured": true
    },
    "CC/OD": {
      "requested_loan_amount": true,
      "interest_rate": true,
      "loan_tenure": true,
      "loan_type": true,
      "guarantee": true,
      "is_loan_secured": true
    },
    "Operating lease": {
      "requested_loan_amount": true,
      "interest_rate": true,
      "loan_tenure": true,
      "loan_type": true,
      "guarantee": true,
      "is_loan_secured": true
    },
    "Finance lease": {
      "requested_loan_amount": true,
      "interest_rate": true,
      "loan_tenure": true,
      "loan_type": true,
      "guarantee": true,
      "is_loan_secured": true
    },
    "Equipment Finance": {
      "requested_loan_amount": true,
      "interest_rate": true,
      "loan_tenure": true,
      "loan_type": true,
      "guarantee": true,
      "is_loan_secured": true,
      "security_cover": true,
      "end_use": true,
      "primary_security": true,
      "charge_type": true,
      "cma_documents": true,
      "equipment_category": true,
      "equipment_sub_category": true,
      "equipment_type": true,
    },
    "Loan against Property": {
      "requested_loan_amount": true,
      "interest_rate": true,
      "loan_tenure": true,
      "loan_type": true,
      "end_use": true,
      "bank_name": true,
      "bank_statement": true,
      "statement_password": true,
      "other_income_source": true,
      "income_tax_returns_contribution": true,
      "co_borrower": true,
      "property_list": true,
    },
    "Term loan": {
      "requested_loan_amount": true,
      "interest_rate": true,
      "loan_tenure": true,
      "loan_type": true,
      "guarantee": true,
      "is_loan_secured": true,
      "security_cover": true,
      "end_use": true,
      "primary_security": true,
      "charge_type": true,
      "cma_documents": true,
    },
    "Infrastructure finance": {
      "requested_loan_amount": true,
      "interest_rate": true,
      "loan_tenure": true,
      "loan_type": true,
      "guarantee": true,
      "is_loan_secured": true,
      "security_cover": true,
      "end_use": true,
      "primary_security": true,
      "charge_type": true,
      "cma_documents": true,
    },
    "Equity": {
      "requested_loan_amount": true,
      "percentageOfEquityDiluted": true,
      "isValuationDone": true,
      "investorsType": true,
      "equityType": true,
      "purposeOfRaisingEquity": true,
      "freshOrDiluted": true,
      "dilutedEquityHolder": true,
      "shareHoldingPattern":true
    },
    "Forfaiting": {
      "requested_loan_amount": true,
      "vendor_payment_schedule": true,
      "business_requirement": true,
      "existing_vendor_financing": true,
      "guarantee_offer_to_lender": true,
      "monthly_purchases_value": true,
      "capexEquipmentImported": true,
      "bankAvalizingBill": true,
      "loan_tenure": true
    },
    "Debetures": {
      "requested_loan_amount": true,
      "loan_tenure": true,
      "debenturesSecuredOrUnsecured": true,
      "debenturesRatedOrUnrated": true,
      "purposeOfIssuingDebentures": true
    },
    "Commercial paper": {
      "requested_loan_amount": true,
      "loan_tenure": true,
      "purposeOfIssuingCommercial": true,
      "commercialRatedOrUnrated": true,
      "coupon": true
    },
    "Securitisation": {
      "requested_loan_amount": true,
      "loan_tenure": true,
      "poolPSLorNonPSL": true,
      "poolRatedOrUnrated": true,
      "desiredCoupon": true,
      "poolAgeing": true
    },
    "Buyers Credit": {
      "requested_loan_amount": true,
      "vendor_payment_schedule": true,
      "business_requirement": true,
      "existing_vendor_financing": true,
      "guarantee_offer_to_lender": true,
      "monthly_purchases_value": true
    },
    "Suppliers Credit": {
      "requested_loan_amount": true,
      "vendor_payment_schedule": true,
      "business_requirement": true,
      "existing_vendor_financing": true,
      "guarantee_offer_to_lender": true,
      "monthly_purchases_value": true
    },
    "Inventory funding": {
      "requested_loan_amount": true,
      "dealer_credit_period": true,
      "business_requirement2": true,
      "existing_dealer_financing": true,
      "geographical_sales_distribution": true,
      "dealer_cash_discounts": true,
      "default_guarantee_offer_fldg": true,
      "monthly_sales": true,
    },
  }

  const statusMapping = {
    "1": 'Financier Queue',
    "2": 'Submitted By Partner',
    "3": 'Draft',
    "4": 'Submitted By Customer',
    "5": 'Pending E-Signing',
    "6": 'Prospect',
    "7": 'Meeting Done',
    "8": 'WIP',
    "9": 'Referred',
    "10": 'Queries',
    "11": 'Approved',
    "12": 'Rejected',
    "13": 'On Hold',
    "14": 'Pre Sanction Documents',
    "15": 'Live',
    "16": 'Customer backed out',
    "17": 'Terms conditions not accepted',
    '18': 'Deal lost',
    "19": 'Sanctioned',
    "20": 'Credit Appraisal'
  };

  const handleOptionChange = (event) => {
    if (event.target.value == "Yes") {
      validation.values.isCreditPeriod = true
    } else {
      validation.values.isCreditPeriod = false
    }
    setSelectedOption(event.target.value);
    setError('');
  };

  const capitalizeFirstLetter = (inputString) => {
    if (typeof inputString !== 'string' || inputString.length === 0) {
      return inputString;
    }
    return inputString.charAt(0).toUpperCase() + inputString.slice(1);
  }

  const handleSubEquipmetChange = (event) => {
    setSelectedSubEquipment(event.target.value);
    validation.setFieldValue('equipmentSubCategory', event.target.value)
    setSubEquipmentError('');
  };

  const handleEquipmetTypeChange = (event) => {
    setSelectedEquipmentType(event.target.value);
    validation.setFieldValue('equipmentType', event.target.value)
    setEquipmentTypeError('');
  };

  const handleEquipmetChange = (event) => {
    setSelectedEquipment(event.target.value);
    validation.setFieldValue('equipmentCategory', event.target.value)
    setEquipmentError('');
  };

  const handlePasswordChange = (event) => {
    if (event.target.value == "Yes") {
      validation.setFieldValue('isPasswordBankStatement', true)
    } else {
      validation.setFieldValue('isPasswordBankStatement', false)
    }
    setIsPasswordBankStatement(event.target.value);
    setIsPasswordError('');
  };

  const handleIncomeChange = (event) => {
    if (event.target.value == "Yes") {
      validation.setFieldValue('isOtherIncomeSource', true)
    } else {
      validation.setFieldValue('isOtherIncomeSource', false)
    }
    setIsOtherIncomeSource(event.target.value);
    setIsIncomeError('');
  };

  const handleCoBorrowerChange = (event) => {
    if (event.target.value == "Yes") {
      validation.setFieldValue('isCoBorrower', true)
    } else {
      validation.setFieldValue('isCoBorrower', false)
    }
    setIsCoBorrower(event.target.value);
    setIsCoBorrowerError('');
  };

  const handleIncomeTypeChange = (event) => {
    validation.setFieldValue('coBorrowerIncomeType', event.target.value)
    setCoBorrowerIncomeType(event.target.value);
    setIncomeCoBorrowerError('');
  };

  const handlevendorPays = (event) => {
    validation.values.vendorPay = event.target.value
    setVendorPays(event.target.value);
    setErrorvendorPays('');
  };

  const handleSecureChange = (event) => {
    if (event.target.value == "Yes") {
      validation.values.isSecured = true
      getDropDownList({ dropdownName: "Security Cover" })
        .then((response) => {
          const dropdownValues = response.data?.rows?.find((dv) => dv.dropdownName == "Security Cover")?.dropdownValues || []
          setSecurityCoverList(dropdownValues)
        })
        .catch((error) => {

        });
    } else {
      validation.values.isSecured = false
    }
    setSelectedIsSecured(event.target.value);
    setErrorSecured('');
  };

  const handleFldgChange = (event) => {
    if (event.target.value == "Yes") {
      validation.values.isFldg = true
    } else {
      validation.values.isFldg = false
    }
    setSelectedFldg(event.target.value);
    setErrorFldg('');
  };

  const handleGuaranteeChange = (event) => {
    if (event.target.value == "Yes") {
      validation.values.isGuaranteeLender = true
    } else {
      validation.values.isGuaranteeLender = false
    }
    if (event.target.value == "Yes") {
      getDropDownList({ dropdownName: "Guarantee Types For Lender" })
        .then((response) => {
          const dropdownValues = response.data?.rows?.find((dv) => dv.dropdownName == "Guarantee Types For Lender")?.dropdownValues || []
          const formattedOptions = dropdownValues.map(option => ({
            label: option.displayName,
            value: option.dropdownValue,
          }));
          setEntityGuaranteeList(formattedOptions)
          setSelectedMulti5(selectedData(formattedOptions, entity.guaranteeTypesLender))
        })
    }
    setSelectedGuarantee(event.target.value);
    setErrorGuarantee('');
  };

  const handleBusinessRequirement = (event) => {
    validation.values.businessRequirement = event.target.value
    setSelectedBusinessRequirement(event.target.value);
    if (event.target.value == "Extend Days Payable Outstanding(DPO)") {
      setIsSelectedDpo(true)
    } else {
      setIsSelectedDpo(false)
    }
    setErrorBusiness('');
  };

  const handleCashDiscount = (event) => {
    if (event.target.value == "Yes") {
      validation.values.isCashDiscount = true
    } else {
      validation.values.isCashDiscount = false
    }
    setCashDiscount(event.target.value);
    setErrorCashDiscount('');
  };

  const handledealerfinancingArrangement = (event) => {
    if (event.target.value == "Yes") {
      validation.values.isDealerArrangement = true
    } else {
      validation.values.isDealerArrangement = false
    }
    setDealerfinancingArrangement(event.target.value);
    if (event.target.value == "Yes") {
      getDropDownList({ dropdownName: "Financing Arrangement" })
        .then((response) => {
          const dropdownValues = response.data?.rows?.find((dv) => dv.dropdownName == "Financing Arrangement")?.dropdownValues || []
          const formattedOptions = dropdownValues.map(option => ({
            label: option.displayName,
            value: option.dropdownValue,
          }));
          setEntityArrangeList(formattedOptions)
          setSelectedMulti3(selectedData(formattedOptions, entity.dealerArrangement))
        })
    }
    setErrorfinancing('');
  };

  const handlevendorfinancingArrangement = (event) => {
    if (event.target.value == "Yes") {
      validation.values.isVendorArrangement = true
    } else {
      validation.values.isVendorArrangement = false
    }
    setVendorfinancingArrangement(event.target.value);
    if (event.target.value == "Yes") {
      getDropDownList({ dropdownName: "Financing Arrangenment for vendor" })
        .then((response) => {
          const dropdownValues = response.data?.rows?.find((dv) => dv.dropdownName == "Financing Arrangenment for vendor")?.dropdownValues || []
          const formattedOptions = dropdownValues.map(option => ({
            label: option.displayName,
            value: option.dropdownValue,
          }));
          setEntityArrangeListForVendor(formattedOptions)
          setSelectedMulti4(selectedData(formattedOptions, entity.vendorsArrangement))
        })
    }
    setErrorfinancingVendor('');
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (isAdmin && validation.values.financier.length === 0) {
      setErrorSelectedFinancier("Please select at least one financier.");
      return;
  }
    if (selectedOption == '' && isOpen) {
      setError('Please select an option');
    }
   
    if (selectedBusinessRequirement == '' && (productSettingObj.business_requirement2 || productSettingObj.business_requirement)) {
      setErrorBusiness('Please select an option');
    }

    if (dealerfinancingArrangement == '' && productSettingObj.existing_dealer_financing) {
      setErrorfinancing('Please select an option');
    }

    if (vendorfinancingArrangement == '' && productSettingObj.existing_vendor_financing) {
      setErrorfinancingVendor('Please select an option');
    }

    if (cashDiscount == '' && productSettingObj.dealer_cash_discounts) {
      setErrorCashDiscount('Please select an option');
    }

    if (selectedFldg == '' && productSettingObj.default_guarantee_offer_fldg) {
      setErrorFldg('Please select an option');
    }

    if (selectedGuarantee == '' && productSettingObj.guarantee_offer_to_lender) {
      setErrorGuarantee('Please select an option');
    }

    if (vendorPays == '' && productSettingObj.vendor_payment_schedule) {
      setErrorvendorPays('Please select an option');
    }

    if (selectedIsSecured == '' && productSettingObj.is_loan_secured) {
      setErrorSecured('Please select an option');
    }

    if (selectedFinType == '') {
      setErrorSelectedFinancier('Please select an option');
    }
    if (selectedPrefFinType == "") {
      setErrorSelectedFinancier("Please select an option");
    }

    if (isPasswordBankStatement == ''  && productSettingObj.statement_password) {
      setIsPasswordError('Please select an option');
    }

    if (isOtherIncomeSource == '' && productSettingObj.other_income_source) {
      setIsIncomeError('Please select an option');
    }

    if (isCoBorrower == ''  && productSettingObj.co_borrower) {
      setIsCoBorrower('Please select an option');
    }

    if (coBorrowerIncomeType == '' && productSettingObj.property_list) {
      setIncomeCoBorrowerError('Please select an option');
    }

    if (selectedEquipment == '' && productSettingObj.equipment_category) {
      setEquipmentError('Please select an option');
    }

    if (selectedSubEquipment == '' && productSettingObj.equipment_sub_category) {
      setSubEquipmentError('Please select an option');
    }

    if (selectedEquipmentType == '' && productSettingObj.equipment_type) {
      setEquipmentTypeError('Please select an option');
    }

    if (valuationDone == '' && productSettingObj.isValuationDone) {
      setValuationDoneError("Please select an option");
    }

    if (selectEquityType == null && productSettingObj.equityType) {
      setSelectEquityTypeError("Please select an option");
    }

    if (selectFreshOrDiluted == null && productSettingObj.freshOrDiluted) {
      setSelectFreshOrDilutedError("Please select an option");
    }

    if (selectdebenturesSecuredOrUnsecured == null && productSettingObj.debenturesSecuredOrUnsecured) {
      setSelectdebenturesSecuredOrUnsecuredError("Please select an option");
    }

    if (selectdebenturesRatedOrUnrated == null && productSettingObj.debenturesRatedOrUnrated) {
      setSelectdebenturesRatedOrUnratedError("Please select an option");
    }

    if (selectCommercialRatedOrUnrated == null && productSettingObj.commercialRatedOrUnrated) {
      setSelectCommercialRatedOrUnratedError("Please select an option");
    }

    if (selectPoolPSLorNonPSL == null && productSettingObj.poolPSLorNonPSL) {
      setSelectpoolPSLorNonPSLError("Please select an option");
    }

    if (selectPoolRatedOrUnrated == null && productSettingObj.poolRatedOrUnrated) {
      setSelectpoolRatedOrUnratedError("Please select an option");
    }
  };

  const apiFetchForLAP = (product, dealInfo) => {
    getDropDownList({ dropdownName: product })
      .then((response) => {
        const dropdownValues = response.data?.rows?.find((dv) => dv.dropdownName == product)?.dropdownValues || []
        const formattedOptions = dropdownValues.map(option => ({
          label: option.displayName,
          value: option.dropdownValue,
        }));
        setEndUseList(formattedOptions)
        setSelectedMulti2(selectedData(formattedOptions, dealInfo.endUse))
      })
      .catch((error) => {
      });

    getDropDownList({ dropdownName: "co_borrower_relation" })
      .then((response) => {
        const dropdownValues = response.data?.rows?.find((dv) => dv.dropdownName == "co_borrower_relation")?.dropdownValues || []
        setCoBorrowerOfPropList(dropdownValues);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const setDealInfo = (dealInfo) => {
    if (dealInfo.businessRequirement == "Extend Days Payable Outstanding(DPO)") {
      setIsSelectedDpo(true)
    }

    setSelectedOption(formatData(dealInfo.isCreditPeriod))
    setSelectedIsSecured(formatData(dealInfo.isSecured))
    setIsOtherIncomeSource(formatData(dealInfo.isOtherIncomeSource));
    setIsPasswordBankStatement(formatData(dealInfo.isPasswordBankStatement))
    setIsCoBorrower(formatData(dealInfo.isCoBorrower));
    setCoBorrowerIncomeType(dealInfo.coBorrowerIncomeType)
    setSelectedEquipment(dealInfo.equipmentCategory)
    setSelectedEquipmentType(dealInfo.equipmentType)
    setSelectedSubEquipment(dealInfo.equipmentSubCategory)
    setDealerfinancingArrangement(formatData(dealInfo.isDealerArrangement))
    setCashDiscount(formatData(dealInfo.isCashDiscount))
    setSelectedFldg(formatData(dealInfo.isFldg))
    if (dealInfo.businessRequirement) {
      setSelectedBusinessRequirement(dealInfo.businessRequirement)
    }
    if (dealInfo.vendorPay) {
      setVendorPays(dealInfo.vendorPay)
    }
    setVendorfinancingArrangement(formatData(dealInfo.isVendorArrangement))
    setSelectedGuarantee(formatData(dealInfo.isGuaranteeLender))
    setSelectedGuarantee(formatData(dealInfo.isGuaranteeLender))
    setSelectedMulti1(selectedData(guaranteeList, dealInfo.guarantee))

    setValuationDone(formatData(dealInfo.isValuationDone))
    setSelectEquityType(dealInfo.equityType)
    setSelectFreshOrDiluted(dealInfo.freshOrDiluted)
    setSelectdebenturesSecuredOrUnsecured(dealInfo.debenturesSecuredOrUnsecured)
    setSelectdebenturesRatedOrUnrated(dealInfo.debenturesRatedOrUnrated)
    setSelectCommercialRatedOrUnrated(dealInfo.commercialRatedOrUnrated)
    setSelectpoolPSLorNonPSL(dealInfo.poolPSLorNonPSL)
    setSelectpoolRatedOrUnrated(dealInfo.poolRatedOrUnrated)
    let products = []
    let productsType = []

    let productinfo = dealInfo.dealProductCommercials.map((ele) => {
      products.push(ele.product)
      productsType.push(ele.productType)
      return {
        product: ele?.product,
        productType: ele?.productType,
        subProduct: ele?.subProduct?.split(',') || [],

        integrationFeesType: ele?.commercials?.integrationFees?.Type,
        integrationFeesFrequency: ele?.commercials?.integrationFees?.Frequency,
        integrationFeesOccurrence: ele?.commercials?.integrationFees?.Occurrence,
        integrationFeesValue: ele?.commercials?.integrationFees?.Value,

        syndicationFeesType: ele?.commercials?.syndicationFees?.Type,
        syndicationFeesFrequency: ele?.commercials?.syndicationFees?.Frequency,
        syndicationFeesOccurrence: ele?.commercials?.syndicationFees?.Occurrence,
        syndicationFeesValue: ele?.commercials?.syndicationFees?.Value,

        platformChargesType: ele?.commercials?.platformCharges?.Type,
        platformChargesFrequency: ele?.commercials?.platformCharges?.Frequency,
        platformChargesOccurrence: ele?.commercials?.platformCharges?.Occurrence,
        platformChargesValue: ele?.commercials?.platformCharges?.Value,
        platformChargesBenchmarkRate: ele?.commercials?.platformCharges?.BenchmarkRate,
        platformChargesBenchmark: ele?.commercials?.platformCharges?.Benchmark,
        platformChargesNVG: ele?.commercials?.platformCharges?.NVG,
        platformChargesMarkupOverBenchmark: ele?.commercials?.platformCharges?.platformChargesMarkupOverBenchmark,

      }
    })
    setSelectedProducts(products)
    setSelectedProductsType(productsType)
    setProductInfo(productinfo)
    validation.setFieldValue("productInfoList", productinfo);
  }

  const formatData = (data) => {
    if (data) {
      return "Yes"
    } else {
      if (data == null) {
        return ''
      }
      return "No"
    }
  }

  const selectedData = (datalist, data) => {
    if (data) {
      const dataValues = data.split(",");
      const newData = [];

      for (const value of dataValues) {
        const foundItem = datalist.find((item) => item.value == value);
        if (foundItem) {
          newData.push(foundItem);
        }
      }

      return newData;
    }

    return [];
  };

  const loadPublicSectorBankList = (search) => {
    callFinancierList({ "financierType": "public_sector" })
      .then((response) => {
        const formattedOptions = response?.data.map((option) => ({
          label: option.entityName,
          value: option.id,
        }));
        setPublicSectorBankList(formattedOptions)
        return formattedOptions
      })
      .catch((error) => {
        console.log(error)
      })
  }

  const loadPrivateSectorBankList = (search) => {
    callFinancierList({ "financierType": "private_sector" })
      .then((response) => {
        const formattedOptions = response?.data.map((option) => ({
          label: option.entityName,
          value: option.id,
        }));
        setPrivateSectorBankList(formattedOptions)
      })
      .catch((error) => {
        console.log(error)
      })
  }

  const loadNBFCList = (search) => {
    callFinancierList({ "financierType": "NBFC" })
      .then((response) => {
        const formattedOptions = response?.data.map((option) => ({
          label: option.entityName,
          value: option.id,
        }));
        setNBFCList(formattedOptions)
      })
      .catch((error) => {
        console.log(error)
      })
  }

  useEffect(() => {
    loadPublicSectorBankList();
    loadNBFCList();
    loadPrivateSectorBankList();
    checkPermissions();
    if (user.entityType == "Owner" || user.entityType == "Partner") {
      setIsAdmin(true)
    }
    getDropDownList({ dropdownName: "Security Cover" })
      .then((response) => {
        const dropdownValues = response.data?.rows?.find((dv) => dv.dropdownName == "Security Cover")?.dropdownValues || []
        setSecurityCoverList(dropdownValues)
      })
      .catch((error) => {

      });
    let dealData = []
    getDealInfo({ id: decodedId })
      .then((response) => {
        setEntity(response.data)
        setDealType(response?.data?.dealType)
        setDealInfo(response.data)
        setDealDetail(response.data)
        dealData = response.data
        // setDealType(response.data)
        getDropDownList({ dropdownName: "Deal Status Buckets" })
          .then((response) => {
            const dropdownValues = response.data?.rows?.find((dv) => dv.dropdownName == "Deal Status Buckets")?.dropdownValues || []
            setDealStatusBucketList(dropdownValues)
          })
          .catch((error) => { });
        // if (response.data.dealType == "Counterparty") {
        //   getCpAnchor({ entityId: dealData.counterpartyId })
        //     .then((response) => {
        //       setAnchorList(response.data)
        //     })
        //     .catch((error) => {
        //       console.log(error);
        //     });
        // }
        callBankList({ page: 1, limit: 200, }).then((res) => {
          const formattedOptions = res.data?.data.map(option => ({
            label: option.bankName,
            value: option.id,
          }));
          setBankList(formattedOptions);
        })
        callFinancierList()
          .then((res) => {
            const formattedOptions = res?.data.map(option => ({
              label: option.entityName,
              value: option.id,
              type: option.financierType
            }));

            const allFinanciers = selectedData(formattedOptions, response.data?.financier?.join(","))
            const publicSectorBanks = allFinanciers.filter((elem) => { return elem.type == 'public_sector' })
            const privateSectorBanks = allFinanciers.filter((elem) => { return elem.type == 'private_sector' })
            const NBFCsBanks = allFinanciers.filter((elem) => { return elem.type == 'NBFC' })

            if (allFinanciers.length > 0) {
              setSelectedFinType('Select')
              setSelectedMulti6(publicSectorBanks)
              handleMulti6(publicSectorBanks)
              setSelectedMulti7(privateSectorBanks);
              handleMulti7(privateSectorBanks)
              setSelectedMulti8(NBFCsBanks);
              handleMulti8(NBFCsBanks)
             
            }

            const allPreferredFinanciers = selectedData(formattedOptions, response.data?.preferredFinancier?.join(","));
            const preferredPublicSectorBanks = allPreferredFinanciers.filter((elem) => elem.type == 'public_sector');
            const preferredPrivateSectorBanks = allPreferredFinanciers.filter((elem) => elem.type == 'private_sector');
            const preferredNBFCsBanks = allPreferredFinanciers.filter((elem) => elem.type == 'NBFC');
        
            if (allPreferredFinanciers.length > 0) {
              setSelectedPrefFinType('Select')
              handlePrefMulti6(preferredPublicSectorBanks)
              setSelectedPrefFinancierMulti6(preferredPublicSectorBanks)
              handlePrefMulti7(preferredPrivateSectorBanks)
              setSelectedPrefFinancierMulti7(preferredPrivateSectorBanks)
              handlePrefMulti8(preferredNBFCsBanks)
              setSelectedPrefFinancierMulti8(preferredNBFCsBanks)
            }
          })

          .catch((error) => {
            console.log(error);
          });

        if (response?.data?.entityId) {
          getOneEntity({ entityId: response.data.entityId })
            .then((response) => {
              if (response.data) {
                setEntityList(response.data)
              }
            })
            .catch((error) => {

            });
        }
        allEntity({ searchKey: "", nonFinancierType: '', sortingOrder: "asc" })
          .then((response) => {
            setAnchorList(response.data)
          })
          .catch((error) => {

          });
        if (response?.data?.anchorId) {
          getOneEntity({ entityId: response.data.anchorId })
            .then((response) => {
              if (response.data) {
                setSelectedAnchorName({ label: response.data[0].entityName, value: response.data[0].id })
              }
            })
            .catch((error) => {

            });
        }

        getDropDownList({ dropdownName: "Tenure" })
          .then((response) => {
            const dropdownValues = response.data?.rows?.find((dv) => dv.dropdownName == "Tenure")?.dropdownValues || []
            setTenureList(dropdownValues)
          })
          .catch((error) => {

          });
        getDropDownList({ dropdownName: "Loan Type" })
          .then((response) => {
            const dropdownValues = response.data?.rows?.find((dv) => dv.dropdownName == "Loan Type")?.dropdownValues || []
            setLoanTypeList(dropdownValues)
          })
          .catch((error) => {

          });
        getDropDownList({ dropdownName: "Guarantee" })
          .then((response) => {
            const dropdownValues = response.data?.rows?.find((dv) => dv.dropdownName == "Guarantee")?.dropdownValues || []
            const formattedOptions = dropdownValues.map(option => ({
              label: option.displayName,
              value: option.dropdownValue,
            }));
            setGuaranteeList(formattedOptions)
            setSelectedMulti1(selectedData(formattedOptions, dealData.guarantee))
          })
          .catch((error) => {

          });
        getDropDownList({ dropdownName: "Product type" })
          .then((response) => {
            const dropdownValues = response.data?.rows?.find((dv) => dv.dropdownName == "Product type")?.dropdownValues || []
            setProductType(dropdownValues)
          })
          .catch((error) => {

          });
        getDropDownList({ dropdownName: "Security type" })
          .then((response) => {
            const dropdownValues = response.data?.rows?.find((dv) => dv.dropdownName == "Security type")?.dropdownValues || []
            setPrimarySecurityList(dropdownValues)
          })
          .catch((error) => {

          });
        getDropDownList({ dropdownName: "Type of Charge" })
          .then((response) => {
            const dropdownValues = response.data?.rows?.find((dv) => dv.dropdownName == "Type of Charge")?.dropdownValues || []
            setTypeOfChargeList(dropdownValues)
          })
          .catch((error) => {

          });
      })
      .catch((error) => {
      });
    getDropDownList({ dropdownName: "Prospective products" })
      .then((response) => {
        const dropdownValues =
          response.data?.rows?.find((dv) => dv.dropdownName == "Prospective products")
            ?.dropdownValues || [];
        setProspectiveProductList(dropdownValues);
      })
      .catch((error) => { });
      getDropDownList({ dropdownName: "Partner program" })
      .then((response) => {
        const dropdownValues =
          response.data?.rows?.find((dv) => dv.dropdownName == "Partner program")
            ?.dropdownValues || [];
            setPartnerProgramList(dropdownValues);
      })
      .catch((error) => { });
    getDropDownList({ dropdownName: "Proposal Type" })
      .then((response) => {
        const dropdownValues =
          response.data?.rows?.find((dv) => dv.dropdownName == "Proposal Type")
            ?.dropdownValues || [];
        setProsposalTypeList(dropdownValues);
      })
      .catch((error) => { });
  }, []);

  const formatDateString = (date) => {
    if (date === null || date === undefined) {
      return null;
    }
    const inputDateString = date;
    const inputDate = new Date(inputDateString);

    const year = inputDate.getFullYear();
    const month = String(inputDate.getMonth() + 1).padStart(2, "0"); // Adding 1 because months are zero-based
    const day = String(inputDate.getDate()).padStart(2, "0");

    const formattedDateString = `${year}-${month}-${day}`;
    return formattedDateString;
  }

  const commercialValidationSchema = commercialFieldsData.reduce(
    (acc, field) => {
      // if (!(isReceivableFinancing == 'Receivable Financing' && field.fieldName == 'selfFinanaces')) {
      acc[`${field.fieldName}Type`] = Yup.string();
      acc[`${field.fieldName}Frequency`] = Yup.string();
      acc[`${field.fieldName}Occurrence`] = Yup.string();
      
      acc[`${field.fieldName}Value`] = Yup.number()
        .typeError("Value must be a number")
        .when(`${field.fieldName}Type`, {
          is: "Percentage",
          then: Yup.number()
            .typeError("Value must be a number")
            .max(
              100,
              `${field.fieldLabel} value must be less than or equal to 100`
            ),
        })
        .min(0, `${field.fieldLabel} value must not be negative.`);

        if(field.fieldName == 'platformCharges'){
          acc[`${field.fieldName}Value`] = Yup.number()
          .typeError("Value must be a number")
          .when(`${field.fieldName}Type`, {
            is: "Throughput",
            then: Yup.number()
              .typeError("Value must be a number")
              .max(
                100,
                `${field.fieldLabel} value must be less than or equal to 100`
              ),
          })
          .min(0, `${field.fieldLabel} value must not be negative.`);
        }

      acc[`${field.fieldName}BenchmarkRate`] = Yup.number()
        .typeError("Benchmark rate  must be a number")
        .when(`${field.fieldName}Type`, {
          is: "NVG",
          then: Yup.number()
            .typeError("Benchmark rate must be a number")
            .max(
              100,
              `Benchmark rate value must be less than or equal to 100`
            ),
        })
        .min(0, `Benchmark rate value must not be negative.`);

      acc[`${field.fieldName}MarkupOverBenchmark`] = Yup.number()
        .typeError("Markup over benchmark must be a number")
        .when(`${field.fieldName}Type`, {
          is: "NVG",
          then: Yup.number()
            .typeError("Markup over benchmark must be a number")
            .max(
              100,
              `Markup over benchmark value must be less than or equal to 100`
            ),
        })
        .min(0, `Markup over benchmark value must not be negative.`);

      acc[`${field.fieldName}NVG`] = Yup.number()
        .typeError("NVG must be a number")
        .when(`${field.fieldName}Type`, {
          is: "NVG",
          then: Yup.number()
            .typeError("NVG must be a number")
            .max(
              100,
              `NVG value must be less than or equal to 100`
            ),
        })
        .min(0, `NVG value must not be negative.`);

        if(isAdmin){
        if (field.fieldName === "syndicationFees" || field.fieldName === "integrationFees") {
          acc[`${field.fieldName}Type`] = Yup.string()
            .when('product', {
              is: 'Inventory funding',
              then: Yup.string().required(`Enter Type`),
              otherwise: Yup.string(),
            });
          acc[`${field.fieldName}Frequency`] = Yup.string()
            .when('product', {
              is: 'Inventory funding',
              then: Yup.string().required(`Enter Frequency`),
              otherwise: Yup.string(),
            });
            acc[`${field.fieldName}Occurrence`] = Yup.string()
            .when(['product', `${field.fieldName}Frequency`], {
              is: (product, frequency) => product === 'Inventory funding' && frequency !== 'One time',
              then: Yup.string().required(`Enter Occurrence`),
              otherwise: Yup.string().nullable(),
            });
          acc[`${field.fieldName}Value`] = Yup.number()
            .typeError("Value must be a number")
            .when('product', {
              is: 'Inventory funding',
              then: Yup.number()
                .typeError("Value must be a number")
                .required(`Enter Value`)
                .min(0, `${field.fieldLabel} value must not be negative.`),
              otherwise: Yup.number(),
            });
        }
      }
      return acc;
    },

    {}
  );

  // validation
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      entityId: entity?.entityId || "",
      loanRequirement: entity?.loanRequirement || "",
      expectedClosureDate: entity?.expectedClosureDate,
      percentageCovered: entity?.percentageCovered || "",
      north: entity?.northSales || "",
      south: entity?.southSales || "",
      east: entity?.eastSales || "",
      west: entity?.westSales || "",
      creditPeriod: entity?.creditPeriod || "",
      fldg: entity?.fldg || "",
      monthlySales: entity?.monthlySales || "",
      monthlyPurchases: entity?.monthlyPurchases || "",
      rateOfInterest: entity?.rateOfInterest || "",
      tenure: entity?.tenure || "",
      loanType: entity?.loanType || "",
      isSecured: entity?.isSecured,
      // productType: entity?.productType || "",
      // product: entity?.product || "",
      facility: entity?.facility || "",
      primarySecurity: entity?.primarySecurity || "",
      typeOfCharge: entity?.typeOfCharge || "",
      vendorDiscount: entity?.vendorDiscount || "",
      extendDpoDays: entity?.extendDpoDays || "",
      vendorPay: entity?.vendorPay || "",
      isFldg: entity?.isFldg,
      isCreditPeriod: entity?.isCreditPeriod,
      businessRequirement: entity?.businessRequirement || "",
      isCashDiscount: entity?.isCashDiscount,
      isDealerArrangement: entity?.isDealerArrangement,
      isVendorArrangement: entity?.isVendorArrangement,
      isGuaranteeLender: entity?.isGuaranteeLender,
      vendorsArrangement: entity?.vendorsArrangement || "",
      guaranteeTypesLender: entity?.guaranteeTypesLender || "",
      dealerArrangement: entity?.dealerArrangement || "",
      endUse: entity?.endUse || "",
      guarantee: entity?.guarantee || "",
      cmaDoc: entity?.cmaDoc || "",
      securityCover: entity?.securityCover || "",
      financier: entity?.financier || [],
      propertyInfo: entity?.propertyInfo || rows,
      bankName: entity?.bankName || "",
      bankStatement: entity?.bankStatement || "",
      isPasswordBankStatement: entity?.isPasswordBankStatement,
      bankStatementPassword: entity?.bankStatementPassword || '',
      isOtherIncomeSource: entity?.isOtherIncomeSource,
      otherIncomeAmount: entity?.otherIncomeAmount || '',
      isCoBorrower: entity?.isCoBorrower,
      coBorrowerIncomeType: entity?.coBorrowerIncomeType || "",
      coBorrowerName: entity?.coBorrowerName || "",
      coBorrowerDob: formatDateString(entity?.coBorrowerDob) || "",
      coBorrowerRelation: entity?.coBorrowerRelation || "",
      coBorrowerPanNumber: entity?.coBorrowerPanNumber || "",
      coBorrowerPan: entity?.coBorrowerPan || "",
      coBorrowerItr: entity?.coBorrowerItr || "",
      equipmentCategory: entity?.equipmentCategory || "",
      equipmentSubCategory: entity?.equipmentSubCategory || "",
      equipmentType: entity?.equipmentType || "",
      // subProduct: entity?.subProduct || "",
      dealType: entity?.dealType || "",
      dealStatus: statusMapping[entity?.dealStatus] || "",
      anchorId: entity?.anchorId || "",
      dealNotes: entity?.dealNotes || "",
      productInfoList: entity?.dealProductCommercials || productInfo,

      percentageOfEquityDiluted: entity?.percentageOfEquityDiluted || "",
      isValuationDone: entity?.isValuationDone !== null ? entity?.isValuationDone : "",
      investorsType: entity?.investorsType || "",
      equityType: entity?.equityType || "",
      purposeOfRaisingEquity: entity?.purposeOfRaisingEquity || "",
      freshOrDiluted: entity?.freshOrDiluted || "",
      dilutedEquityHolder: entity?.dilutedEquityHolder || "",

      capexEquipmentImported: entity?.capexEquipmentImported || "",
      bankAvalizingBill: entity?.bankAvalizingBill || "",

      debenturesSecuredOrUnsecured: entity?.debenturesSecuredOrUnsecured || "",
      debenturesRatedOrUnrated: entity?.debenturesRatedOrUnrated || "",
      purposeOfIssuingDebentures: entity?.purposeOfIssuingDebentures || "",

      purposeOfIssuingCommercial: entity?.purposeOfIssuingCommercial || "",
      commercialRatedOrUnrated: entity?.commercialRatedOrUnrated || "",
      coupon: entity?.coupon || "",

      poolPSLorNonPSL: entity?.poolPSLorNonPSL || "",
      poolRatedOrUnrated: entity?.poolRatedOrUnrated || "",
      desiredCoupon: entity?.desiredCoupon || "",
      poolAgeing: entity?.poolAgeing || "",
      shareholdingAsOf: "",
      prospectiveProduct: entity?.prospectiveProduct || "",
      proposalType: entity?.proposalType || "",
      partnerProgram: entity?.partnerProgram || "",
      preferredFinancier:entity?.preferredFinancier || [],
      shareholderList: [
        {
          shareholderName: "",
          shareholderType: "",
          percentageHolding: "",
        },
      ],
    },

    validationSchema: Yup.object({
      entityId: isAdmin
        ? Yup.number().required('Please Select Entity')
        : Yup.number(),
      loanRequirement: Yup.number().typeError("Loan Requirement Amount must be a number")
        // .required("Loan Requirement is required")
        .min(0, "Loan Requirement cannot be negative")
        .max(99999999999999, "Loan Requirement cannot more than 14 digits"),
      expectedClosureDate: isAdmin ? Yup.string().required("Please Select Closure Date").nullable() : Yup.string().nullable(),
      rateOfInterest: productSettingObj.interest_rate
        ? Yup.number().typeError("Rate Of Interest must be a number")
          // .required("Rate Of Interest is required")
          .min(0, "Rate Of Interest cannot be negative")
          .max(100, "Rate Of Interest cannot be more than 100")
        : Yup.number(),
      tenure: productSettingObj.loan_tenure
        ? Yup.string()
        : Yup.string(),
      loanType: productSettingObj.loan_type
        ? Yup.string()
        : Yup.string(),
      // isSecured: isSelectedIDCF
      //   ? Yup.boolean().required('Please Select Loan Type')
      //   : Yup.boolean(),
      // productType: Yup.string().required('Please Select Product Type'),
      primarySecurity: productSettingObj.primary_security
        ? Yup.string()
        : Yup.string(),
      typeOfCharge: productSettingObj.charge_type
        ? Yup.string()
        : Yup.string(),
      // product: Yup.string().required('Please Select Product'),
      facility: isOpen
        ? Yup.string()
        : Yup.string(),
      securityCover: selectedIsSecured == "Yes" && productSettingObj.security_cover
        ? Yup.string()
        : Yup.string(),
      creditPeriod: selectedOption == "Yes" && productSettingObj.dealer_credit_period
        ? Yup.number().typeError("Credit Period must be a number")
          // .required("Please Enter Credit Period")
          .min(0, "Credit Period cannot be negative")
        : Yup.number(),
      percentageCovered: dealerfinancingArrangement == "Yes" && productSettingObj.existing_dealer_financing
        ? Yup.number().typeError("Percentage Covered must be a number")
          // .required("Please Enter Percentage Covered")
          .min(0, "Percentage Covered cannot be negative")
          .max(100, "Percentage Covered cannot be more than 100")
        : Yup.number(),
      north: productSettingObj.geographical_sales_distribution
        ? Yup.number().typeError("North Sales must be a number")
          // .required("Please Enter North Percentage")
          .min(0, "percentage cannot be negative")
          .max(100, "Percentage cannot be more than 100")
        : Yup.number(),
      south: productSettingObj.geographical_sales_distribution
        ? Yup.number().typeError("South Sales must be a number")
          // .required("Please Enter South Percentage")
          .min(0, "percentage cannot be negative")
          .max(100, "Percentage cannot be more than 100")
        : Yup.number(),
      east: productSettingObj.geographical_sales_distribution
        ? Yup.number().typeError("East sales must be a number")
          // .required("Please Enter east percentage")
          .min(0, "percentage cannot be negative")
          .max(100, "Percentage cannot be more than 100")
        : Yup.number(),
      west: productSettingObj.geographical_sales_distribution
        ? Yup.number().typeError("West Sales must be a number")
          // .required("Please Enter West Percentage")
          .min(0, "Percentage cannot be negative")
          .max(100, "Percentage cannot be more than 100")
        : Yup.number(),
      fldg: selectedFldg == "Yes" && productSettingObj.default_guarantee_offer_fldg
        ? Yup.number().typeError("FLDG must be a number")
          // .required("Please Enter FLDG")
          .min(0, "Percentage cannot be negative")
          .max(100, "Percentage cannot be more than 100")
        : Yup.number(),
      monthlySales: productSettingObj.monthly_sales
        ? Yup.number().typeError("Monthly Sales Amount must be a number")
          // .required("Please Enter Monthly Sales")
          .min(0, "Monthly Sales cannot be negative")
        : Yup.number(),
      // isFldg: isChannelFin
      //   ? Yup.boolean().required('')
      //   : Yup.boolean(),
      // isCreditPeriod: isChannelFin
      //   ? Yup.boolean().required('')
      //   : Yup.boolean(),
      businessRequirement: productSettingObj.business_requirement || productSettingObj.business_requirement2
        ? Yup.string()
        : Yup.string(),
      // isCashDiscount: isChannelFin
      //   ? Yup.boolean().required('')
      //   : Yup.boolean(),
      // isDealerArrangement: isChannelFin
      //   ? Yup.boolean().required('')
      //   : Yup.boolean(),
      vendorPay: productSettingObj.vendor_payment_schedule
        ? Yup.string()
        : Yup.string(),
      vendorDiscount: isSelectedDpo && productSettingObj.business_requirement
        ? Yup.number().typeError("Vendor Discount must be a number")
          // .required("Please Enter Discount you get from Vendors")
          .min(0, "Vendor Discount cannot be negative")
          .max(100, "Vendor Discount cannot be more than 100")
        : Yup.number(),
      extendDpoDays: isSelectedDpo && productSettingObj.business_requirement
        ? Yup.number().typeError("DPO days must be a number")
          // .required("Please Enter how many days would you want to extend DPO?")
          .min(0, "DPO days cannot be negative")
        : Yup.number(),
      // isVendorArrangement: isInvoiceDisc
      //   ? Yup.boolean().required('')
      //   : Yup.boolean(),
      // isGuaranteeLender: isInvoiceDisc
      //   ? Yup.boolean().required('')
      //   : Yup.boolean(),
      monthlyPurchases: productSettingObj.monthly_purchases_value
        ? Yup.number().typeError("Monthly Purchases Amount must be a number")
          // .required("Please Enter Monthly Purchases")
          .min(0, "Monthly Purchases cannot be negative")
        : Yup.number(),
      vendorsArrangement: vendorfinancingArrangement == "Yes" && productSettingObj.existing_vendor_financing
        ? Yup.string()
        : Yup.string(),
      guaranteeTypesLender: selectedGuarantee == "Yes" && productSettingObj.guarantee_offer_to_lender
        ? Yup.string()
        : Yup.string(),
      dealerArrangement: dealerfinancingArrangement == "Yes" && productSettingObj.existing_dealer_financing
        ? Yup.string()
        : Yup.string(),
      endUse: productSettingObj.end_use
        ? Yup.string()
        : Yup.string(),
      guarantee: productSettingObj.guarantee
        ? Yup.string()
        : Yup.string(),
      cmaDoc: productSettingObj.cma_documents
        ? Yup.string()
        : Yup.string(),
      // financier: isAdmin ? Yup.array().min(1, "Please Select at least one Financier").required("Please Select Finacier"): Yup.string(),
      preferredFinancier:Yup.array(),
      total: Yup.number()
        .test("totalPercentage", "The Total Percentage should be 100", function (value) {
          if (productSettingObj.geographical_sales_distribution) {
            const { north, south, east, west } = this.parent;
            const values = [north, south, east, west].filter(val => val !== undefined && val !== null);
            if (values.length > 0) {
              const total = values.reduce((acc, curr) => acc + curr, 0);
              return total === 100;
            }
          }
          return true;
        }),
      propertyInfo: productSettingObj.property_list ? Yup.array().of(
        Yup.object({
          propertyNature: Yup.string(),
          propertyAge: Yup.number().typeError("Property Age Amount must be a number").min(0, "Property Age cannot be negative"),
          city: Yup.string(),
          propertyOwner: Yup.string(),
          propertyStatus: Yup.string(),
          propertyValue: Yup.number().typeError("Property Value Amount must be a number").test("propertyValue", "Value of Property Should Be Greater Than Loan Amount", function (value) {
            if (isLoanAgainstProperty) {
              const { propertyValue } = this.parent;
              return validation.values.loanRequirement < propertyValue;
            }
            return true;
          }),
          address: Yup.string(),
          pincode: Yup.number()
            // .required("Please Enter Pincode")
            .typeError("Pincode Must be a Number")
            .positive("Pincode must be a positive number")
            .integer("Pincode must be an integer")
            .test(
              "len",
              "Pincode must be exactly 6 digits",
              (val) => !val || val.toString().length === 6
            ),
          state: Yup.string(),
          parentDeed: Yup.string(),
          saleDeed: Yup.string(),
          utilityBills: Yup.string(),
          propertyTax: Yup.string(),
        })
      ) : Yup.array(),
      bankName: productSettingObj.bank_name
        ? Yup.string()
        : Yup.string(),
      bankStatement: productSettingObj.bank_statement
        ? Yup.string()
        : Yup.string(),
      // isPasswordBankStatement: isLoanAgainstProperty
      //   ? Yup.boolean().required('')
      //   : Yup.boolean(),
      bankStatementPassword: isPasswordBankStatement == "Yes" && productSettingObj.statement_password
        ? Yup.string()
        : Yup.string(),
      // isOtherIncomeSource: isLoanAgainstProperty
      //   ? Yup.boolean().required('')
      //   : Yup.boolean(),
      otherIncomeAmount: isOtherIncomeSource == "Yes" && productSettingObj.other_income_source
        ? Yup.number()
          .typeError("Income Amount Must Be Number")
          .min(0, "Income Cannot Be Negative")
        : Yup.number(),
      // isCoBorrower: isLoanAgainstProperty
      //   ? Yup.boolean().required('')
      //   : Yup.boolean(),
      coBorrowerIncomeType: isCoBorrower == "Yes" && productSettingObj.co_borrower
        ? Yup.string()
        : Yup.string(),
      coBorrowerName: isCoBorrower == "Yes" && productSettingObj.co_borrower
        ? Yup.string()
        : Yup.string(),
      coBorrowerDob: isCoBorrower == "Yes" && productSettingObj.co_borrower
        ? Yup.string()
        : Yup.string(),
      coBorrowerPanNumber: isCoBorrower == "Yes" && productSettingObj.co_borrower
        ? Yup.string()
          .matches(API_SERVICES.PAN_PATTERN, "Enter a valid PAN number")
        : Yup.string(),
      coBorrowerItr: isCoBorrower == "Yes" && productSettingObj.co_borrower
        ? Yup.string()
        : Yup.string(),
      coBorrowerPan: isCoBorrower == "Yes" && productSettingObj.co_borrower
        ? Yup.string()
        : Yup.string(),
      coBorrowerRelation: isCoBorrower == "Yes" && productSettingObj.co_borrower
        ? Yup.string()
        : Yup.string(),
      equipmentCategory: productSettingObj.equipment_category
        ? Yup.string()
        : Yup.string(),
      equipmentSubCategory: productSettingObj.equipment_sub_category
        ? Yup.string()
        : Yup.string(),
      equipmentType: productSettingObj.equipment_type
        ? Yup.string()
        : Yup.string(),
      // subProduct: isShowSubProduct
      //   ? Yup.string().required('Please Select Sub Product')
      //   : Yup.string(),
      dealType: Yup.string(),
      dealStatus: isAdmin
      ? Yup.string()
      : Yup.string(),
      dealNotes: Yup.string(),
      productInfoList: Yup.array().of(
        Yup.object({
          product: Yup.string().required("Please Select product"),
          productType: Yup.string().required("Please Select Product Type"),
          subProduct: Yup.array()
            .when('product', {
              is: (product) =>
                product === 'Payable Financing' ||
                product === 'Receivable Financing' || product === 'CC/OD' || product == 'Inventory funding'
                || product === 'Debetures',
              then: Yup.array()
                .min(1, "Please Select at least one Sub Product")
                .required("Please Select Sub Product"),
              otherwise: Yup.array().nullable(),
            }),
          ...commercialValidationSchema
        }),
      ),

      percentageOfEquityDiluted: productSettingObj.percentageOfEquityDiluted
        ? Yup.number()
          .typeError("Percentage equity diluted must be a number")
          // .required("Percentage equity diluted is required")
          .min(0, "Percentage equity diluted cannot be negative")
          .max(100, "Percentage equity diluted cannot be more than 100")
        : Yup.number(),
      isValuationDone: productSettingObj.isValuationDone
        ? Yup.boolean()
        : Yup.string(),
      investorsType: productSettingObj.investorsType
        ? Yup.string()
        : Yup.string(),
      equityType: productSettingObj.equityType
        ? Yup.string()
        : Yup.string(),
      purposeOfRaisingEquity: productSettingObj.purposeOfRaisingEquity
        ? Yup.string()
        : Yup.string(),
      freshOrDiluted: productSettingObj.freshOrDiluted
        ? Yup.string()
        : Yup.string(),
      dilutedEquityHolder: productSettingObj.dilutedEquityHolder
        ? Yup.string()
        : Yup.string(),

      capexEquipmentImported: productSettingObj.capexEquipmentImported
        ? Yup.string()
        : Yup.string(),
      bankAvalizingBill: productSettingObj.bankAvalizingBill
        ? Yup.string()
        : Yup.string(),

      debenturesSecuredOrUnsecured: productSettingObj.debenturesSecuredOrUnsecured
        ? Yup.string()
        : Yup.string(),
      debenturesRatedOrUnrated: productSettingObj.debenturesRatedOrUnrated
        ? Yup.string()
        : Yup.string(),
      purposeOfIssuingDebentures: productSettingObj.purposeOfIssuingDebentures
        ? Yup.string()
        : Yup.string(),

      purposeOfIssuingCommercial: productSettingObj.purposeOfIssuingCommercial
        ? Yup.string()
        : Yup.string(),
      commercialRatedOrUnrated: productSettingObj.commercialRatedOrUnrated
        ? Yup.string()
        : Yup.string(),
      coupon: productSettingObj.coupon
        ? Yup.string()
        : Yup.string(),

      poolPSLorNonPSL: productSettingObj.poolPSLorNonPSL
        ? Yup.string()
        : Yup.string(),
      poolRatedOrUnrated: productSettingObj.poolRatedOrUnrated
        ? Yup.string()
        : Yup.string(),
      desiredCoupon: productSettingObj.desiredCoupon
        ? Yup.string()
        : Yup.string(),
      poolAgeing: productSettingObj.poolAgeing
        ? Yup.string()
        : Yup.string(),
      shareholdingAsOf: productSettingObj.shareHoldingPattern
        ? Yup.date()
        : Yup.date(),
      shareholderList: productSettingObj.shareHoldingPattern
        ? Yup.array().of(
          Yup.object({
            shareholderType: Yup.string(),
            percentageHolding: Yup.number()
              // .required("Percentage Holding is required")
              .min(0, "Percentage Holding cannot be less than 0"),
          })
        )
        : Yup.array(),
      prospectiveProduct: isAdmin ? Yup.string().required("Please Select Prospective Product")
        : Yup.string(),
        proposalType: isAdmin ?Yup.string().required("Please select a proposal type"): Yup.string(),
      partnerProgram:Yup.string(),
    }),
    onSubmit: values => {
      values.productInfoList.forEach((product, productIndex) => {
        const commercialEntry = {};
        commercialFieldsData.forEach((field) => {
          const typeField = `${field.fieldName}Type`;
          const valueField = `${field.fieldName}Value`;
          const timeField = `${field.fieldName}Frequency`;
          const cycleField = `${field.fieldName}Occurrence`;
          const benchmarkRate = `${field.fieldName}BenchmarkRate`;
          const markupOverBenchmark = `${field.fieldName}MarkupOverBenchmark`;
          const benchmark = `${field.fieldName}Benchmark`;
          const NVG = `${field.fieldName}NVG`;

          commercialEntry[`${field.fieldName}`] = {
            Type: product[typeField],
            Value: product[valueField],
            Frequency: product[timeField],
            Occurrence: product[cycleField],
            Benchmark: product[benchmark],
            BenchmarkRate: product[benchmarkRate],
            MarkupOverBenchmark: product[markupOverBenchmark],
            NVG: product[NVG]
          };
        });
        product.commercials = [commercialEntry];
      });

      const entity = {
        id: decodedId,
        entityId: values.entityId,
        loanRequirement: values.loanRequirement,
        expectedClosureDate: values.expectedClosureDate,
        productType: values.productType,
        product: values.product,
        dealType: values.dealType,
        dealStatus: values.dealStatus,
        dealNotes: values.dealNotes,
        productList: values.productInfoList,
        prospectiveProduct: values.prospectiveProduct || "",
        proposalType: values.proposalType || "",
        partnerProgram:values.partnerProgram||"",
        preferredFinancier: values.preferredFinancier || [],
      }
      if (entity.dealType == "Counterparty") {
        entity.anchorId = values.anchorId
        entity.counterpartyId = values.entityId
      }

      if (values.subProduct) {
        entity.subProduct = values.subProduct
      }
      if (selectedFinType == "AllExcept") {
        let allFinancierArray = [...privateSectorBankList, ...publicSectorBankList, ...NBFCList];
        let selectedValue = [...selectedMulti6, ...selectedMulti7, ...selectedMulti8]
        const firstArrayValues = selectedValue?.map((item) => item.value);
        const exceptFinancierArray = allFinancierArray
          .filter((item) => !firstArrayValues.includes(item.value))
          .map((item) => item.value);
        entity.financier = exceptFinancierArray;
      } else {
        entity.financier = [...publicFinancier, ...privateFinancier, ...nbfcFinancier];
      }
      if (selectedPrefFinType == "AllExcept") {
        let allPreferredFinancierArray = [...privateSectorBankList, ...publicSectorBankList, ...NBFCList];
        let selectedPrefValue = [
        ...selectedPrefFinancierMulti6,
        ...selectedPrefFinancierMulti7,
        ...selectedPrefFinancierMulti8,]
        const firstPrefArrayValues = selectedPrefValue?.map((item) => item.value);
        const exceptPreferredFinancierArray = allPreferredFinancierArray
          .filter((item) => !firstPrefArrayValues.includes(item.value))
          .map((item) => item.value);
        entity.preferredFinancier = exceptPreferredFinancierArray;
      } else {
        entity.preferredFinancier = [
          ...preferredPublicFinancier,
          ...preferredPrivateFinancier,
          ...preferredNbfcFinancier,];
      }
      if (values.facility) {
        entity.facility = values.facility
      }

      if (isApprovePermission) {
        entity.status = 'Submit'
      } else if (user.roleName == 'partner') {
        entity.status = "partner"
      } else {
        entity.status = 'create'
      }

      entity.tenure = productSettingObj.loan_tenure ? String(values.tenure) : null;
      entity.loanType = productSettingObj.loan_type ? values.loanType : null;
      entity.rateOfInterest = productSettingObj.interest_rate ? values.rateOfInterest : null;
      entity.primarySecurity = productSettingObj.primary_security ? values.primarySecurity : null;
      entity.typeOfCharge = productSettingObj.charge_type ? values.typeOfCharge : null;
      entity.cmaDoc = productSettingObj.cma_documents ? values.cmaDoc : null;
      entity.businessRequirement = (productSettingObj.business_requirement || productSettingObj.business_requirement2) ? selectedBusinessRequirement : null;
      entity.northSales = productSettingObj.geographical_sales_distribution ? values.north : null;
      entity.southSales = productSettingObj.geographical_sales_distribution ? values.south : null;
      entity.eastSales = productSettingObj.geographical_sales_distribution ? values.east : null;
      entity.westSales = productSettingObj.geographical_sales_distribution ? values.west : null;
      entity.monthlySales = productSettingObj.monthly_sales ? values.monthlySales : null;
      entity.vendorPay = productSettingObj.vendor_payment_schedule ? vendorPays : null;
      entity.businessRequirement = (productSettingObj.business_requirement || productSettingObj.business_requirement2) ? selectedBusinessRequirement : null;
      entity.monthlyPurchases = productSettingObj.monthly_purchases_value ? values.monthlyPurchases : null;

      if (valuationDone == "Yes" && productSettingObj.isValuationDone) {
        entity.isValuationDone = true;
      } else if (productSettingObj.isValuationDone && valuationDone == "No") {
        entity.isValuationDone = false;
      }

      if (productSettingObj.shareHoldingPattern) {
        let totalShareholding = 0;
        values.shareholderList.forEach((elem) => {
          totalShareholding += +elem.percentageHolding;
          totalShareholding = Math.round(totalShareholding * 100) / 100;
        });
        if (totalShareholding > 100) {
          setToastInfo({
            message: "%Holding Shouldn't be greater than 100",
            showToast: true,
            role: "error",
          });
          return;
        }
        if (totalShareholding < 100) {
          setToastInfo({
            message: "%Holding Shouldn't be less than 100",
            showToast: true,
            role: "error",
          });
          return;
        }
        handleSubmitForShareHolding(values,totalShareholding)
      }

      entity.percentageOfEquityDiluted = productSettingObj.percentageOfEquityDiluted ? values.percentageOfEquityDiluted : '';
      entity.investorsType = productSettingObj.investorsType ? values.investorsType : '';
      entity.equityType = productSettingObj.equityType ? values.equityType : '';
      entity.purposeOfRaisingEquity = productSettingObj.purposeOfRaisingEquity ? values.purposeOfRaisingEquity : '';
      entity.freshOrDiluted = productSettingObj.freshOrDiluted ? values.freshOrDiluted : '';
      entity.dilutedEquityHolder = productSettingObj.dilutedEquityHolder ? values.dilutedEquityHolder : '';
      entity.capexEquipmentImported = productSettingObj.capexEquipmentImported ? values.capexEquipmentImported : '';
      entity.bankAvalizingBill = productSettingObj.bankAvalizingBill ? values.bankAvalizingBill : '';
      entity.debenturesSecuredOrUnsecured = productSettingObj.debenturesSecuredOrUnsecured ? values.debenturesSecuredOrUnsecured : '';
      entity.debenturesRatedOrUnrated = productSettingObj.debenturesRatedOrUnrated ? values.debenturesRatedOrUnrated : '';
      entity.purposeOfIssuingDebentures = productSettingObj.purposeOfIssuingDebentures ? values.purposeOfIssuingDebentures : '';
      entity.purposeOfIssuingCommercial = productSettingObj.purposeOfIssuingCommercial ? values.purposeOfIssuingCommercial : '';
      entity.commercialRatedOrUnrated = productSettingObj.commercialRatedOrUnrated ? values.commercialRatedOrUnrated : '';
      entity.coupon = productSettingObj.coupon ? values.coupon : '';
      entity.poolPSLorNonPSL = productSettingObj.poolPSLorNonPSL ? values.poolPSLorNonPSL : '';
      entity.poolRatedOrUnrated = productSettingObj.poolRatedOrUnrated ? values.poolRatedOrUnrated : '';
      entity.desiredCoupon = productSettingObj.desiredCoupon ? values.desiredCoupon : '';
      entity.poolAgeing = productSettingObj.poolAgeing ? values.poolAgeing : '';

      if (selectedIsSecured == "Yes" && productSettingObj.is_loan_secured) {
        entity.isSecured = true;
      } else if (productSettingObj.is_loan_secured && selectedIsSecured == "No") {
        entity.isSecured = false;
      }

      if (productSettingObj.end_use) {
        const newData = [];
        selectedMulti2.forEach((ele) => {
          newData.push(ele.value);
        });
        entity.endUse = newData.join(",");
      }

      if (productSettingObj.guarantee) {
        const newData2 = [];
        selectedMulti1.forEach((ele) => {
          newData2.push(ele.value);
        });
        entity.guarantee = newData2.join(",");
      }

      if (cashDiscount == "No" && productSettingObj.dealer_cash_discounts) {
        entity.isCashDiscount = false;
      } else if (productSettingObj.dealer_cash_discounts) {
        entity.isCashDiscount = true;
      }

      if (selectedFldg == "Yes" && productSettingObj.default_guarantee_offer_fldg) {
        entity.fldg = values.fldg;
        entity.isFldg = true;
      } else if (productSettingObj.default_guarantee_offer_fldg && selectedFldg == 'No') {
        entity.isFldg = false;
      }

      if (selectedOption == "No" && productSettingObj.dealer_credit_period) {
        entity.isCreditPeriod = false;
        entity.creditPeriod = 0;
      } else if (productSettingObj.dealer_credit_period) {
        entity.isCreditPeriod = true;
        entity.creditPeriod = values.creditPeriod;
      }

      if (dealerfinancingArrangement == "No" && productSettingObj.existing_dealer_financing) {
        entity.isDealerArrangement = false;
      } else if (productSettingObj.existing_dealer_financing) {
        entity.isDealerArrangement = true;
        const newData = [];
        selectedMulti3.forEach((ele) => {
          newData.push(ele.value);
        });
        entity.dealerArrangement = newData.join(",");
        entity.percentageCovered = values.percentageCovered;
      }

      if (vendorfinancingArrangement == "No" && productSettingObj.existing_vendor_financing) {
        entity.isVendorArrangement = false;
      } else if (productSettingObj.existing_vendor_financing) {
        entity.isVendorArrangement = true;
        const newData = [];
        selectedMulti4.forEach((ele) => {
          newData.push(ele.value);
        });
        entity.vendorsArrangement = newData.join(",");
      }

      if (selectedGuarantee == "No" && productSettingObj.guarantee_offer_to_lender) {
        entity.isGuaranteeLender = false;
      } else if (productSettingObj.guarantee_offer_to_lender) {
        entity.isGuaranteeLender = true;
        const newData = [];
        selectedMulti5.forEach((ele) => {
          newData.push(ele.value);
        });
        entity.guaranteeTypesLender = newData.join(",");
      }

      if (isSelectedDpo && productSettingObj.business_requirement) {
        entity.vendorDiscount = values.vendorDiscount;
        entity.extendDpoDays = values.extendDpoDays;
      }

      if (productSettingObj.guarantee) {
        const newData2 = [];
        selectedMulti1.forEach((ele) => {
          newData2.push(ele.value);
        });
        entity.guarantee = newData2.join(",");
      }

      if (productSettingObj.property_list) {
        entity.propertyInfo = values.propertyInfo;
        entity.bankName = values.bankName;
        entity.bankStatement = values.bankStatement;
        entity.isPasswordBankStatement = values.isPasswordBankStatement;
        entity.isCoBorrower = values.isCoBorrower;
        entity.isSecured = false;
      }

      if (productSettingObj.co_borrower) {
        entity.coBorrowerIncomeType = values.coBorrowerIncomeType;
        entity.coBorrowerName = values.coBorrowerName;
        entity.coBorrowerDob = values.coBorrowerDob;
        entity.coBorrowerRelation = values.coBorrowerRelation;
        entity.coBorrowerPanNumber = values.coBorrowerPanNumber;
        entity.coBorrowerPan = values.coBorrowerPan;
        entity.coBorrowerItr = values.coBorrowerItr;
      }

      if (productSettingObj.statement_password) {
        entity.bankStatementPassword = values.bankStatementPassword;
      }

      if (productSettingObj.other_income_source) {
        entity.isOtherIncomeSource = values.isOtherIncomeSource;
        entity.otherIncomeAmount = +values.otherIncomeAmount || '';
      }

      if (productSettingObj.equipment_category) {
        entity.equipmentCategory = values.equipmentCategory;
        entity.equipmentSubCategory = values.equipmentSubCategory;
        entity.equipmentType = values.equipmentType;
        entity.isSecured = true;
      }

      Object.keys(entity).forEach(key => {
        if (entity[key] === null || entity[key] === "") {
          delete entity[key];
        }
      });

      confirmAlert({
        title: 'Confirm',
        message: 'Please note that once you submit this deal, it cannot be edited. Are you sure you want to proceed with the submission?',
        buttons: [
          {
            label: 'Yes',
            onClick: () => {
              setLoader(true);
              editDeal(entity)
                .then((response) => {
                  if (response.code == "201") {
                    setLoader(false);
                    if (isfullAccess) {
                      const encryptedId = btoa(entity.id.toString());
                      // navigate(`/${user.roleName}/emandate?id=${encodeURIComponent(encryptedId)}`);
                      navigate(`/${user.roleName}/listDeal`);
                    } else {
                      window.history.back();
                    }
                  }
                })
                .catch((error) => {
                  setLoader(false);
                }).finally(f => {
                  setLoader(false);
                });
              validation.resetForm()
            },
          },
          {
            label: 'No',
            onClick: () => {
              setLoader(false);
              // validation.resetForm()
            },
          },
        ],
      });
    },
  })

  const validation3 = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: "",
      assignedTo: "",
      assignedToFirm: "",
      assignedToProgramRm : ","
    },
    validationSchema: Yup.object({
      id: Yup.number().required(""),
      assignedTo: Yup.string().required("Please Select User to Assign Deal")
    }),
    onSubmit: values => {
      callAssignDealFinancier({ id: values.id, assignedTo: values.assignedTo, assignedToFirm: values.assignedToFirm, assignedToProgramRm: values.assignedToProgramRm })
        .then((response) => {
          if (response.status) {
            setToastInfo({
              message: 'Deal Assigned Succesfully',
              showToast: true,
              role: "success",
            });
            getDealInfo({ id: decodedId })
              .then((response) => {
                if (response.status) {
                  setEntity(response.data)
                  setDealType(response?.data?.dealType)
                }
              }).catch((error) => {

              });
            setAssignmodal(false);
          } else {
            setToastInfo({
              message: response.message,
              showToast: true,
              role: "error",
            });
          }
        }).catch((error) => {
        });
    }
  })

  const handleDelete = (rowIndex) => {
    validation.values.propertyInfo.splice(rowIndex, 1);
    validation.validateForm();
  };

  const createOnDropHandler = async (acceptedFiles, cb) => {
    const selectedFile = acceptedFiles[0];
    if (selectedFile) {
      cb({ percentage: 0 })
      let formData = new FormData();
      formData.append("upl", selectedFile);
      const config = {
        onUploadProgress: progressEvent => {
          const percentage = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          cb({ percentage })
        },
      };
      try {
        const response = await axios.post(
          `${API_URL}/s3/uploadSystemConfigFiles`,
          formData,
          config
        );
        if (response.status === 200) {
          cb({ file: response.data[0].fileName })
        } else {
          cb({ error: response.data.message })
        }
      } catch (error) {
        cb({ error: error.response.data.message })
      }
    }
  };

  const onDropForInput1 = useCallback(async (docType, acceptedFiles) => {
    await createOnDropHandler(acceptedFiles, (result) => {
      setUploadProgressBankStat(result.percentage);
      setErrorMessageBankStat(result.error)
      validation.setFieldValue(docType, result.file);
    });
  });

  const onDropForInput2 = useCallback(async (docType, acceptedFiles) => {
    await createOnDropHandler(acceptedFiles, (result) => {
      setUploadProgressCma(result.percentage);
      setErrorMessageCma(result.error)
      validation.setFieldValue(docType, result.file);
    });
  });

  const onDropForInput3 = useCallback(async (docType, acceptedFiles) => {
    await createOnDropHandler(acceptedFiles, (result) => {
      setUploadProgressCoBoPan(result.percentage);
      setErrorMessageCoBoPan(result.error)
      validation.setFieldValue(docType, result.file);
    });
  });

  const onDropForInput4 = useCallback(async (docType, acceptedFiles) => {
    await createOnDropHandler(acceptedFiles, (result) => {
      setUploadProgressCoBoItr(result.percentage);
      setErrorMessageCoBoItr(result.error)
      validation.setFieldValue(docType, result.file);
    });
  });

  const handleMulti1 = (selectedOptions) => {
    const newData = []
    selectedOptions.forEach((ele) => {
      newData.push(ele.value)
    })
    validation.values.guarantee = newData.join(",")
    const isNoSelected = selectedOptions.some((option) => option.value == 'No Guarantee');

    if (isNoSelected) {
      setSelectedMulti1([{ label: 'No Guarantee', value: 'No Guarantee' }]);
      validation.values.guarantee = 'No Guarantee'
    } else {
      setSelectedMulti1(selectedOptions);
    }
  };

  const handleMulti2 = (selectedOptions) => {
    const newData = []
    selectedOptions.forEach((ele) => {
      newData.push(ele.value)
    })
    validation.values.endUse = newData.join(",")
    setSelectedMulti2(selectedOptions);
  };

  const handleMulti3 = (selectedOptions) => {
    const newData = []
    selectedOptions.forEach((ele) => {
      newData.push(ele.value)
    })
    validation.values.dealerArrangement = newData.join(",")
    setSelectedMulti3(selectedOptions);
  };

  const handleMulti4 = (selectedOptions) => {
    const newData = []
    selectedOptions.forEach((ele) => {
      newData.push(ele.value)
    })
    validation.values.vendorsArrangement = newData.join(",")
    setSelectedMulti4(selectedOptions);
  };

  const handleMulti5 = (selectedOptions) => {
    const newData = []
    selectedOptions.forEach((ele) => {
      newData.push(ele.value)
    })
    validation.values.guaranteeTypesLender = newData.join(",")
    setSelectedMulti5(selectedOptions);
  };

  const handleMulti6 = (selectedOptions) => {
    const newData = selectedOptions.map((ele) => ele.value);
    setPublicFinancier(newData);
    setSelectedMulti6(selectedOptions);
    setErrorSelectedFinancier('');
};

const handleMulti7 = (selectedOptions) => {
    const newData = selectedOptions.map((ele) => ele.value);
    setPrivateFinancier(newData);
    setSelectedMulti7(selectedOptions);
    setErrorSelectedFinancier('');
};

const handleMulti8 = (selectedOptions) => {
    const newData = selectedOptions.map((ele) => ele.value);
    setNbfcFinancier(newData);
    setSelectedMulti8(selectedOptions);
    setErrorSelectedFinancier('');
};


useEffect(() => {
    const aggregatedFinanciers = [
        ...selectedMulti6.map((ele) => ele.value),
        ...selectedMulti7.map((ele) => ele.value),
        ...selectedMulti8.map((ele) => ele.value),
    ];

    if (aggregatedFinanciers.length > 0) {
        validation.setFieldValue('financier', aggregatedFinanciers);
    } else {
        validation.setFieldValue('financier', []);
    }
    if (selectedMulti6.length === 0 && selectedMulti7.length === 0 && selectedMulti8.length === 0) {
        setErrorSelectedFinancier('At least one financier must be selected.');
    } else {
        setErrorSelectedFinancier('');
    }

}, [selectedMulti6, selectedMulti7, selectedMulti8]);


  const handlePrefMulti1 = (selectedOptions) => {
    const newData = [];
    selectedOptions.forEach((ele) => {
      newData.push(ele.value);
    });
    validation.values.guarantee = newData.join(",");
    const isNoSelected = selectedOptions.some(
      (option) => option.value == "No Guarantee"
    );

    if (isNoSelected) {
      setSelectedPrefFinancierMulti1([{ label: "No Guarantee", value: "No Guarantee" }]);
      validation.values.guarantee = "No Guarantee";
    } else {
      // Update selected options
      setSelectedPrefFinancierMulti1(selectedOptions);
    }
  };

  const handlePrefMulti2 = (selectedOptions) => {
    const newData = [];
    selectedOptions.forEach((ele) => {
      newData.push(ele.value);
    });
    validation.values.endUse = newData.join(",");
    setSelectedPrefFinancierMulti2(selectedOptions);
  };

  const handlePrefMulti3 = (selectedOptions) => {
    const newData = [];
    selectedOptions.forEach((ele) => {
      newData.push(ele.value);
    });
    validation.values.dealerArrangement = newData.join(",");
    setSelectedPrefFinancierMulti3(selectedOptions);
  };

  const handlePrefMulti4 = (selectedOptions) => {
    const newData = [];
    selectedOptions.forEach((ele) => {
      newData.push(ele.value);
    });
    validation.values.vendorsArrangement = newData.join(",");
    setSelectedPrefFinancierMulti4(selectedOptions);
  };

  const handlePrefMulti5 = (selectedOptions) => {
    const newData = [];
    selectedOptions.forEach((ele) => {
      newData.push(ele.value);
    });
    validation.values.guaranteeTypesLender = newData.join(",");
    setSelectedPrefFinancierMulti5(selectedOptions);
  };

  const handlePrefMulti6 = (selectedOptions) => {
    const newData = selectedOptions.map(ele => ele.value);
    setPreferredPublicFinancier(newData);
    validation.setFieldValue("preferredFinancier", newData); // Update validation state
    setSelectedPrefFinancierMulti6(selectedOptions);
};


const handlePrefMulti7 = (selectedOptions) => {
  const newData = selectedOptions.map(ele => ele.value);
  setPreferredPrivateFinancier(newData);
  validation.setFieldValue("preferredFinancier", newData); // Update validation state
  setSelectedPrefFinancierMulti7(selectedOptions);
};

const handlePrefMulti8 = (selectedOptions) => {
  const newData = selectedOptions.map(ele => ele.value);
  setPreferredNbfcFinancier(newData);
  validation.setFieldValue("preferredFinancier", newData); // Update validation state
  setSelectedPrefFinancierMulti8(selectedOptions);
};
  const handleCancel = () => {
    window.history.back();
  }

  const onHandleSaveAsDraft = (status) => {
    validation.values.productInfoList.forEach((product, productIndex) => {
      const commercialEntry = {};
      commercialFieldsData.forEach((field) => {
        const typeField = `${field.fieldName}Type`;
        const valueField = `${field.fieldName}Value`;
        const timeField = `${field.fieldName}Frequency`;
        const cycleField = `${field.fieldName}Occurrence`;
        const benchmarkRate = `${field.fieldName}BenchmarkRate`;
        const markupOverBenchmark = `${field.fieldName}MarkupOverBenchmark`;
        const benchmark = `${field.fieldName}Benchmark`;
        const NVG = `${field.fieldName}NVG`;

        commercialEntry[`${field.fieldName}`] = {
          Type: product[typeField],
          Value: product[valueField],
          Frequency: product[timeField],
          Occurrence: product[cycleField],
          Benchmark: product[benchmark],
          BenchmarkRate: product[benchmarkRate],
          MarkupOverBenchmark: product[markupOverBenchmark],
          NVG: product[NVG]
        };
      });
      product.commercials = [commercialEntry];
    });
    // validation.handleSubmit()
    if (validation.errors && Object.keys(validation.errors).length > 0) {
      validation.handleSubmit()
      return;
    }
    const entity = {
      id: decodedId,
      entityId: validation.values.entityId,
      productType: validation.values.productType,
      product: validation.values.product,
      dealType: validation.values.dealType,
      dealStatus: validation.values.dealStatus,
      productList: validation.values.productInfoList,
      prospectiveProduct: validation.values.prospectiveProduct || "",
      proposalType: validation.values.proposalType || "",
      partnerProgram:validation.values.partnerProgram||"",
      preferredFinancier: validation.values.preferredFinancier || [],
    }
    if (entity.dealType == "Counterparty") {
      entity.anchorId = validation.values.anchorId
      entity.counterpartyId = validation.values.entityId
    } else {
      entity.anchorId = validation.values.entityId
    }

    if (validation.values.subProduct) {
      entity.subProduct = validation.values.subProduct
    }

    if (validation.values.rateOfInterest) {
      entity.rateOfInterest = validation.values.rateOfInterest || null
    }

    if (validation.values.loanRequirement) {
      entity.loanRequirement = validation.values.loanRequirement || null
    }
    
    if (validation.values.expectedClosureDate) {
      entity.expectedClosureDate = validation.values.expectedClosureDate || null
    }
    
    entity.status = status

    if (selectedFinType == "AllExcept") {
      let allFinancierArray = [...privateSectorBankList, ...publicSectorBankList, ...NBFCList];
      let selectedValue = [...selectedMulti6, ...selectedMulti7, ...selectedMulti8]
      const firstArrayValues = selectedValue?.map((item) => item.value);
      const exceptFinancierArray = allFinancierArray
        .filter((item) => !firstArrayValues.includes(item.value))
        .map((item) => item.value);
      entity.financier = exceptFinancierArray;
    } else {
      entity.financier = [...publicFinancier, ...privateFinancier, ...nbfcFinancier]
    }
    if (selectedPrefFinType == "AllExcept") {
      let allPreferredFinancierArray = [...privateSectorBankList, ...publicSectorBankList, ...NBFCList];
      let selectedPrefValue = [
        ...selectedPrefFinancierMulti6,
        ...selectedPrefFinancierMulti7,
        ...selectedPrefFinancierMulti8,]
      const firstPrefArrayValues = selectedPrefValue?.map((item) => item.value);
      const exceptPreferredFinancierArray = allPreferredFinancierArray
        .filter((item) => !firstPrefArrayValues.includes(item.value))
        .map((item) => item.value);
      entity.preferredFinancier = exceptPreferredFinancierArray;
    } else {
      entity.preferredFinancier = [
        ...preferredPublicFinancier,
        ...preferredPrivateFinancier,
        ...preferredNbfcFinancier,]
    }

    if (selectedIsSecured == "Yes") {
      entity.securityCover = validation.values.securityCover;
    }

    if (validation.values.facility) {
      entity.facility = validation.values.facility || null
    }

    entity.tenure = productSettingObj.loan_tenure ? String(validation.values.tenure) : null;
    entity.loanType = productSettingObj.loan_type ? validation.values.loanType : null;
    entity.rateOfInterest = productSettingObj.interest_rate ? validation.values.rateOfInterest : null;
    entity.primarySecurity = productSettingObj.primary_security ? validation.values.primarySecurity : null;
    entity.typeOfCharge = productSettingObj.charge_type ? validation.values.typeOfCharge : null;
    entity.cmaDoc = productSettingObj.cma_documents ? validation.values.cmaDoc : null;
    entity.businessRequirement = (productSettingObj.business_requirement || productSettingObj.business_requirement2) ? selectedBusinessRequirement : null;
    entity.northSales = productSettingObj.geographical_sales_distribution ? validation.values.north : null;
    entity.southSales = productSettingObj.geographical_sales_distribution ? validation.values.south : null;
    entity.eastSales = productSettingObj.geographical_sales_distribution ? validation.values.east : null;
    entity.westSales = productSettingObj.geographical_sales_distribution ? validation.values.west : null;
    entity.monthlySales = productSettingObj.monthly_sales ? validation.values.monthlySales : null;
    entity.vendorPay = productSettingObj.vendor_payment_schedule ? vendorPays : null;
    entity.businessRequirement = (productSettingObj.business_requirement || productSettingObj.business_requirement2) ? selectedBusinessRequirement : null;
    entity.monthlyPurchases = productSettingObj.monthly_purchases_value ? validation.values.monthlyPurchases : null;

    if (valuationDone == "Yes" && productSettingObj.isValuationDone) {
      entity.isValuationDone = true;
    } else if (productSettingObj.isValuationDone && valuationDone == "No") {
      entity.isValuationDone = false;
    }

    if (productSettingObj.shareHoldingPattern) {
      let totalShareholding = 0;
      validation.values.shareholderList.forEach((elem) => {
        totalShareholding += +elem.percentageHolding;
        totalShareholding = Math.round(totalShareholding * 100) / 100;
      });
      if (totalShareholding > 100 && totalShareholding !== 0) {
        setToastInfo({
          message: "%Holding Shouldn't be greater than 100",
          showToast: true,
          role: "error",
        });
        return;
      }
      if (totalShareholding < 100 && totalShareholding !== 0) {
        setToastInfo({
          message: "%Holding Shouldn't be less than 100",
          showToast: true,
          role: "error",
        });
        return;
      }
      handleSubmitForShareHolding(validation.values,totalShareholding)
    }

    entity.percentageOfEquityDiluted = productSettingObj.percentageOfEquityDiluted ? validation.values.percentageOfEquityDiluted : '';
    entity.investorsType = productSettingObj.investorsType ? validation.values.investorsType : '';
    entity.equityType = productSettingObj.equityType ? validation.values.equityType : '';
    entity.purposeOfRaisingEquity = productSettingObj.purposeOfRaisingEquity ? validation.values.purposeOfRaisingEquity : '';
    entity.freshOrDiluted = productSettingObj.freshOrDiluted ? validation.values.freshOrDiluted : '';
    entity.dilutedEquityHolder = productSettingObj.dilutedEquityHolder ? validation.values.dilutedEquityHolder : '';
    entity.capexEquipmentImported = productSettingObj.capexEquipmentImported ? validation.values.capexEquipmentImported : '';
    entity.bankAvalizingBill = productSettingObj.bankAvalizingBill ? validation.values.bankAvalizingBill : '';
    entity.debenturesSecuredOrUnsecured = productSettingObj.debenturesSecuredOrUnsecured ? validation.values.debenturesSecuredOrUnsecured : '';
    entity.debenturesRatedOrUnrated = productSettingObj.debenturesRatedOrUnrated ? validation.values.debenturesRatedOrUnrated : '';
    entity.purposeOfIssuingDebentures = productSettingObj.purposeOfIssuingDebentures ? validation.values.purposeOfIssuingDebentures : '';
    entity.purposeOfIssuingCommercial = productSettingObj.purposeOfIssuingCommercial ? validation.values.purposeOfIssuingCommercial : '';
    entity.commercialRatedOrUnrated = productSettingObj.commercialRatedOrUnrated ? validation.values.commercialRatedOrUnrated : '';
    entity.coupon = productSettingObj.coupon ? validation.values.coupon : '';
    entity.poolPSLorNonPSL = productSettingObj.poolPSLorNonPSL ? validation.values.poolPSLorNonPSL : '';
    entity.poolRatedOrUnrated = productSettingObj.poolRatedOrUnrated ? validation.values.poolRatedOrUnrated : '';
    entity.desiredCoupon = productSettingObj.desiredCoupon ? validation.values.desiredCoupon : '';
    entity.poolAgeing = productSettingObj.poolAgeing ? validation.values.poolAgeing : '';

    if (selectedIsSecured == "Yes" && productSettingObj.is_loan_secured) {
      entity.isSecured = true;
    } else if (productSettingObj.is_loan_secured && selectedIsSecured == "No") {
      entity.isSecured = false;
    }

    if (productSettingObj.end_use) {
      const newData = [];
      selectedMulti2.forEach((ele) => {
        newData.push(ele.value);
      });
      entity.endUse = newData.join(",");
    }

    if (productSettingObj.guarantee) {
      const newData2 = [];
      selectedMulti1.forEach((ele) => {
        newData2.push(ele.value);
      });
      entity.guarantee = newData2.join(",");
    }

    if (cashDiscount == "No" && productSettingObj.dealer_cash_discounts) {
      entity.isCashDiscount = false;
    } else if (cashDiscount == "Yes" &&productSettingObj.dealer_cash_discounts) {
      entity.isCashDiscount = true;
    }

    if (selectedFldg == "Yes" && productSettingObj.default_guarantee_offer_fldg) {
      entity.fldg = validation.values.fldg;
      entity.isFldg = true;
    } else if (productSettingObj.default_guarantee_offer_fldg && selectedFldg == 'No') {
      entity.isFldg = false;
    }

    if (selectedOption == "No" && productSettingObj.dealer_credit_period) {
      entity.isCreditPeriod = false;
      entity.creditPeriod = 0;
    } else if (selectedOption == "Yes" && productSettingObj.dealer_credit_period) {
      entity.isCreditPeriod = true;
      entity.creditPeriod = validation.values.creditPeriod;
    }

    if (dealerfinancingArrangement == "No" && productSettingObj.existing_dealer_financing) {
      entity.isDealerArrangement = false;
    } else if (dealerfinancingArrangement == "Yes" && productSettingObj.existing_dealer_financing) {
      entity.isDealerArrangement = true;
      const newData = [];
      selectedMulti3.forEach((ele) => {
        newData.push(ele.value);
      });
      entity.dealerArrangement = newData.join(",");
      entity.percentageCovered = validation.values.percentageCovered;
    }

    if (vendorfinancingArrangement == "No" && productSettingObj.existing_vendor_financing) {
      entity.isVendorArrangement = false;
    } else if (vendorfinancingArrangement == "Yes" && productSettingObj.existing_vendor_financing) {
      entity.isVendorArrangement = true;
      const newData = [];
      selectedMulti4.forEach((ele) => {
        newData.push(ele.value);
      });
      entity.vendorsArrangement = newData.join(",");
    }

    if (selectedGuarantee == "No" && productSettingObj.guarantee_offer_to_lender) {
      entity.isGuaranteeLender = false;
    } else if (selectedGuarantee == "Yes" && productSettingObj.guarantee_offer_to_lender) {
      entity.isGuaranteeLender = true;
      const newData = [];
      selectedMulti5.forEach((ele) => {
        newData.push(ele.value);
      });
      entity.guaranteeTypesLender = newData.join(",");
    }

    if (isSelectedDpo && productSettingObj.business_requirement) {
      entity.vendorDiscount = validation.values.vendorDiscount;
      entity.extendDpoDays = validation.values.extendDpoDays;
    }

    if (productSettingObj.guarantee) {
      const newData2 = [];
      selectedMulti1.forEach((ele) => {
        newData2.push(ele.value);
      });
      entity.guarantee = newData2.join(",");
    }
    if (productSettingObj.property_list) {
      entity.propertyInfo = validation.values.propertyInfo;
      entity.bankName = validation.values.bankName;
      entity.bankStatement = validation.values.bankStatement;
      entity.isPasswordBankStatement = validation.values.isPasswordBankStatement;
      entity.isCoBorrower = validation.values.isCoBorrower;
      entity.isSecured = false;
    }

    if (productSettingObj.co_borrower) {
      entity.coBorrowerIncomeType = validation.values.coBorrowerIncomeType;
      entity.coBorrowerName = validation.values.coBorrowerName;
      entity.coBorrowerDob = validation.values.coBorrowerDob;
      entity.coBorrowerRelation = validation.values.coBorrowerRelation;
      entity.coBorrowerPanNumber = validation.values.coBorrowerPanNumber;
      entity.coBorrowerPan = validation.values.coBorrowerPan;
      entity.coBorrowerItr = validation.values.coBorrowerItr;
    }

    if (productSettingObj.statement_password) {
      entity.bankStatementPassword = validation.values.bankStatementPassword;
    }

    if (productSettingObj.other_income_source) {
      entity.isOtherIncomeSource = validation.values.isOtherIncomeSource;
      entity.otherIncomeAmount = +validation.values.otherIncomeAmount;
    }

    if (productSettingObj.equipment_category) {
      entity.equipmentCategory = validation.values.equipmentCategory;
      entity.equipmentSubCategory = validation.values.equipmentSubCategory;
      entity.equipmentType = validation.values.equipmentType;
      entity.isSecured = true;
    }
    entity.dealNotes = validation.values.dealNotes;
    Object.keys(entity).forEach(key => {
      if (entity[key] === null || entity[key] === "") {
        delete entity[key];
      }
    });
    if (status !== 'Submit' && status !== 'partner' && status !== 'create') {
      confirmAlert({
        title: 'Confirm',
        message: 'Are you sure you want to save deal?',
        buttons: [
          {
            label: 'Yes',
            onClick: () => {
              setLoader(true);
              editDealDraft(entity)
                .then((response) => {
                  if (response.code == "201") {
                    setLoader(false);
                    if (isfullAccess) {
                      navigate(`/${user.roleName}/listDeal`);
                    } else {
                      window.history.back();
                    }
                  }
                })
                .catch((error) => {
                  setLoader(false);
                }).finally(f => {
                  setLoader(false);
                });
            },
          },
          {
            label: 'No',
            onClick: () => {
              setLoader(false);
            },
          },
        ],
      });
    } else {
      confirmAlert({
        title: 'Confirm',
        message: 'Please note that once you submit this deal, it cannot be edited. Are you sure you want to proceed with the submission?',
        buttons: [
          {
            label: 'Yes',
            onClick: () => {
              setLoader(true);
              editDeal(entity)
                .then((response) => {
                  if (response.code == "201") {
                    setLoader(false);
                    if (isfullAccess) {
                      const encryptedId = btoa(entity.id.toString());
                      // navigate(`/${user.roleName}/emandate?id=${encodeURIComponent(encryptedId)}`);
                      navigate(`/${user.roleName}/listDeal`);
                    } else {
                      window.history.back();
                    }
                  }
                })
                .catch((error) => {
                  setLoader(false);
                }).finally(f => {
                  setLoader(false);
                });
              validation.resetForm()
            },
          },
          {
            label: 'No',
            onClick: () => {
              setLoader(false);
              // validation.resetForm()
            },
          },
        ],
      });
    }
  }

  const handleFinancierSelect = (event) => {
    setSelectedFinType(event.target.value);
    if (event.target.value == "All") {
      callFinancierList({ "financierType": "public_sector" })
        .then((response) => {
          const newData = [];
          const formattedOptions = response?.data.map((option) => ({
            label: option.entityName,
            value: option.id,
          }));
          formattedOptions.forEach((ele) => {
            newData.push(ele.value);
          });
          setPublicFinancier(newData);
          validation.values.financier = newData
          setSelectedMulti6(formattedOptions);
        })
        .catch((error) => {
          console.log(error)
        })
      callFinancierList({ "financierType": "private_sector" })
        .then((response) => {
          const newData = [];
          const formattedOptions = response?.data.map((option) => ({
            label: option.entityName,
            value: option.id,
          }));
          formattedOptions.forEach((ele) => {
            newData.push(ele.value);
          });
          setPrivateFinancier(newData)
          setSelectedMulti7(formattedOptions);
        })
        .catch((error) => {
          console.log(error)
        })

      callFinancierList({ "financierType": "NBFC" })
        .then((response) => {
          const newData = [];
          const formattedOptions = response?.data.map((option) => ({
            label: option.entityName,
            value: option.id,
          }));
          formattedOptions.forEach((ele) => {
            newData.push(ele.value);
          });
          setNbfcFinancier(newData);
          setSelectedMulti8(formattedOptions);
        })
        .catch((error) => {
          console.log(error)
        })
    } else {
      setSelectedMulti6([]);
      setPublicFinancier([])
      setSelectedMulti7([]);
      setPrivateFinancier([])
      setSelectedMulti8([]);
      setNbfcFinancier([])
      validation.setFieldValue('financier', []);
    }
    setErrorSelectedFinancier('');
  };
  const handlePrefFinancierSelect = (event) => {
    setSelectedPrefFinType(event.target.value);
    if (event.target.value == "All") {
      callFinancierList({ "financierType": "public_sector" })
        .then((response) => {
          const newData = [];
          const formattedOptions = response?.data.map((option) => ({
            label: option.entityName,
            value: option.id,
          }));
          formattedOptions.forEach((ele) => {
            newData.push(ele.value);
          });
          setPreferredPublicFinancier(newData);
          validation.values.preferredFinancier = newData
          setSelectedPrefFinancierMulti6(formattedOptions);
        })
        .catch((error) => {
          console.log(error)
        })
      callFinancierList({ "financierType": "private_sector" })
        .then((response) => {
          const newData = [];
          const formattedOptions = response?.data.map((option) => ({
            label: option.entityName,
            value: option.id,
          }));
          formattedOptions.forEach((ele) => {
            newData.push(ele.value);
          });
          setPreferredPrivateFinancier(newData)
          setSelectedPrefFinancierMulti7(formattedOptions);
        })
        .catch((error) => {
          console.log(error)
        })

      callFinancierList({ "financierType": "NBFC" })
        .then((response) => {
          const newData = [];
          const formattedOptions = response?.data.map((option) => ({
            label: option.entityName,
            value: option.id,
          }));
          formattedOptions.forEach((ele) => {
            newData.push(ele.value);
          });
          setPreferredNbfcFinancier(newData);
          setSelectedPrefFinancierMulti8(formattedOptions);
        })
        .catch((error) => {
          console.log(error)
        })
    } else {
      setSelectedPrefFinancierMulti6([]);
      setSelectedPrefFinancierMulti7([]);
      setSelectedPrefFinancierMulti8([]);
      setPreferredPublicFinancier([]);
      setPreferredPrivateFinancier([]);
      setPreferredNbfcFinancier([]);
      validation.setFieldValue('preferredFinancier', []);
    }
    setErrorSelectedFinancier('');
  };
  const checkPermissions = async () => {
    const isAddNew = await isPermission("approve_deal", "approve_permission")
    const isFull = await isPermission("deal_detail", "full_access")
    const assignment = await isPermission("assign", "create_permission")
    const leadAssignment = await isPermission("lead_assign", "create_permission")
    const isRecommendFin = await isPermission("financier_preference", "view_permission");

    setIsShowRecommendFinancier(isRecommendFin)
    setIsAssignmentPermisssion(leadAssignment)
    setIsAssignmentForMePermisssion(assignment)
    setIsfullAccess(isFull)
    setIsApprovePermission(isAddNew)
  }

  const handleBankChange = (option) => {
    setSelectedBankName(option)
    validation.setFieldValue('bankName', option.label);

  };

  const assignFunc = (ele) => {
    validation3.setFieldValue("assignedTo",ele.assignedTo)
    validation3.setFieldValue("assignedToFirm",ele.assignedToFirm)
    validation3.setFieldValue("assignedToProgramRm",ele.assignedToProgramRm)
    callGetCIUser()
      .then((response) => {
        if (response.code == 200 && response.status) {
          setUserList(response?.data?.rows)
        }
      }).catch((error) => {
      })
    validation3.setFieldValue('id', ele.id)
    setAssignmodal(true);
  }

  const assignToMeFunc = (ele) => {
    const user = decryptedValue(localStorage.getItem("user"));
    callAssignToMeDealFinancier({ id: ele.id, assignedTo: user.id })
      .then((response) => {
        if (response.status) {
          checkPermissions()
          setToastInfo({
            message: 'Deal Assigned Succesfully',
            showToast: true,
            role: "success",
          });
          getDealInfo({ id: decodedId })
            .then((response) => {
              if (response.status) {
                setEntity(response.data)
                setDealType(response?.data?.dealType)
              }
            }).catch((error) => {

            });
        } else {
          setToastInfo({
            message: response.message,
            showToast: true,
            role: "error",
          });
        }
      }).catch((error) => {

      });
  }

  const handleProductChange = (product, productType, subProduct,index) => {
    const updatedProducts = [...selectedProducts];
    updatedProducts[index] = product;
    setSelectedProducts(updatedProducts);
  };

  const handleProductTypeChange = (product, productType, subProduct,index) => {
    const updatedProducts = [...selectedProductsType];
    updatedProducts[index] = productType;
    setSelectedProductsType(updatedProducts);
  };

  useEffect(() => {
    if (selectedProducts.includes("Payable Financing") || selectedProducts.includes("Receivable Financing") || selectedProducts.includes("Inventory funding")
      || selectedProducts.includes("Buyers Credit") || selectedProducts.includes("Suppliers Credit") || selectedProducts.includes("Forfaiting")) {
      selectedProducts.forEach((type) => {
        if (type === "Payable Financing" || type === "Receivable Financing" || type === "Inventory funding") {
          getDropDownList({
            dropdownName: type,
          })
            .then((response) => {
              const dropdownValues = response.data?.rows?.find(
                (dv) => dv.dropdownName === type
              )?.dropdownValues || [];
              setSubProductList(dropdownValues);
            })
            .catch((error) => { });
        }
      });

      getDropDownList({
        dropdownName: "Guarantee Types For Lender"
      })
        .then((response) => {
          const dropdownValues =
            response.data?.rows?.find(
              (dv) =>
                dv.dropdownName == "Guarantee Types For Lender"
            )?.dropdownValues || [];
          const formattedOptions = dropdownValues.map((option) => ({
            label: option.displayName,
            value: option.dropdownValue,
          }));
          setEntityGuaranteeList(formattedOptions);
          setSelectedMulti5(
            selectedData(
              formattedOptions,
              dealDetail.guaranteeTypesLender
            )
          );
        });

      getDropDownList({ dropdownName: "Financing Arrangement" })
        .then((response) => {
          const dropdownValues =
            response.data?.rows?.find(
              (dv) =>
                dv.dropdownName == "Financing Arrangement"
            )?.dropdownValues || [];
          const formattedOptions = dropdownValues.map((option) => ({
            label: option.displayName,
            value: option.dropdownValue,
          }));
          setEntityArrangeList(formattedOptions);
          setSelectedMulti3(
            selectedData(
              formattedOptions,
              dealDetail.dealerArrangement
            )
          );
        });

      getDropDownList({ dropdownName: "Financing Arrangenment for vendor" })
        .then((response) => {
          const dropdownValues =
            response.data?.rows?.find(
              (dv) =>
                dv.dropdownName == "Financing Arrangenment for vendor"
            )?.dropdownValues || [];
          const formattedOptions = dropdownValues.map((option) => ({
            label: option.displayName,
            value: option.dropdownValue,
          }));
          setEntityArrangeListForVendor(formattedOptions);
          setSelectedMulti4(
            selectedData(
              formattedOptions,
              dealDetail.vendorsArrangement
            )
          );
        });
    }

    if (selectedProducts.includes("Loan against Property")) {
      apiFetchForLAP("enduse_loan_against_prop");
      const loanObj = {
        id: uId(),
        propertyNature: "",
        propertyOwner: "",
        propertyStatus: "",
        propertyValue: "",
        propertyAge: "",
        address: "",
        city: "",
        pincode: "",
        state: "",
        parentDeed: "",
        saleDeed: "",
        utilityBills: "",
        propertyTax: "",
      };
      validation.setFieldValue("propertyInfoList", [loanObj]);
    } else if (selectedProducts.includes("End Use")) {
      apiFetchForLAP("End Use");
    }

    if (selectedProducts.includes("Equipment Finance")) {
      validation.values.isSecured = true;
      setSelectedIsSecured("Yes");
    } else {
      setSelectedIsSecured(formatData(dealDetail.isSecured));
    }

    if (selectedProducts.includes("Receivable Financing")) {
      validation.values.facility = "Dealer";
    }

    if (selectedProducts.includes("Inventory funding")) {
      validation.values.facility = "Dealer";
    }


    if (selectedProducts.includes("Payable Financing")) {
      validation.values.facility = "Vendor";
    }

    if (selectedProducts.includes("Loan against Property")) {
      if (dealDetail.propertyInfo) {
        setRows(
          dealDetail.propertyInfo.map((obj) =>
            Object.assign(obj, { id: uId() })
          )
        );
      }
      setSelectedBankName({
        label: dealDetail.bankName,
        value: dealDetail.bankName,
      });
      apiFetchForLAP("enduse_loan_against_prop", dealDetail);
    } else {
      apiFetchForLAP("End Use", dealDetail);
    }

    getShareholdingList({ entityId: entity?.entityId })
      .then((response) => {
        const allshareholdings = response.data?.data || [];
        if (allshareholdings.length > 0) {
          const formatedDate = formatDateString1(
            allshareholdings[0].shareholdingAsOf
          );
          allshareholdings[0].shareholdingAsOf = formatedDate;
          setShareholdingList(allshareholdings);
          validation.setFieldValue("shareholdingAsOf", formatedDate);
          validation.setFieldValue("shareholderList", allshareholdings[0].shareholderList);
        }
      })
      .catch((error) => {
        console.log(error);
      });

    let newObj = {}
    Object.keys(productSettingObj).forEach(key => {
      newObj[key] = false;
    });
    
    selectedProducts.forEach(product => {
      if (productSetting[product]) {
        Object.keys(productSetting[product]).forEach(key => {
          if (productSetting[product][key]) {
            newObj[key] = true;
          }
        });
      }
    });
    setProductSettingObj(newObj)
  }, [selectedProducts, dealDetail]);
  
  useEffect(() => {
    selectedProductsType.forEach((product) => {
      if (product === "Term loan") {
        getDropDownList({ dropdownName: "Security Cover" })
          .then((response) => {
            const dropdownValues =
              response.data?.rows?.find(
                (dv) => dv.dropdownName === "Security Cover"
              )?.dropdownValues || [];
            setSecurityCoverList(dropdownValues);
          })
          .catch((error) => { });

        getDropDownList({ dropdownName: "End Use" })
          .then((response) => {
            const dropdownValues =
              response.data?.rows?.find(
                (dv) => dv.dropdownName === "End Use"
              )?.dropdownValues || [];
            const formattedOptions = dropdownValues.map(
              (option) => ({
                label: option.displayName,
                value: option.dropdownValue,
              })
            );
            setEndUseList(formattedOptions);
          })
          .catch((error) => { });
      }
      if (product === "Working Capital") {
        getDropDownList({ dropdownName: "WC Tenure" })
          .then((response) => {
            const dropdownValues =
              response.data?.rows?.find(
                (dv) => dv.dropdownName === "WC Tenure"
              )?.dropdownValues || [];
            setTenureList(dropdownValues);
          })
          .catch((error) => { });

          getDropDownList({ dropdownName: "Financing Arrangement" })
          .then((response) => {
            const dropdownValues = response.data?.rows?.find((dv) => dv.dropdownName == "Financing Arrangement")?.dropdownValues || []
            const formattedOptions = dropdownValues.map(option => ({
              label: option.displayName,
              value: option.dropdownValue,
            }));
            setEntityArrangeList(formattedOptions)
            setSelectedMulti3(selectedData(formattedOptions, dealDetail.dealerArrangement))
          })

      } else {
        getDropDownList({ dropdownName: "Tenure" })
          .then((response) => {
            const dropdownValues =
              response.data?.rows?.find(
                (dv) => dv.dropdownName === "Tenure"
              )?.dropdownValues || [];
            setTenureList(dropdownValues);
          })
          .catch((error) => { });
      }
    });
  }, [selectedProductsType,dealDetail])

  const handleDeleteProduct = (rowIndex) => {
    validation.values.productInfoList.splice(rowIndex, 1);
    validation.validateForm();
    let productList = []
    let productTypeList = []
    validation.values.productInfoList.map((ele)=>{
      if(ele.product){
        productList.push(ele.product)
      }
      if(ele.productType){
        productTypeList.push(ele.productType)
      }
    })
    setSelectedProducts(productList)
    setSelectedProductsType(productTypeList)
  }; 

  const handleDeleteShareHolding = (rowIndex) => {
    validation.values.shareholderList.splice(rowIndex, 1);
    setPercentageholdingValue(0);
    validation.validateForm();
  };


  const onChangePercentageValue = (value) => {
    setPercentageholdingValue(percentageholdingValue + value);
  };

  let totalValue = 0;
  for (let value of validation.values.shareholderList) {
    totalValue += +value.percentageHolding;
    totalValue = Math.round(totalValue * 100) / 100;
  }

  const handleSubmitForShareHolding = (values,totalShareholding) => {
    let shareholdingPatternObj = {
      shareholdingAsOf: values.shareholdingAsOf,
      totalShareholding,
      entityId:values.entityId,
      shareholderList: values.shareholderList,
    };
    if (shareholdingList.length == 0) {
      addShareholding(shareholdingPatternObj)
        .then((response) => {
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      shareholdingPatternObj.id = shareholdingList[0].id;
      editShareholding(shareholdingPatternObj)
        .then((response) => {
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  const ReferredFinancierList = () => {
    setRefferedFinModal(true)
    let productType = []
    let product = []
    let subProduct = []
    let entityId = validation.values.entityId
    let loanRequirement = validation.values.loanRequirement ? +validation.values.loanRequirement : ''
    let roi = validation.values.rateOfInterest ? +validation.values.rateOfInterest : ''

    if (validation.values.productInfoList) {
      validation.values.productInfoList?.map((ele) => {
        if (ele.productType) {
          productType.push(ele.productType)
        }
        if (ele.product) {
          product.push(ele.product)
        }
        if (ele.subProduct) {
          subProduct.push(ele.subProduct)
        }
      })
    }

    if (product, productType) {
      let obj = { productType, product, subProduct, loanRequirement, roi, entityId }
      callReferredFinancierList(obj)
        .then((response) => {
          if(response.data && response.data.length>0){
            setReferredFinancierList(response.data)
          }else{
            setReferredFinancierList([])
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  const handleInputChange = (value) => {
    allEntity({ searchKey: value, nonFinancierType: '',sortingOrder: "asc" })
      .then((response) => {
        if (response?.data) {
          setAnchorList(response.data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleAnchorChange = (option) => {
    setSelectedAnchorName(option);
    validation.setFieldValue("anchorId", option.value);
  };

  const handleDateChange = (date) => {
    validation.setFieldValue('expectedClosureDate', date);
  };
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row className="vertical-scroll">
            <Col xs="12">
              <div>
                <div>
                  <FormikProvider value={validation}>
                    <Form
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        // handleSubmit(e)
                        return false;
                      }}
                    >
                      <div>
                        <h5 style={{ marginTop: "1%" }}>Edit Deal: {entity?.dealName}</h5>
                      </div>
                      <div className="mb-3 row">
                        {isAdmin && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">Select Entity Type*</Label>
                          <Input
                            name="dealType"
                            type="select"
                            onChange={(e)=>{
                              validation.handleChange(e)
                              setDealType(e.target.value)
                            }}
                            onBlur={validation.handleBlur}
                            value={validation.values.dealType || ""}
                            invalid={
                              !!(validation.touched.dealType && validation.errors.dealType)
                            }
                            disabled={!isfullAccess}
                          >
                            <option value="" disabled>Select Entity Type</option>
                            <option
                              value="Anchor"
                            >
                              Anchor
                            </option>
                            <option
                              value="Counterparty"
                            >
                              Counterparty
                            </option>
                            <option
                              value="Standalone"
                            >
                              Standalone
                            </option>
                          </Input>
                          {validation.touched.dealType &&
                            validation.errors.dealType ? (
                            <FormFeedback type="invalid">
                              {validation.errors.dealType}
                            </FormFeedback>
                          ) : null}
                        </Col>)}

                        {isAdmin && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">Entity Name*</Label>
                          <Input
                            name="entityId"
                            type="select"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.entityId || ""}
                            invalid={
                              validation.touched.entityId &&
                              validation.errors.entityId
                            }
                            disabled={true}
                          >
                            <option value="" disabled>Select Entity Name</option>
                            {entityList?.map((option) => (
                              <option key={option.id} value={option.id}>
                                {option.entityName}
                              </option>
                            ))}
                          </Input>
                          {validation.touched.entityId &&
                            validation.errors.entityId ? (
                            <FormFeedback type="invalid">
                              {validation.errors.entityId}
                            </FormFeedback>
                          ) : null}
                        </Col>)}

                        {selectedDealType == "Counterparty" && (
                          <Col sm="12" md="6">
                            <Label className="form-label mt-4 grey">Anchor Name</Label>
                            {/* <Input
                              name="anchorId"
                              type="select"
                              disabled={true}
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.anchorId || ""}
                              invalid={
                                validation.touched.anchorId &&
                                validation.errors.anchorId
                              }
                            >
                              <option value="" disabled>Select Anchor Name</option>
                              {entityList.map((option) => (
                                <option key={option.id} value={option.id}>
                                  {option.entityName}
                                </option>
                              ))}
                            </Input> */}
                             <Select
                              options={anchorList?.map((option, index) => ({
                                label: option.entityName,
                                value: option.id,
                              }))}
                              className={`select-dropdown ${validation.touched.anchorId &&
                                validation.errors.anchorId
                                ? "is-invalid"
                                : ""
                                }`}
                              name="anchorId"
                              id="anchorId"
                              placeholder={"Enter Anchor Name"}
                              value={selectedAnchorName}
                              onInputChange={(e) => {
                                handleInputChange(e)
                              }}
                              onMenuOpen={(e) => {
                                hasOpenedBefore ? handleInputChange("") : null;
                                setHasOpenedBefore(false);
                              }}
                              onChange={(selectedOption) => {
                                setSelectedAnchorName(selectedOption.label)
                                handleAnchorChange(selectedOption);
                              }}
                              onBlur={() => {
                                validation.setFieldTouched('anchorId', true);
                              }}
                            />
                            {validation.touched.anchorId &&
                              validation.errors.anchorId ? (
                              <FormFeedback type="invalid">
                                {validation.errors.anchorId}
                              </FormFeedback>
                            ) : null}
                          </Col>
                        )}

                        {isAdmin && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">
                            Select Prospective Product*
                          </Label>
                          <Input
                            name="prospectiveProduct"
                            type="select"
                            placeholder="Select Prospective Product"
                            onChange={(e) => {
                              validation.handleChange(e);
                              const selectedProduct = e.target.value;
                                // Reset Partner Program if Prospective Product is not "TradEasy"
                                if (selectedProduct !== "TradEasy") {
                                  validation.setFieldValue("partnerProgram", "");
                                  }
                              if (selectedProduct === 'TradEasy') {
                                validation.setFieldValue('productInfoList[0].platformChargesType', 'Flat');
                                validation.setFieldValue('productInfoList[0].platformChargesFrequency', 'One time');
                                validation.setFieldValue('productInfoList[0].integrationFeesType', 'Flat');
                                validation.setFieldValue('productInfoList[0].integrationFeesFrequency', 'One time');
                                validation.setFieldValue('productInfoList[0].syndicationFeesType', 'Flat');
                                validation.setFieldValue('productInfoList[0].syndicationFeesFrequency', 'One time');
    
                              }
                            }}
                            onBlur={validation.handleBlur}
                            value={validation.values.prospectiveProduct || ""}
                            invalid={!!(validation.touched.prospectiveProduct && validation.errors.prospectiveProduct)}
                          >
                            <option value="" disabled> Select Prospective Product</option>
                            {prospectiveProductList?.map((option, index) => (
                              <option
                                key={option.id}
                                value={option.dropdownValue}
                              >
                                {option.displayName}
                              </option>
                            ))}
                          </Input>
                          {validation.touched.prospectiveProduct &&
                            validation.errors.prospectiveProduct ? (
                            <FormFeedback type="invalid">
                              {validation.errors.prospectiveProduct}
                            </FormFeedback>
                          ) : null}
                        </Col>)}

                        {isAdmin && validation.values.prospectiveProduct && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">
                          Select Proposal Type*
                          </Label>
                          <Input
                            name="proposalType"
                            type="select"
                            placeholder="Select Proposal Type"
                            onChange={(e) => {
                              validation.handleChange(e);
                            }}
                            onBlur={validation.handleBlur}
                            value={validation.values.proposalType || ""}
                            invalid={!!(validation.touched.proposalType && validation.errors.proposalType)}
                          >
                            <option value="" disabled> Select Proposal Type</option>
                            {prosposalTypeList?.map((option, index) => (
                              <option
                                key={option.id}
                                value={option.dropdownValue}
                              >
                                {option.displayName}
                              </option>
                            ))}
                          </Input>
                          {validation.touched.proposalType &&
                            validation.errors.proposalType ? (
                            <FormFeedback type="invalid">
                              {validation.errors.proposalType}
                            </FormFeedback>
                          ) : null}
                        </Col>)}

                        {isAdmin && validation.values.prospectiveProduct === "TradEasy" && (
                          <Col sm="12" md="6">
                            <Label className="form-label mt-4 grey">Partner Program</Label>
                            <Select
                              name="partnerProgram"
                              placeholder="Select Partner Program"
                              options={partnerProgramList?.map(option => ({
                                value: option.dropdownValue,
                                label: option.displayName
                              }))}
                              onChange={(selectedOption) => {
                                validation.setFieldValue("partnerProgram", selectedOption ? selectedOption.value : "");
                              }}
                              onBlur={() => validation.setFieldTouched("partnerProgram", true)}
                              value={
                                partnerProgramList.find(
                                  option => option.dropdownValue === validation.values.partnerProgram
                                )
                                  ? {
                                    value: validation.values.partnerProgram,
                                    label: partnerProgramList.find(
                                      option => option.dropdownValue === validation.values.partnerProgram
                                    )?.displayName
                                  }
                                  : null
                              }
                              isClearable
                            />
                            {validation.touched.partnerProgram && validation.errors.partnerProgram ? (
                              <FormFeedback type="invalid">
                                {validation.errors.partnerProgram}
                              </FormFeedback>
                            ) : null}
                          </Col>
                        )}

                        <Col lg="12" sm="12">
                          <FieldArray
                            name="productInfoList"
                            render={(arrayHelpers) => (
                              <>
                                {validation.values?.productInfoList?.map(
                                  (file, index) => (
                                    <ProductRow
                                      key={file.id}
                                      onDelete={handleDeleteProduct}
                                      index={index}
                                      validation={validation}
                                      change={handleProductChange}
                                      changeType={handleProductTypeChange}
                                      commercialFieldsData={commercialFieldsData}
                                      isAdmin = {isAdmin}
                                    />
                                  )
                                )}
                                <span
                                  className="text-success"
                                  style={{ cursor: "pointer" }}
                                  onKeyUp={() => { }}
                                  onClick={() => {
                                    arrayHelpers.push({
                                      id: '',
                                      product: '',
                                      productType: '',
                                      subProduct: [],
                                      integrationFeesType: '',
                                      integrationFeesFrequency: '',
                                      integrationFeesOccurrence: '',
                                      integrationFeesValue: '',
                                      syndicationFeesType: '',
                                      syndicationFeesFrequency: '',
                                      syndicationFeesOccurrence: '',
                                      syndicationFeesValue: '',
                                      platformChargesType: '',
                                      platformChargesFrequency: '',
                                      platformChargesOccurrence: '',
                                      platformChargesValue: '',
                                      platformChargesBenchmarkRate: '',
                                      platformChargesMarkupOverBenchmark: '',
                                      platformChargesBenchmark:'',
                                      platformChargesNVG:''
                                    });
                                  }}
                                >
                                  <i className="mdi mdi-plus me-1" /> Add
                                  Product
                                </span>
                              </>
                            )}
                          />
                        </Col>

                        <Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">Requested Loan Amount</Label>
                          <Input
                            name="loanRequirement"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.loanRequirement || ""}
                            invalid={validation.touched.loanRequirement && validation.errors.loanRequirement}
                          />
                          {validation.touched.loanRequirement && validation.errors.loanRequirement ? (
                            <FormFeedback type="invalid">{validation.errors.loanRequirement}</FormFeedback>
                          ) : null}
                        </Col>

                        {productSettingObj.interest_rate && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">Rate of Interest (%)</Label>
                          <Input
                            name="rateOfInterest"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.rateOfInterest || ""}
                            invalid={validation.touched.rateOfInterest && validation.errors.rateOfInterest}
                          />
                          {validation.touched.rateOfInterest && validation.errors.rateOfInterest ? (
                            <FormFeedback type="invalid">{validation.errors.rateOfInterest}</FormFeedback>
                          ) : null}
                        </Col>)}

                        {productSettingObj.loan_tenure && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">Tenure</Label>
                          <Input
                            name="tenure"
                            type="select"
                            placeholder="Enter Entity constitution"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.tenure || ""}
                            invalid={
                              validation.touched.tenure && validation.errors.tenure
                            }
                          >
                            <option value="" disabled>Select Tenure</option>
                            {tenureList.map((option) => (
                              <option key={option.id} value={option.dropdownValue}>
                                {option.displayName}
                              </option>
                            ))}
                          </Input>
                          {validation.touched.tenure && validation.errors.tenure ? (
                            <FormFeedback type="invalid">
                              {validation.errors.tenure}
                            </FormFeedback>
                          ) : null}
                        </Col>)}

                        {productSettingObj.percentageOfEquityDiluted && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">
                            What % of equity to be diluted?
                          </Label>
                          <Input
                            name="percentageOfEquityDiluted"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.percentageOfEquityDiluted || ""}
                            invalid={
                              validation.touched.percentageOfEquityDiluted &&
                              validation.errors.percentageOfEquityDiluted
                            }
                          />
                          {validation.touched.percentageOfEquityDiluted &&
                            validation.errors.percentageOfEquityDiluted ? (
                            <FormFeedback type="invalid">
                              {validation.errors.percentageOfEquityDiluted}
                            </FormFeedback>
                          ) : null}
                        </Col>)}

                        {productSettingObj.shareHoldingPattern && (
                          <Col sm="12" md="12" className="mt-4">
                            <div>
                              <Card className="p-3 mt-3">
                                <Row className="mb-4">
                                  <Col lg={3} className="me-5">
                                    <Label
                                      htmlFor="horizontal-email-Input"
                                      className="col-sm-12 col-form-label"
                                    >
                                      Shareholding as of
                                    </Label>
                                    <Input
                                      type="date"
                                      className="form-control"
                                      name="shareholdingAsOf"
                                      id="shareholdingAsOf"
                                      max={currentDate}
                                      value={validation.values.shareholdingAsOf || ""}
                                      onChange={validation.handleChange}
                                      onBlur={validation.handleBlur}
                                      invalid={
                                        !!(
                                          validation.touched.shareholdingAsOf &&
                                          validation.errors.shareholdingAsOf
                                        )
                                      }
                                    />
                                    {validation.touched.shareholdingAsOf &&
                                      validation.errors.shareholdingAsOf ? (
                                      <FormFeedback type="invalid">
                                        {validation.errors.shareholdingAsOf}
                                      </FormFeedback>
                                    ) : null}
                                  </Col>
                                  <Col lg={2} sm={4}>
                                    <Label
                                      htmlFor="horizontal-email-Input"
                                      className="col-sm-12 mt-2"
                                    >
                                      Total shareholding %
                                    </Label>
                                    <div className="shareholdingPercent">{totalValue}</div>
                                  </Col>
                                  <Col lg={2}></Col>
                                </Row>
                                <Row>
                                  <Col sm="12">
                                    <div className="mb-3">
                                      <Table
                                        Table
                                        striped
                                        bordered
                                        hover
                                        style={{ width: "100%", backgroundColor: "white" }}
                                      >
                                        <thead>
                                          <tr>
                                            <th>Shareholder Name</th>
                                            <th>Shareholder Type</th>
                                            <th>% Holding</th>
                                            <th></th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <FieldArray
                                            name="shareholderList"
                                            render={(arrayHelpers) => (
                                              <>
                                                {validation.values.shareholderList.map(
                                                  (shareholder, index) => (
                                                    <TableRowShareHolding
                                                      key={shareholder.id}
                                                      onDelete={handleDeleteShareHolding}
                                                      index={index}
                                                      validation={validation}
                                                      percentageholdingValue={
                                                        onChangePercentageValue
                                                      }
                                                    />
                                                  )
                                                )}
                                                <tr>
                                                  <td colSpan={5}>
                                                    <span
                                                      className="text-success"
                                                      style={{ cursor: "pointer" }}
                                                      onClick={() => {
                                                        arrayHelpers.push({
                                                          shareholderName: "",
                                                          shareholderType: "",
                                                          percentageHolding: "",
                                                        });
                                                      }}
                                                    >
                                                      <i className="mdi mdi-plus me-1" /> Add
                                                      Shareholder
                                                    </span>
                                                  </td>
                                                </tr>
                                              </>
                                            )}
                                          />
                                        </tbody>
                                      </Table>
                                    </div>
                                  </Col>
                                </Row>
                              </Card>
                            </div>
                          </Col>
                        )}

                        {productSettingObj.isValuationDone && (
                          <Col sm="12" md="6">
                            <Label className="form-label mt-4 grey">
                              Has the valuation being done?
                            </Label>
                            <div className="d-flex ms-4">
                              <div>
                                <Input
                                  type="radio"
                                  id="isValuationDone1"
                                  value="Yes"
                                  onChange={() => { }}
                                  style={{ border: "1px solid black" }}
                                  checked={valuationDone == "Yes"}
                                  onClick={(event) => {
                                    if (event.target.value == "Yes") {
                                      validation.setFieldValue("isValuationDone", true);
                                    } else {
                                      validation.setFieldValue("isValuationDone", false);
                                    }
                                    setValuationDone(event.target.value);
                                    setValuationDoneError("");
                                  }}
                                />
                                <Label
                                  htmlFor="isValuationDone1"
                                  className="ms-2"
                                >
                                  Yes
                                </Label>
                              </div>
                              <div className="ms-4">
                                <Input
                                  type="radio"
                                  id="isValuationDone2"
                                  onChange={() => { }}
                                  value="No"
                                  style={{ border: "1px solid black" }}
                                  checked={valuationDone == "No"}
                                  onClick={(event) => {
                                    if (event.target.value == "Yes") {
                                      validation.setFieldValue("isValuationDone", true);
                                    } else {
                                      validation.setFieldValue("isValuationDone", false);
                                    }
                                    setValuationDone(event.target.value);
                                    setValuationDoneError("");
                                  }}
                                />
                                <Label
                                  htmlFor="isValuationDone2"
                                  className="ms-2"
                                >
                                  No
                                </Label>
                              </div>
                            </div>
                            {valuationDoneError && (
                              <p
                                style={{
                                  color: "rgb(245,116,116)",
                                  fontSize: "11px",
                                }}
                                className="ms-4"
                              >
                                {valuationDoneError}
                              </p>
                            )}
                          </Col>
                        )}

                        {productSettingObj.investorsType && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">
                            What kind of investors accepted to the company?
                          </Label>
                          <Input
                            name="investorsType"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.investorsType || ""}
                            invalid={
                              validation.touched.investorsType &&
                              validation.errors.investorsType
                            }
                          />
                          {validation.touched.investorsType &&
                            validation.errors.investorsType ? (
                            <FormFeedback type="invalid">
                              {validation.errors.investorsType}
                            </FormFeedback>
                          ) : null}
                        </Col>)}

                        {productSettingObj.equityType && (
                          <Col sm="12" md="6">
                            <Label className="form-label mt-4 grey">
                              Whether it is preference share equity or normal equity?
                            </Label>
                            <div className="d-flex ms-4">
                              <div>
                                <Input
                                  type="radio"
                                  id="equityType1"
                                  value="Preference share equity"
                                  onChange={() => { }}
                                  style={{ border: "1px solid black" }}
                                  checked={selectEquityType == "Preference share equity"}
                                  onClick={(event) => {
                                    validation.setFieldValue("equityType", event.target.value);
                                    setSelectEquityType(event.target.value);
                                    setSelectEquityTypeError("");
                                  }}
                                />
                                <Label
                                  htmlFor="equityType1"
                                  className="ms-2"
                                >
                                  Preference share equity
                                </Label>
                              </div>
                              <div className="ms-4">
                                <Input
                                  type="radio"
                                  id="equityType2"
                                  onChange={() => { }}
                                  value="Normal equity"
                                  style={{ border: "1px solid black" }}
                                  checked={selectEquityType == "Normal equity"}
                                  onClick={(event) => {
                                    validation.setFieldValue("equityType", event.target.value);
                                    setSelectEquityType(event.target.value);
                                    setSelectEquityTypeError("");
                                  }}
                                />
                                <Label
                                  htmlFor="equityType2"
                                  className="ms-2"
                                >
                                  Normal equity
                                </Label>
                              </div>
                            </div>
                            {selectEquityTypeError && (
                              <p
                                style={{
                                  color: "rgb(245,116,116)",
                                  fontSize: "11px",
                                }}
                                className="ms-4"
                              >
                                {selectEquityTypeError}
                              </p>
                            )}
                          </Col>
                        )}

                        {productSettingObj.purposeOfRaisingEquity && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">
                            What is the purpose of raising Equity?
                          </Label>
                          <Input
                            name="purposeOfRaisingEquity"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.purposeOfRaisingEquity || ""}
                            invalid={
                              validation.touched.purposeOfRaisingEquity &&
                              validation.errors.purposeOfRaisingEquity
                            }
                          />
                          {validation.touched.purposeOfRaisingEquity &&
                            validation.errors.purposeOfRaisingEquity ? (
                            <FormFeedback type="invalid">
                              {validation.errors.purposeOfRaisingEquity}
                            </FormFeedback>
                          ) : null}
                        </Col>)}

                        {productSettingObj.freshOrDiluted && (
                          <Col sm="12" md="6">
                            <Label className="form-label mt-4 grey">
                              Is it fresh equity or diluted equity?
                            </Label>
                            <div className="d-flex ms-4">
                              <div>
                                <Input
                                  type="radio"
                                  id="freshOrDiluted1"
                                  value="Fresh equity"
                                  onChange={() => { }}
                                  style={{ border: "1px solid black" }}
                                  checked={selectFreshOrDiluted == "Fresh equity"}
                                  onClick={(event) => {
                                    validation.setFieldValue("freshOrDiluted", event.target.value);
                                    setSelectFreshOrDiluted(event.target.value);
                                    setSelectFreshOrDilutedError("");
                                  }}
                                />
                                <Label
                                  htmlFor="freshOrDiluted1"
                                  className="ms-2"
                                >
                                  Fresh equity
                                </Label>
                              </div>
                              <div className="ms-4">
                                <Input
                                  type="radio"
                                  id="freshOrDiluted2"
                                  onChange={() => { }}
                                  value="Diluted equity"
                                  style={{ border: "1px solid black" }}
                                  checked={selectFreshOrDiluted == "Diluted equity"}
                                  onClick={(event) => {
                                    validation.setFieldValue("freshOrDiluted", event.target.value);
                                    setSelectFreshOrDiluted(event.target.value);
                                    setSelectFreshOrDilutedError("");
                                  }}
                                />
                                <Label
                                  htmlFor="freshOrDiluted2"
                                  className="ms-2"
                                >
                                  Diluted equity
                                </Label>
                              </div>
                            </div>
                            {selectFreshOrDilutedError && (
                              <p
                                style={{
                                  color: "rgb(245,116,116)",
                                  fontSize: "11px",
                                }}
                                className="ms-4"
                              >
                                {selectFreshOrDilutedError}
                              </p>
                            )}
                          </Col>
                        )}

                        {productSettingObj.dilutedEquityHolder && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">
                            Whose equity is being diluted?
                          </Label>
                          <Input
                            name="dilutedEquityHolder"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.dilutedEquityHolder || ""}
                            invalid={
                              validation.touched.dilutedEquityHolder &&
                              validation.errors.dilutedEquityHolder
                            }
                          />
                          {validation.touched.dilutedEquityHolder &&
                            validation.errors.dilutedEquityHolder ? (
                            <FormFeedback type="invalid">
                              {validation.errors.dilutedEquityHolder}
                            </FormFeedback>
                          ) : null}
                        </Col>)}

                        {productSettingObj.capexEquipmentImported && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">
                            What is the capex equipment being imported?
                          </Label>
                          <Input
                            name="capexEquipmentImported"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.capexEquipmentImported || ""}
                            invalid={
                              validation.touched.capexEquipmentImported &&
                              validation.errors.capexEquipmentImported
                            }
                          />
                          {validation.touched.capexEquipmentImported &&
                            validation.errors.capexEquipmentImported ? (
                            <FormFeedback type="invalid">
                              {validation.errors.capexEquipmentImported}
                            </FormFeedback>
                          ) : null}
                        </Col>)}

                        {productSettingObj.bankAvalizingBill && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">
                            Which bank will abalize or co-accept the bill of exchange?
                          </Label>
                          <Input
                            name="bankAvalizingBill"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.bankAvalizingBill || ""}
                            invalid={
                              validation.touched.bankAvalizingBill &&
                              validation.errors.bankAvalizingBill
                            }
                          />
                          {validation.touched.bankAvalizingBill &&
                            validation.errors.bankAvalizingBill ? (
                            <FormFeedback type="invalid">
                              {validation.errors.bankAvalizingBill}
                            </FormFeedback>
                          ) : null}
                        </Col>)}

                        {productSettingObj.debenturesSecuredOrUnsecured && (
                          <Col sm="12" md="6">
                            <Label className="form-label mt-4 grey">
                              Whether the debentures are secured or unsecured?
                            </Label>
                            <div className="d-flex ms-4">
                              <div>
                                <Input
                                  type="radio"
                                  id="debenturesSecuredOrUnsecured1"
                                  value="Secured"
                                  onChange={() => { }}
                                  style={{ border: "1px solid black" }}
                                  checked={selectdebenturesSecuredOrUnsecured == "Secured"}
                                  onClick={(event) => {
                                    validation.setFieldValue("debenturesSecuredOrUnsecured", event.target.value);
                                    setSelectdebenturesSecuredOrUnsecured(event.target.value);
                                    setSelectdebenturesSecuredOrUnsecuredError("");
                                  }}
                                />
                                <Label
                                  htmlFor="debenturesSecuredOrUnsecured1"
                                  className="ms-2"
                                >
                                  Secured
                                </Label>
                              </div>
                              <div className="ms-4">
                                <Input
                                  type="radio"
                                  id="debenturesSecuredOrUnsecured2"
                                  onChange={() => { }}
                                  value="Unsecured"
                                  style={{ border: "1px solid black" }}
                                  checked={selectdebenturesSecuredOrUnsecured == "Unsecured"}
                                  onClick={(event) => {
                                    validation.setFieldValue("debenturesSecuredOrUnsecured", event.target.value);
                                    setSelectdebenturesSecuredOrUnsecured(event.target.value);
                                    setSelectdebenturesSecuredOrUnsecuredError("");
                                  }}
                                />
                                <Label
                                  htmlFor="debenturesSecuredOrUnsecured2"
                                  className="ms-2"
                                >
                                  Unsecured
                                </Label>
                              </div>
                            </div>
                            {selectdebenturesSecuredOrUnsecuredError && (
                              <p
                                style={{
                                  color: "rgb(245,116,116)",
                                  fontSize: "11px",
                                }}
                                className="ms-4"
                              >
                                {selectdebenturesSecuredOrUnsecuredError}
                              </p>
                            )}
                          </Col>
                        )}

                        {productSettingObj.debenturesRatedOrUnrated && (
                          <Col sm="12" md="6">
                            <Label className="form-label mt-4 grey">
                              Whether the Debentures are rated or unrated?
                            </Label>
                            <div className="d-flex ms-4">
                              <div>
                                <Input
                                  type="radio"
                                  id="debenturesRatedOrUnrated1"
                                  value="Rated"
                                  onChange={() => { }}
                                  style={{ border: "1px solid black" }}
                                  checked={selectdebenturesRatedOrUnrated == "Rated"}
                                  onClick={(event) => {
                                    validation.setFieldValue("debenturesRatedOrUnrated", event.target.value);
                                    setSelectdebenturesRatedOrUnrated(event.target.value);
                                    setSelectdebenturesRatedOrUnratedError("");
                                  }}
                                />
                                <Label
                                  htmlFor="debenturesRatedOrUnrated1"
                                  className="ms-2"
                                >
                                  Rated
                                </Label>
                              </div>
                              <div className="ms-4">
                                <Input
                                  type="radio"
                                  id="debenturesRatedOrUnrated2"
                                  onChange={() => { }}
                                  value="Unrated"
                                  style={{ border: "1px solid black" }}
                                  checked={selectdebenturesRatedOrUnrated == "Unrated"}
                                  onClick={(event) => {
                                    validation.setFieldValue("debenturesRatedOrUnrated", event.target.value);
                                    setSelectdebenturesRatedOrUnrated(event.target.value);
                                    setSelectdebenturesRatedOrUnratedError("");
                                  }}
                                />
                                <Label
                                  htmlFor="debenturesRatedOrUnrated2"
                                  className="ms-2"
                                >
                                  Unrated
                                </Label>
                              </div>
                            </div>
                            {selectdebenturesRatedOrUnratedError && (
                              <p
                                style={{
                                  color: "rgb(245,116,116)",
                                  fontSize: "11px",
                                }}
                                className="ms-4"
                              >
                                {selectdebenturesRatedOrUnratedError}
                              </p>
                            )}
                          </Col>
                        )}

                        {productSettingObj.purposeOfIssuingDebentures && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">
                            Purpose of issuing Debentures?
                          </Label>
                          <Input
                            name="purposeOfIssuingDebentures"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.purposeOfIssuingDebentures || ""}
                            invalid={
                              validation.touched.purposeOfIssuingDebentures &&
                              validation.errors.purposeOfIssuingDebentures
                            }
                          />
                          {validation.touched.purposeOfIssuingDebentures &&
                            validation.errors.purposeOfIssuingDebentures ? (
                            <FormFeedback type="invalid">
                              {validation.errors.purposeOfIssuingDebentures}
                            </FormFeedback>
                          ) : null}
                        </Col>)}

                        {productSettingObj.purposeOfIssuingCommercial && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">
                            Purpose of issuing Commercial Paper?
                          </Label>
                          <Input
                            name="purposeOfIssuingCommercial"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.purposeOfIssuingCommercial || ""}
                            invalid={
                              validation.touched.purposeOfIssuingCommercial &&
                              validation.errors.purposeOfIssuingCommercial
                            }
                          />
                          {validation.touched.purposeOfIssuingCommercial &&
                            validation.errors.purposeOfIssuingCommercial ? (
                            <FormFeedback type="invalid">
                              {validation.errors.purposeOfIssuingCommercial}
                            </FormFeedback>
                          ) : null}
                        </Col>)}

                        {productSettingObj.commercialRatedOrUnrated && (
                          <Col sm="12" md="6">
                            <Label className="form-label mt-4 grey">
                              Whether the Commercial Papers are rated or unrated?
                            </Label>
                            <div className="d-flex ms-4">
                              <div>
                                <Input
                                  type="radio"
                                  id="commercialRatedOrUnrated1"
                                  value="Rated"
                                  onChange={() => { }}
                                  style={{ border: "1px solid black" }}
                                  checked={selectCommercialRatedOrUnrated == "Rated"}
                                  onClick={(event) => {
                                    validation.setFieldValue("commercialRatedOrUnrated", event.target.value);
                                    setSelectCommercialRatedOrUnrated(event.target.value);
                                    setSelectCommercialRatedOrUnratedError("");
                                  }}
                                />
                                <Label
                                  htmlFor="commercialRatedOrUnrated1"
                                  className="ms-2"
                                >
                                  Rated
                                </Label>
                              </div>
                              <div className="ms-4">
                                <Input
                                  type="radio"
                                  id="commercialRatedOrUnrated2"
                                  onChange={() => { }}
                                  value="Unrated"
                                  style={{ border: "1px solid black" }}
                                  checked={selectCommercialRatedOrUnrated == "Unrated"}
                                  onClick={(event) => {
                                    validation.setFieldValue("commercialRatedOrUnrated", event.target.value);
                                    setSelectCommercialRatedOrUnrated(event.target.value);
                                    setSelectCommercialRatedOrUnratedError("");
                                  }}
                                />
                                <Label
                                  htmlFor="commercialRatedOrUnrated2"
                                  className="ms-2"
                                >
                                  Unrated
                                </Label>
                              </div>
                            </div>
                            {selectCommercialRatedOrUnratedError && (
                              <p
                                style={{
                                  color: "rgb(245,116,116)",
                                  fontSize: "11px",
                                }}
                                className="ms-4"
                              >
                                {selectCommercialRatedOrUnratedError}
                              </p>
                            )}
                          </Col>
                        )}

                        {productSettingObj.coupon && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">
                            What is the coupon?
                          </Label>
                          <Input
                            name="coupon"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.coupon || ""}
                            invalid={
                              validation.touched.coupon &&
                              validation.errors.coupon
                            }
                          />
                          {validation.touched.coupon &&
                            validation.errors.coupon ? (
                            <FormFeedback type="invalid">
                              {validation.errors.coupon}
                            </FormFeedback>
                          ) : null}
                        </Col>)}

                        {productSettingObj.poolPSLorNonPSL && (
                          <Col sm="12" md="6">
                            <Label className="form-label mt-4 grey">
                              Whether the pool is securitise as PSL or non PSL?
                            </Label>
                            <div className="d-flex ms-4">
                              <div>
                                <Input
                                  type="radio"
                                  id="poolPSLorNonPS1"
                                  value="PSL"
                                  onChange={() => { }}
                                  style={{ border: "1px solid black" }}
                                  checked={selectPoolPSLorNonPSL == "PSL"}
                                  onClick={(event) => {
                                    validation.setFieldValue("poolPSLorNonPSL", event.target.value);
                                    setSelectpoolPSLorNonPSL(event.target.value);
                                    setSelectpoolPSLorNonPSLError("");
                                  }}
                                />
                                <Label
                                  htmlFor="poolPSLorNonPS1"
                                  className="ms-2"
                                >
                                  PSL
                                </Label>
                              </div>
                              <div className="ms-4">
                                <Input
                                  type="radio"
                                  id="poolPSLorNonPSL2"
                                  onChange={() => { }}
                                  value="Non PSL"
                                  style={{ border: "1px solid black" }}
                                  checked={selectPoolPSLorNonPSL == "Non PSL"}
                                  onClick={(event) => {
                                    validation.setFieldValue("poolPSLorNonPSL", event.target.value);
                                    setSelectpoolPSLorNonPSL(event.target.value);
                                    setSelectpoolPSLorNonPSLError("");
                                  }}
                                />
                                <Label
                                  htmlFor="poolPSLorNonPSL2"
                                  className="ms-2"
                                >
                                  Non PSL
                                </Label>
                              </div>
                            </div>
                            {selectPoolPSLorNonPSLError && (
                              <p
                                style={{
                                  color: "rgb(245,116,116)",
                                  fontSize: "11px",
                                }}
                                className="ms-4"
                              >
                                {selectPoolPSLorNonPSLError}
                              </p>
                            )}
                          </Col>
                        )}

                        {productSettingObj.poolRatedOrUnrated && (
                          <Col sm="12" md="6">
                            <Label className="form-label mt-4 grey">
                              Whether the pool is rated or unrated?
                            </Label>
                            <div className="d-flex ms-4">
                              <div>
                                <Input
                                  type="radio"
                                  id="poolRatedOrUnrated1"
                                  value="Rated"
                                  onChange={() => { }}
                                  style={{ border: "1px solid black" }}
                                  checked={selectPoolRatedOrUnrated == "Rated"}
                                  onClick={(event) => {
                                    validation.setFieldValue("poolRatedOrUnrated", event.target.value);
                                    setSelectpoolRatedOrUnrated(event.target.value);
                                    setSelectpoolRatedOrUnratedError("");
                                  }}
                                />
                                <Label
                                  htmlFor="poolRatedOrUnrated1"
                                  className="ms-2"
                                >
                                  Rated
                                </Label>
                              </div>
                              <div className="ms-4">
                                <Input
                                  type="radio"
                                  id="poolRatedOrUnrated2"
                                  onChange={() => { }}
                                  value="Unrated"
                                  style={{ border: "1px solid black" }}
                                  checked={selectPoolRatedOrUnrated == "Unrated"}
                                  onClick={(event) => {
                                    validation.setFieldValue("poolRatedOrUnrated", event.target.value);
                                    setSelectpoolRatedOrUnrated(event.target.value);
                                    setSelectpoolRatedOrUnratedError("");
                                  }}
                                />
                                <Label
                                  htmlFor="poolRatedOrUnrated2"
                                  className="ms-2"
                                >
                                  Unrated
                                </Label>
                              </div>
                            </div>
                            {selectPoolRatedOrUnratedError && (
                              <p
                                style={{
                                  color: "rgb(245,116,116)",
                                  fontSize: "11px",
                                }}
                                className="ms-4"
                              >
                                {selectPoolRatedOrUnratedError}
                              </p>
                            )}
                          </Col>
                        )}

                        {productSettingObj.desiredCoupon && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">
                            What is the coupon which are looking for?
                          </Label>
                          <Input
                            name="desiredCoupon"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.desiredCoupon || ""}
                            invalid={
                              validation.touched.desiredCoupon &&
                              validation.errors.desiredCoupon
                            }
                          />
                          {validation.touched.desiredCoupon &&
                            validation.errors.desiredCoupon ? (
                            <FormFeedback type="invalid">
                              {validation.errors.desiredCoupon}
                            </FormFeedback>
                          ) : null}
                        </Col>)}

                        {productSettingObj.poolAgeing && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">
                            What is the ageing of the pool(Month/Year)?
                          </Label>
                          <Input
                            name="poolAgeing"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.poolAgeing || ""}
                            invalid={
                              validation.touched.poolAgeing &&
                              validation.errors.poolAgeing
                            }
                          />
                          {validation.touched.poolAgeing &&
                            validation.errors.poolAgeing ? (
                            <FormFeedback type="invalid">
                              {validation.errors.poolAgeing}
                            </FormFeedback>
                          ) : null}
                        </Col>)}

                        {productSettingObj.loan_type && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">Loan Type</Label>
                          <Input
                            name="loanType"
                            type="select"
                            placeholder="Enter Entity constitution"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.loanType || ""}
                            invalid={
                              validation.touched.loanType && validation.errors.loanType
                            }
                          >
                            <option value="" disabled>Select Loan Type</option>
                            {loanTypeList.map((option) => (
                              <option key={option.id} value={option.dropdownValue}>
                                {option.displayName}
                              </option>
                            ))}
                          </Input>
                          {validation.touched.loanType &&
                            validation.errors.loanType ? (
                            <FormFeedback type="invalid">
                              {validation.errors.loanType}
                            </FormFeedback>
                          ) : null}
                        </Col>)}

                        {productSettingObj.is_loan_secured && (
                          <Col sm="12" md="6">
                            <Label className="form-label mt-4 grey">Is Loan Secured?</Label>
                            <div className="d-flex ms-4">
                              <div>
                                <Input
                                  type="radio"
                                  id="isSecured1"
                                  value="Yes"
                                  onChange={() => { }}
                                  checked={selectedIsSecured == 'Yes'}
                                  onClick={handleSecureChange}
                                  style={{ border: "1px solid black" }}
                                />
                                <Label htmlFor="isSecured1" className="ms-2">Yes</Label>
                              </div>
                              <div className="ms-4">
                                <Input
                                  type="radio"
                                  id="isSecured2"
                                  value="No"
                                  onChange={() => { }}
                                  checked={selectedIsSecured == 'No'}
                                  onClick={handleSecureChange}
                                  style={{ border: "1px solid black" }}
                                />
                                <Label htmlFor="isSecured2" className="ms-2">No</Label>
                              </div>
                            </div>
                            {errorSecured && <p style={{ color: 'rgb(245,116,116)', fontSize: "11px" }} className="ms-4">{errorSecured}</p>}
                          </Col>
                        )}

                        {productSettingObj.guarantee && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">Guarantee</Label>
                          <Select
                            name="guarantee"
                            value={selectedMulti1}
                            isMulti={true}
                            onChange={handleMulti1}
                            options={guaranteeList}
                            className="select2-selection"
                          // isDisabled={true}
                          />
                          {validation.touched.guarantee && validation.values.guarantee == "" && <p style={{ color: 'rgb(245,116,116)', fontSize: "11px" }} >{validation.errors.guarantee}</p>}

                        </Col>)}

                        {selectedIsSecured == 'Yes' && productSettingObj.is_loan_secured && (
                          <Col sm="12" md="6">
                            <Label className="form-label mt-4 grey">Security Cover</Label>
                            <Input
                              name="securityCover"
                              type="select"
                              placeholder="Enter Entity constitution"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.securityCover || ""}
                              invalid={
                                validation.touched.securityCover && validation.errors.securityCover
                              }
                            >
                              <option value="" disabled>Select Security Cover</option>
                              {securityCoverList.map((option) => (
                                <option key={option.id} value={option.dropdownValue}>
                                  {option.displayName}
                                </option>
                              ))}
                            </Input>
                            {validation.touched.securityCover &&
                              validation.errors.securityCover ? (
                              <FormFeedback type="invalid">
                                {validation.errors.securityCover}
                              </FormFeedback>
                            ) : null}
                          </Col>
                        )}

                        {productSettingObj.end_use && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">Select End Use</Label>
                          <Select
                            name="endUse"
                            value={selectedMulti2}
                            isMulti={true}
                            onChange={handleMulti2}
                            options={endUseList}
                            className="select2-selection"
                          // isDisabled={true}
                          />
                          {validation.touched.endUse && validation.values.endUse == "" && <p style={{ color: 'rgb(245,116,116)', fontSize: "11px" }} >{validation.errors.endUse}</p>}

                        </Col>)}

                        {productSettingObj.primary_security && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">Select Primary Security Type</Label>
                          <Input
                            name="primarySecurity"
                            type="select"
                            onChange={e => {
                              validation.handleChange(e)
                            }}
                            onBlur={validation.handleBlur}
                            value={validation.values.primarySecurity || ""}
                            invalid={
                              validation.touched.primarySecurity &&
                              validation.errors.primarySecurity
                            }
                          >
                            <option value="" disabled>Select Primary Security Type</option>
                            {primarySecurityList.map((option, index) => (
                              <option key={option.id} value={option.dropdownValue}>
                                {option.displayName}
                              </option>
                            ))}
                          </Input>
                          {validation.touched.primarySecurity &&
                            validation.errors.primarySecurity ? (
                            <FormFeedback type="invalid">
                              {validation.errors.primarySecurity}
                            </FormFeedback>
                          ) : null}
                        </Col>)}

                        {productSettingObj.charge_type && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">What Is The Type of Charge?</Label>
                          <Input
                            name="typeOfCharge"
                            type="select"
                            onChange={e => {
                              validation.handleChange(e)
                            }}
                            onBlur={validation.handleBlur}
                            value={validation.values.typeOfCharge || ""}
                            invalid={
                              validation.touched.typeOfCharge &&
                              validation.errors.typeOfCharge
                            }
                          >
                            <option value="" disabled>Select type of charge</option>
                            {typeOfChargeList.map((option, index) => (
                              <option key={option.id} value={option.dropdownValue}>
                                {option.displayName}
                              </option>
                            ))}
                          </Input>
                          {validation.touched.typeOfCharge &&
                            validation.errors.typeOfCharge ? (
                            <FormFeedback type="invalid">
                              {validation.errors.typeOfCharge}
                            </FormFeedback>
                          ) : null}
                        </Col>)}

                        {productSettingObj.cma_documents && (<Col sm="12" md="6" >
                          <DynamicFileUploadInput
                            label={'Upload CMA Documents'}
                            inputName={'cmaDoc'}
                            onDropHandler={(acceptedFiles) => onDropForInput2('cmaDoc', acceptedFiles)}
                            isDragActive={true}
                            validation={validation}
                            uploadProgress={uploadProgressCma}
                            errorMessage={errorMessageCma}
                            deal={entity}
                          />
                        </Col>)}

                        {productSettingObj.equipment_category && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">Equipment Category</Label>
                          <div className="d-flex ms-4">
                            <div className="d-flex">
                              <Input
                                type="radio"
                                id="equipmentCategory1"
                                onChange={() => { }}
                                style={{ border: "1px solid black" }}
                                value="Construction Equipment"
                                checked={selectedEquipment == 'Construction Equipment'}
                                onClick={handleEquipmetChange}
                              />
                              <Label htmlFor="equipmentCategory1" className="ms-2">Construction Equipment</Label>
                            </div>
                            <div className="ms-4 d-flex">
                              <Input
                                type="radio"
                                id="equipmentCategory2"
                                onChange={() => { }}
                                style={{ border: "1px solid black" }}
                                value="Industrial Equipment"
                                checked={selectedEquipment == 'Industrial Equipment'}
                                onClick={handleEquipmetChange}
                              />
                              <Label htmlFor="equipmentCategory2" className="ms-2">Industrial Equipment</Label>
                            </div>
                            <div className="ms-4 d-flex">
                              <Input
                                type="radio"
                                id="equipmentCategory3"
                                onChange={() => { }}
                                style={{ border: "1px solid black" }}
                                value="Medical Equipment"
                                checked={selectedEquipment == 'Medical Equipment'}
                                onClick={handleEquipmetChange}
                              />
                              <Label htmlFor="equipmentCategory3" className="ms-2">Medical Equipment</Label>
                            </div>
                          </div>
                          {equipmentError && <p style={{ color: 'rgb(245,116,116)', fontSize: "11px" }} className="ms-4">{equipmentError}</p>}
                        </Col>)}

                        {productSettingObj.equipment_sub_category && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">Equipment Sub-category</Label>
                          <div className="ms-4">
                            <div className="d-flex">
                              <Input
                                type="radio"
                                id="equipmentSubCategory1"
                                onChange={() => { }}
                                style={{ border: "1px solid black" }}
                                value="Very Strong/ Deep secondary market/ Very good resale value/ Market"
                                checked={selectedSubEquipment == 'Very Strong/ Deep secondary market/ Very good resale value/ Market'}
                                onClick={handleSubEquipmetChange}
                              />
                              <Label htmlFor="equipmentSubCategory1" className="ms-2">Category A
                                {' '}
                                <span><p style={{ fontSize: "11px", color: "grey" }}>Very Strong/ Deep secondary market/ Very good resale value/ Market</p></span>
                              </Label>
                            </div>
                            <div className="d-flex">
                              <Input
                                type="radio"
                                id="equipmentSubCategory2"
                                onChange={() => { }}
                                style={{ border: "1px solid black" }}
                                value="Strong/ Deep secondary market/ Good resale value"
                                checked={selectedSubEquipment == 'Strong/ Deep secondary market/ Good resale value'}
                                onClick={handleSubEquipmetChange}
                              />
                              <Label htmlFor="equipmentSubCategory2" className="ms-2">Category B
                                {' '}
                                <span><p style={{ fontSize: "11px", color: "grey" }}>Strong/ Deep secondary market/ Good resale value</p></span>
                              </Label>
                            </div>
                            <div className="d-flex">
                              <Input
                                type="radio"
                                id="equipmentSubCategory3"
                                onChange={() => { }}
                                style={{ border: "1px solid black" }}
                                value="Reasonably good secondary market but lower resale values as compared to Category B asset"
                                checked={selectedSubEquipment == 'Reasonably good secondary market but lower resale values as compared to Category B asset'}
                                onClick={handleSubEquipmetChange}
                              />
                              <Label htmlFor="equipmentSubCategory3" className="ms-2">Category C
                                {' '}
                                <span><p style={{ fontSize: "11px", color: "grey" }}>Reasonably good secondary market but lower resale values as compared to Category B asset</p></span>
                              </Label>
                            </div>
                          </div>
                          {subEquipmentError && <p style={{ color: 'rgb(245,116,116)', fontSize: "11px" }} className="ms-4">{subEquipmentError}</p>}
                        </Col>)}

                        {productSettingObj.equipment_type && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">Equipment Type</Label>
                          <div className="d-flex ms-4">
                            <div>
                              <Input
                                type="radio"
                                id="equipmentType1"
                                onChange={() => { }}
                                style={{ border: "1px solid black" }}
                                value="New"
                                checked={selectedEquipmentType == 'New'}
                                onClick={handleEquipmetTypeChange}
                              />
                              <Label htmlFor="equipmentType1" className="ms-2">New</Label>
                            </div>
                            <div className="ms-4">
                              <Input
                                type="radio"
                                id="equipmentType2"
                                onChange={() => { }}
                                style={{ border: "1px solid black" }}
                                value="Used"
                                checked={selectedEquipmentType == 'Used'}
                                onClick={handleEquipmetTypeChange}
                              />
                              <Label htmlFor="equipmentType2" className="ms-2">Used</Label>
                            </div>
                          </div>
                          {equipmentTypeError && <p style={{ color: 'rgb(245,116,116)', fontSize: "11px" }} className="ms-4">{equipmentTypeError}</p>}
                        </Col>)}

                        {productSettingObj.bank_name && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">Select Bank Name</Label>
                          <Select
                            options={bankList}
                            className={`select-dropdown ${validation.touched.bankName &&
                              validation.errors.bankName
                              ? "is-invalid"
                              : ""
                              }`}
                            name="bankName"
                            id="bankName"
                            placeholder={"Select Bank Name"}
                            value={selectedBankName}
                            onChange={(selectedOption) => {
                              handleBankChange(selectedOption);
                            }}
                          />
                          {validation.touched.bankName &&
                            validation.errors.bankName && (
                              <FormFeedback>
                                {validation.errors.bankName}
                              </FormFeedback>
                            )}
                        </Col>)}

                        {productSettingObj.bank_statement && (<Col lg='6' sm='12'>
                          <DynamicFileUploadInput
                            label={'Upload Bank Statement'}
                            inputName={'bankStatement'}
                            onDropHandler={(acceptedFiles) => onDropForInput1('bankStatement', acceptedFiles)}
                            isDragActive={true}
                            validation={validation}
                            uploadProgress={uploadProgressBankStat}
                            errorMessage={errorMessageBankStat}
                            deal={entity}
                          />
                        </Col>)}

                        {productSettingObj.statement_password && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">Is Bank Statement Password Protected?</Label>
                          <div className="d-flex ms-4">
                            <div>
                              <Input
                                type="radio"
                                id="pass1"
                                onChange={() => { }}
                                style={{ border: "1px solid black" }}
                                value="Yes"
                                checked={isPasswordBankStatement == 'Yes'}
                                onClick={handlePasswordChange}
                              />
                              <Label htmlFor="pass1" className="ms-2">Yes</Label>
                            </div>
                            <div className="ms-4">
                              <Input
                                type="radio"
                                id="pass2"
                                onChange={() => { }}
                                style={{ border: "1px solid black" }}
                                value="No"
                                checked={isPasswordBankStatement == 'No'}
                                onClick={handlePasswordChange}
                              />
                              <Label htmlFor="pass2" className="ms-2">No</Label>
                            </div>
                          </div>
                          {isPasswordError && <p style={{ color: 'rgb(245,116,116)', fontSize: "11px" }} className="ms-4">{isPasswordError}</p>}
                        </Col>)}

                        {isPasswordBankStatement == "Yes" && productSettingObj.statement_password && (
                          <Col sm="12" md="6">
                            <Label className="form-label mt-4 grey">Enter Bank Statement Password</Label>
                            <Input
                              name="bankStatementPassword"
                              type="text"
                              placeholder={'Enter Bank Statement Password'}
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.bankStatementPassword || ""}
                              invalid={validation.touched.bankStatementPassword && validation.errors.bankStatementPassword}
                            />
                            {validation.touched.bankStatementPassword && validation.errors.bankStatementPassword ? (
                              <FormFeedback type="invalid">{validation.errors.bankStatementPassword}</FormFeedback>
                            ) : null}
                          </Col>
                        )}

                        {productSettingObj.property_list && (<Col lg='12' sm='12'>
                          <FieldArray
                            name="propertyInfo"
                            render={(arrayHelpers) => (
                              <>
                                {validation.values.propertyInfo?.map(
                                  (file, index) => (
                                    <TableRow
                                      key={file.id}
                                      onDelete={handleDelete}
                                      index={index}
                                      validation={validation}
                                      entity={entity}
                                    />
                                  )
                                )}
                                <span
                                  className="text-success"
                                  style={{ cursor: "pointer" }}
                                  onKeyUp={() => { }}
                                  onClick={() => {
                                    arrayHelpers.push({
                                      id: uId(),
                                      propertyNature: "",
                                      propertyOwner: "",
                                      propertyStatus: "",
                                      propertyValue: "",
                                      propertyAge: "",
                                      address: "",
                                      city: "",
                                      pincode: "",
                                      state: "",
                                      parentDeed: "",
                                      saleDeed: "",
                                      utilityBills: "",
                                      propertyTax: ""
                                    });
                                  }}
                                >
                                  <i className="mdi mdi-plus me-1" /> Add
                                  Property
                                </span>
                              </>
                            )}
                          />
                        </Col>)}

                        {productSettingObj.other_income_source && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">Is there An Income source other Than that declared In the income tax returns that may contribute to the repayment of this loan?</Label>
                          <div className="d-flex ms-4">
                            <div>
                              <Input
                                type="radio"
                                id="pass3"
                                onChange={() => { }}
                                style={{ border: "1px solid black" }}
                                value="Yes"
                                checked={isOtherIncomeSource == 'Yes'}
                                onClick={handleIncomeChange}
                              />
                              <Label htmlFor="pass3" className="ms-2">Yes</Label>
                            </div>
                            <div className="ms-4">
                              <Input
                                type="radio"
                                id="pass4"
                                onChange={() => { }}
                                style={{ border: "1px solid black" }}
                                value="No"
                                checked={isOtherIncomeSource == 'No'}
                                onClick={handleIncomeChange}
                              />
                              <Label htmlFor="pass4" className="ms-2">No</Label>
                            </div>
                          </div>
                          {isIncomeError && <p style={{ color: 'rgb(245,116,116)', fontSize: "11px" }} className="ms-4">{isIncomeError}</p>}
                        </Col>)}

                        {isOtherIncomeSource == "Yes" && productSettingObj.other_income_source && (
                          <Col sm="12" md="6">
                            <Label className="form-label mt-4 grey">If Yes Income Amount</Label>
                            <Input
                              name="otherIncomeAmount"
                              type="text"
                              placeholder={'Enter Income Amount'}
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.otherIncomeAmount || ""}
                              invalid={validation.touched.otherIncomeAmount && validation.errors.otherIncomeAmount}
                            />
                            {validation.touched.otherIncomeAmount && validation.errors.otherIncomeAmount ? (
                              <FormFeedback type="invalid">{validation.errors.otherIncomeAmount}</FormFeedback>
                            ) : null}
                          </Col>
                        )}

                        {productSettingObj.co_borrower && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">Is There Co-borrower For This Loan?</Label>
                          <div className="d-flex ms-4">
                            <div>
                              <Input
                                type="radio"
                                id="coBorrower1"
                                onChange={() => { }}
                                style={{ border: "1px solid black" }}
                                value="Yes"
                                checked={isCoBorrower == 'Yes'}
                                onClick={handleCoBorrowerChange}
                              />
                              <Label htmlFor="coBorrower1" className="ms-2">Yes</Label>
                            </div>
                            <div className="ms-4">
                              <Input
                                type="radio"
                                id="coBorrower2"
                                onChange={() => { }}
                                style={{ border: "1px solid black" }}
                                value="No"
                                checked={isCoBorrower == 'No'}
                                onClick={handleCoBorrowerChange}
                              />
                              <Label htmlFor="coBorrower2" className="ms-2">No</Label>
                            </div>
                          </div>
                          {isCoBorrowerError && <p style={{ color: 'rgb(245,116,116)', fontSize: "11px" }} className="ms-4">{isCoBorrowerError}</p>}
                        </Col>)}

                        {isCoBorrower == "Yes" && productSettingObj.co_borrower && (
                          <>
                            <Col sm="12" md="6">
                              <Label className="form-label mt-4 grey">Enter Name of The Co-borrower</Label>
                              <Input
                                name="coBorrowerName"
                                type="text"
                                placeholder={'Enter Name of The Co-borrower'}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.coBorrowerName || ""}
                                invalid={validation.touched.coBorrowerName && validation.errors.coBorrowerName}
                              />
                              {validation.touched.coBorrowerName && validation.errors.coBorrowerName ? (
                                <FormFeedback type="invalid">{validation.errors.coBorrowerName}</FormFeedback>
                              ) : null}
                            </Col>

                            <Col sm="12" md="6">
                              <Label className="form-label mt-4 grey">D.O.B of The Co-borrower</Label>
                              <Input
                                name="coBorrowerDob"
                                type="date"
                                placeholder={'Enter Name of The Co-borrower'}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.coBorrowerDob || ""}
                                invalid={validation.touched.coBorrowerDob && validation.errors.coBorrowerDob}
                              />
                              {validation.touched.coBorrowerDob && validation.errors.coBorrowerDob ? (
                                <FormFeedback type="invalid">{validation.errors.coBorrowerDob}</FormFeedback>
                              ) : null}
                            </Col>

                            <Col>
                              <Label className="form-label mt-4 grey">Select the relationship with the co-borrower</Label>
                              <Input
                                type="select"
                                placeholder="Select Relationship With The Co-borrower"
                                name={'coBorrowerRelation'}
                                id={'coBorrowerRelation'}
                                value={validation.values.coBorrowerRelation}
                                onChange={e => validation.handleChange(e)}
                                invalid={
                                  !!(validation.touched.coBorrowerRelation &&
                                    validation.errors.coBorrowerRelation)
                                }
                              >
                                <option value="" disabled>Select Relationship With The Co-borrower</option>
                                {coBorrowerOfPropList.map((option, index) => (
                                  <option key={option.id} value={option.dropdownValue}>
                                    {option.displayName}
                                  </option>
                                ))}
                              </Input>

                              {validation.touched.coBorrowerRelation &&
                                validation.errors.coBorrowerRelation && (
                                  <FormFeedback>
                                    {validation.errocoBorrowerRelation}
                                  </FormFeedback>
                                )}
                            </Col>

                            <Col sm="12" md="6">
                              <Label className="form-label mt-4 grey">Enter PAN No. of The Co-borrower</Label>
                              <Input
                                name="coBorrowerPanNumber"
                                type="text"
                                placeholder={'Enter PAN No. of The Co-borrower'}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.coBorrowerPanNumber || ""}
                                invalid={validation.touched.coBorrowerPanNumber && validation.errors.coBorrowerPanNumber}
                              />
                              {validation.touched.coBorrowerPanNumber && validation.errors.coBorrowerPanNumber ? (
                                <FormFeedback type="invalid">{validation.errors.coBorrowerPanNumber}</FormFeedback>
                              ) : null}
                            </Col>

                            <Col sm="12" md="6">
                              <Label className="form-label mt-4 grey">Income Type of The Co-borrower</Label>
                              <div className="d-flex ms-4">
                                <div>
                                  <Input
                                    type="radio"
                                    id="incomeType1"
                                    onChange={() => { }}
                                    style={{ border: "1px solid black" }}
                                    value="Salary"
                                    checked={coBorrowerIncomeType == 'Salary'}
                                    onClick={handleIncomeTypeChange}
                                  />
                                  <Label htmlFor="incomeType1" className="ms-2">Salary</Label>
                                </div>
                                <div className="ms-4">
                                  <Input
                                    type="radio"
                                    id="incomeType2"
                                    onChange={() => { }}
                                    style={{ border: "1px solid black" }}
                                    value="Business"
                                    checked={coBorrowerIncomeType == 'Business'}
                                    onClick={handleIncomeTypeChange}
                                  />
                                  <Label htmlFor="incomeType2" className="ms-2">Business</Label>
                                </div>
                                <div className="ms-4">
                                  <Input
                                    type="radio"
                                    id="incomeType2"
                                    onChange={() => { }}
                                    style={{ border: "1px solid black" }}
                                    value="Other"
                                    checked={coBorrowerIncomeType == 'Other'}
                                    onClick={handleIncomeTypeChange}
                                  />
                                  <Label htmlFor="incomeType2" className="ms-2">Other</Label>
                                </div>
                              </div>
                              {incomeCoBorrowerError && <p style={{ color: 'rgb(245,116,116)', fontSize: "11px" }} className="ms-4">{incomeCoBorrowerError}</p>}
                            </Col>

                            <Col lg='6' sm='12'>
                              <DynamicFileUploadInput
                                label={'Attach PAN'}
                                inputName={'coBorrowerPan'}
                                onDropHandler={(acceptedFiles) => onDropForInput3('coBorrowerPan', acceptedFiles)}
                                isDragActive={true}
                                validation={validation}
                                uploadProgress={uploadProgressCoBoPan}
                                errorMessage={errorMessageCoBoPan}
                                deal={entity}
                              />
                            </Col>

                            <Col lg='6' sm='12'>
                              <DynamicFileUploadInput
                                label={'Income Tax Returns of The Co-borrower'}
                                inputName={'coBorrowerItr'}
                                onDropHandler={(acceptedFiles) => onDropForInput4('coBorrowerItr', acceptedFiles)}
                                isDragActive={true}
                                validation={validation}
                                uploadProgress={uploadProgressCoBoItr}
                                errorMessage={errorMessageCoBoItr}
                                deal={entity}
                              />
                            </Col>
                          </>


                        )}

                        {productSettingObj.dealer_credit_period && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">Is there a credit period being offered to dealers and distributors?</Label>
                          <div className="d-flex ms-4">
                            <div>
                              <Input
                                type="radio"
                                id="option1"
                                value="Yes"
                                onChange={() => { }}
                                checked={selectedOption == 'Yes'}
                                onClick={handleOptionChange}
                                style={{ border: "1px solid black" }}
                              />
                              <Label htmlFor="option1" className="ms-2">Yes</Label>
                            </div>
                            <div className="ms-4">
                              <Input
                                type="radio"
                                id="option2"
                                value="No"
                                onChange={() => { }}
                                checked={selectedOption == 'No'}
                                onClick={handleOptionChange}
                                style={{ border: "1px solid black" }}
                              />
                              <Label htmlFor="option2" className="ms-2">No</Label>
                            </div>
                          </div>
                          {error && <p style={{ color: 'rgb(245,116,116)', fontSize: "11px" }} className="ms-4">{error}</p>}
                        </Col>)}

                        {selectedOption == "Yes" && productSettingObj.dealer_credit_period && (
                          <Col sm="12" md="6">
                            <Label className="form-label mt-4 grey">What is the average credit period currently offered? (in days)</Label>
                            <Input
                              name="creditPeriod"
                              type="text"
                              onBlur={validation.handleBlur}
                              onChange={validation.handleChange}
                              value={validation.values.creditPeriod || ""}
                              invalid={validation.touched.creditPeriod && validation.errors.creditPeriod}
                            />
                            {validation.touched.creditPeriod && validation.errors.creditPeriod ? (
                              <FormFeedback type="invalid">{validation.errors.creditPeriod}</FormFeedback>
                            ) : null}
                          </Col>
                        )}

                        {productSettingObj.business_requirement2 && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">What is the Business Requirement?</Label>
                          <div className="ms-4">
                            <div>
                              <Input
                                type="radio"
                                id="BusinessRequirement1"
                                onChange={() => { }}
                                value="Greater channel coverage"
                                checked={selectedBusinessRequirement == 'Greater channel coverage'}
                                onClick={handleBusinessRequirement}
                                style={{ width: "15px", height: "15px", border: "1px solid black" }}
                              />
                              <Label htmlFor="BusinessRequirement1" className="ms-2">Greater channel coverage
                                {' '}
                                <span><p style={{ fontSize: "11px", color: "grey" }}>to increase sales</p></span>
                              </Label>
                            </div>
                            <div>
                              <Input
                                type="radio"
                                id="BusinessRequirement2"
                                onChange={() => { }}
                                value="Reduce my Days Sales Outstanding (DSO)"
                                checked={selectedBusinessRequirement == 'Reduce my Days Sales Outstanding (DSO)'}
                                onClick={handleBusinessRequirement}
                                style={{ width: "15px", height: "15px", border: "1px solid black" }}
                              />
                              <Label htmlFor="BusinessRequirement2" className="ms-2">Reduce my Days Sales Outstanding (DSO)
                                {' '}
                                <span><p style={{ fontSize: "11px", color: "grey" }}>to meet working capital needs</p></span>
                              </Label>
                            </div>
                            <div>
                              <Input
                                type="radio"
                                id="BusinessRequirement3"
                                value="Reduce my credit risk"
                                onChange={() => { }}
                                checked={selectedBusinessRequirement == 'Reduce my credit risk'}
                                onClick={handleBusinessRequirement}
                                style={{ width: "15px", height: "15px", border: "1px solid black" }}
                              />
                              <Label htmlFor="BusinessRequirement3" className="ms-2">Reduce my credit risk
                                {' '}
                                <span><p style={{ fontSize: "11px", color: "grey" }}>by receiving early payment for my sales proceeds</p></span>
                              </Label>
                            </div>
                            <div>
                              <Input
                                type="radio"
                                id="BusinessRequirement4"
                                onChange={() => { }}
                                value="Deleverage my balance sheet"
                                checked={selectedBusinessRequirement == 'Deleverage my balance sheet'}
                                onClick={handleBusinessRequirement}
                                style={{ width: "15px", height: "15px", border: "1px solid black" }}
                              />
                              <Label htmlFor="BusinessRequirement4" className="ms-2">Deleverage my balance sheet
                                {' '}
                                <span><p style={{ fontSize: "11px", color: "grey" }}>and reduce my working capital requirement</p></span>
                              </Label>
                            </div>
                          </div>
                          {errorBusiness && <p style={{ color: 'rgb(245,116,116)', fontSize: "11px" }} className="ms-4">{errorBusiness}</p>}
                        </Col>)}

                        {productSettingObj.existing_dealer_financing && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">Is there an existing dealer financing arrangement?</Label>
                          <div className="d-flex ms-4">
                            <div>
                              <Input
                                type="radio"
                                id="dealerfinancingArrangement1"
                                value="Yes"
                                onChange={() => { }}
                                checked={dealerfinancingArrangement == 'Yes'}
                                onClick={handledealerfinancingArrangement}
                                style={{ border: "1px solid black" }}
                              />
                              <Label htmlFor="financingArrangement1" className="ms-2">Yes</Label>
                            </div>
                            <div className="ms-4">
                              <Input
                                type="radio"
                                id="financingArrangement2"
                                value="No"
                                onChange={() => { }}
                                checked={dealerfinancingArrangement == 'No'}
                                onClick={handledealerfinancingArrangement}
                                style={{ border: "1px solid black" }}
                              />
                              <Label htmlFor="financingArrangemen2" className="ms-2">No</Label>
                            </div>
                          </div>
                          {errorfinancing && <p style={{ color: 'rgb(245,116,116)', fontSize: "11px" }} className="ms-4">{errorfinancing}</p>}
                        </Col>)}

                        {dealerfinancingArrangement == "Yes" && productSettingObj.existing_dealer_financing && (
                          <Col sm="12" md="6">
                            <Label className="form-label mt-4 grey">Select the entity types with which arrangements have been made</Label>
                            <Select
                              name="dealerArrangement"
                              value={selectedMulti3}
                              isMulti={true}
                              onChange={handleMulti3}
                              options={entityArrangeList}
                              className="select2-selection"
                            />
                            {validation.values.dealerArrangement == "" && <p style={{ color: 'rgb(245,116,116)', fontSize: "11px" }} >{validation.errors.dealerArrangement}</p>}

                          </Col>
                        )}

                        {dealerfinancingArrangement == "Yes" && productSettingObj.existing_dealer_financing && (
                          <Col sm="12" md="6">
                            <Label className="form-label mt-4 grey">What Percentage Of Dealers Are Covered By The Existing Arrangement?</Label>
                            <Input
                              name="percentageCovered"
                              type="text"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.percentageCovered || ""}
                              invalid={validation.touched.percentageCovered && validation.errors.percentageCovered}
                            />
                            {validation.touched.percentageCovered && validation.errors.percentageCovered ? (
                              <FormFeedback type="invalid">{validation.errors.percentageCovered}</FormFeedback>
                            ) : null}
                          </Col>
                        )}

                        {productSettingObj.geographical_sales_distribution && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">How Is Sale Distributed Geographically?</Label>
                          {validation.errors.total ? (
                            <p style={{ color: 'rgb(245,116,116)', fontSize: "11px" }}>{validation.errors.total}</p>
                          ) : null}
                          <div style={{ width: "50%" }}>
                            <div className="mt-2">
                              <Input
                                name="north"
                                type="text"
                                onChange={validation.handleChange}
                                placeholder="North Sales"
                                onBlur={validation.handleBlur}
                                value={validation.values.north || ""}
                                invalid={validation.touched.north && validation.errors.north}
                              />
                              {validation.touched.north && validation.errors.north ? (
                                <FormFeedback type="invalid">{validation.errors.north}</FormFeedback>
                              ) : null}
                            </div>

                            <div className="mt-2">
                              <Input
                                name="south"
                                type="text"
                                placeholder="South Sales"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.south || ""}
                                invalid={validation.touched.south && validation.errors.south}
                              />
                              {validation.touched.south && validation.errors.south ? (
                                <FormFeedback type="invalid">{validation.errors.south}</FormFeedback>
                              ) : null}
                            </div>

                            <div className="mt-2">
                              <Input
                                name="east"
                                type="text"
                                placeholder="East Sales"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.east || ""}
                                invalid={validation.touched.east && validation.errors.east}
                              />
                              {validation.touched.east && validation.errors.east ? (
                                <FormFeedback type="invalid">{validation.errors.east}</FormFeedback>
                              ) : null}
                            </div>

                            <div className="mt-2">
                              <Input
                                name="west"
                                type="text"
                                placeholder="West Sales"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.west || ""}
                                invalid={validation.touched.west && validation.errors.west}
                              />
                              {validation.touched.west && validation.errors.west ? (
                                <FormFeedback type="invalid">{validation.errors.west}</FormFeedback>
                              ) : null}
                            </div>
                          </div>
                        </Col>)}

                        {productSettingObj.dealer_cash_discounts && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">Is cash discount provided to dealers and distributors?</Label>
                          <div className="d-flex ms-4">
                            <div>
                              <Input
                                type="radio"
                                id="cashDiscount1"
                                value="Yes"
                                onChange={() => { }}
                                checked={cashDiscount == 'Yes'}
                                onClick={handleCashDiscount}
                                style={{ border: "1px solid black" }}
                              />
                              <Label htmlFor="cashDiscount1" className="ms-2">Yes</Label>
                            </div>
                            <div className="ms-4">
                              <Input
                                type="radio"
                                id="cashDiscount2"
                                value="No"
                                onChange={() => { }}
                                checked={cashDiscount == 'No'}
                                onClick={handleCashDiscount}
                                style={{ border: "1px solid black" }}
                              />
                              <Label htmlFor="cashDiscount2" className="ms-2">No</Label>
                            </div>
                          </div>
                          {errorCashDiscount && <p style={{ color: 'rgb(245,116,116)', fontSize: "11px" }} className="ms-4">{errorCashDiscount}</p>}
                        </Col>)}

                        {productSettingObj.default_guarantee_offer_fldg && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">Would a first loss default guarantee (FLDG) be offered to the lender?</Label>
                          <div className="d-flex ms-4">
                            <div>
                              <Input
                                type="radio"
                                id="fldg1"
                                onChange={() => { }}
                                value="Yes"
                                checked={selectedFldg == 'Yes'}
                                onClick={handleFldgChange}
                                style={{ border: "1px solid black" }}
                              />
                              <Label htmlFor="fldg1" className="ms-2">Yes</Label>
                            </div>
                            <div className="ms-4">
                              <Input
                                type="radio"
                                id="fldg2"
                                value="No"
                                onChange={() => { }}
                                checked={selectedFldg == 'No'}
                                onClick={handleFldgChange}
                                style={{ border: "1px solid black" }}
                              />
                              <Label htmlFor="fldg2" className="ms-2">No</Label>
                            </div>
                          </div>
                          {errorFldg && <p style={{ color: 'rgb(245,116,116)', fontSize: "11px" }} className="ms-4">{errorFldg}</p>}
                        </Col>)}

                        {selectedFldg == "Yes" && productSettingObj.default_guarantee_offer_fldg && (
                          <Col sm="12" md="6">
                            <Label className="form-label mt-4 grey">Please mention the maximum percentage of FLDG willing to be provided</Label>
                            <Input
                              name="fldg"
                              type="text"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.fldg || ""}
                              invalid={validation.touched.fldg && validation.errors.fldg}
                            />
                            {validation.touched.fldg && validation.errors.fldg ? (
                              <FormFeedback type="invalid">{validation.errors.fldg}</FormFeedback>
                            ) : null}
                          </Col>
                        )}

                        {productSettingObj.monthly_sales && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">What Is The Value of Monthly Sales?</Label>
                          <Input
                            name="monthlySales"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.monthlySales || ""}
                            invalid={validation.touched.monthlySales && validation.errors.monthlySales}
                          />
                          {validation.touched.monthlySales && validation.errors.monthlySales ? (
                            <FormFeedback type="invalid">{validation.errors.monthlySales}</FormFeedback>
                          ) : null}
                        </Col>)}

                        {productSettingObj.vendor_payment_schedule && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">When are the vendors currently paid?</Label>
                          <div>
                            <div className="ms-4">
                              <Input
                                type="radio"
                                id="vendorPays1"
                                onChange={() => { }}
                                value="On/before the receipt of goods and services"
                                checked={vendorPays == 'On/before the receipt of goods and services'}
                                onClick={handlevendorPays}
                                style={{ border: "1px solid black" }}
                              />
                              <Label htmlFor="vendorPays1" className="ms-2">On/before the receipt of goods and services</Label>
                            </div>
                            <div className="ms-4">
                              <Input
                                type="radio"
                                id="vendorPays2"
                                onChange={() => { }}
                                value="After the receipt of goods and services"
                                checked={vendorPays == 'After the receipt of goods and services'}
                                onClick={handlevendorPays}
                                style={{ border: "1px solid black" }}
                              />
                              <Label htmlFor="vendorPays2" className="ms-2">After the receipt of goods and services</Label>
                            </div>
                          </div>
                          {errorvendorPays && <p style={{ color: 'rgb(245,116,116)', fontSize: "11px" }} className="ms-4">{errorvendorPays}</p>}
                        </Col>)}

                        {productSettingObj.business_requirement && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">What is the Business Requirement?</Label>
                          <div className="ms-4">
                            <div>
                              <Input
                                type="radio"
                                id="BusinessRequirement5"
                                value="Deleverage my balance sheet"
                                onChange={() => { }}
                                checked={selectedBusinessRequirement == 'Deleverage my balance sheet'}
                                onClick={handleBusinessRequirement}
                                style={{ width: "15px", height: "15px", border: "1px solid black" }}
                              />
                              <Label htmlFor="BusinessRequirement5" className="ms-2">Deleverage my balance sheet
                                {' '}
                                <span><p style={{ fontSize: "11px", color: "grey" }}>and reduce my working capital requirement</p></span>
                              </Label>
                            </div>
                            <div>
                              <Input
                                type="radio"
                                id="BusinessRequirement6"
                                value="Extend Days Payable Outstanding(DPO)"
                                onChange={() => { }}
                                checked={selectedBusinessRequirement == 'Extend Days Payable Outstanding(DPO)'}
                                onClick={handleBusinessRequirement}
                                style={{ width: "15px", height: "15px", border: "1px solid black" }}
                              />
                              <Label htmlFor="BusinessRequirement6" className="ms-2">Extend Days Payable Outstanding(DPO)
                                {' '}
                                <span><p style={{ fontSize: "11px", color: "grey" }}>to reduce my working capital cycle</p></span>
                              </Label>
                            </div>
                            <div>
                              <Input
                                type="radio"
                                id="BusinessRequirement7"
                                value="Improve profit margins"
                                onChange={() => { }}
                                checked={selectedBusinessRequirement == 'Improve profit margins'}
                                onClick={handleBusinessRequirement}
                                style={{ width: "15px", height: "15px", border: "1px solid black" }}
                              />
                              <Label htmlFor="BusinessRequirement7" className="ms-2">Improve profit margins
                                {' '}
                                <span><p style={{ fontSize: "11px", color: "grey" }}>by getting a cash discount from vendors for early payments</p></span>
                              </Label>
                            </div>
                            <div>
                              <Input
                                type="radio"
                                id="BusinessRequirement8"
                                value="Offer lucrative payment terms"
                                onChange={() => { }}
                                checked={selectedBusinessRequirement == 'Offer lucrative payment terms'}
                                onClick={handleBusinessRequirement}
                                style={{ width: "15px", height: "15px", border: "1px solid black" }}
                              />
                              <Label htmlFor="BusinessRequirement8" className="ms-2">Offer lucrative payment terms
                                {' '}
                                <span><p style={{ fontSize: "11px", color: "grey" }}>to attract vendors by making early payments</p></span>
                              </Label>
                            </div>
                          </div>
                          {errorBusiness && <p style={{ color: 'rgb(245,116,116)', fontSize: "11px" }} className="ms-4">{errorBusiness}</p>}
                        </Col>)}

                        {isSelectedDpo && productSettingObj.business_requirement && (
                          <>
                            <Col sm="12" md="6">
                              <Label className="form-label mt-4 grey">If the lender disburses on Day 1, what cash discount would be received from vendors?</Label>
                              <Input
                                name="vendorDiscount"
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.vendorDiscount || ""}
                                invalid={validation.touched.vendorDiscount && validation.errors.vendorDiscount}
                              />
                              {validation.touched.vendorDiscount && validation.errors.vendorDiscount ? (
                                <FormFeedback type="invalid">{validation.errors.vendorDiscount}</FormFeedback>
                              ) : null}
                            </Col>

                            <Col sm="12" md="6">
                              <Label className="form-label mt-4 grey">By how many days would the DPO be extended?</Label>
                              <Input
                                name="extendDpoDays"
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.extendDpoDays || ""}
                                invalid={validation.touched.extendDpoDays && validation.errors.extendDpoDays}
                              />
                              {validation.touched.extendDpoDays && validation.errors.extendDpoDays ? (
                                <FormFeedback type="invalid">{validation.errors.extendDpoDays}</FormFeedback>
                              ) : null}
                            </Col>
                          </>
                        )}

                        {productSettingObj.existing_vendor_financing && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">Is there an existing vendor financing arrangement?</Label>
                          <div className="d-flex ms-4">
                            <div>
                              <Input
                                type="radio"
                                id="financingArrangement3"
                                value="Yes"
                                onChange={() => { }}
                                checked={vendorfinancingArrangement == 'Yes'}
                                onClick={handlevendorfinancingArrangement}
                                style={{ border: "1px solid black" }}
                              />
                              <Label htmlFor="financingArrangement3" className="ms-2">Yes</Label>
                            </div>
                            <div className="ms-4">
                              <Input
                                type="radio"
                                id="financingArrangement4"
                                value="No"
                                onChange={() => { }}
                                checked={vendorfinancingArrangement == 'No'}
                                onClick={handlevendorfinancingArrangement}
                                style={{ border: "1px solid black" }}
                              />
                              <Label htmlFor="financingArrangemen4" className="ms-2">No</Label>
                            </div>
                          </div>
                          {errorfinancingVendor && <p style={{ color: 'rgb(245,116,116)', fontSize: "11px" }} className="ms-4">{errorfinancingVendor}</p>}
                        </Col>)}

                        {vendorfinancingArrangement == "Yes" && productSettingObj.existing_vendor_financing && (
                          <Col sm="12" md="6">
                            <Label className="form-label mt-4 grey">Select the entity types with which arrangements have been made</Label>
                            <Select
                              name="vendorsArrangement"
                              value={selectedMulti4}
                              isMulti={true}
                              onChange={handleMulti4}
                              options={entityArrangeListForVendor}
                              className="select2-selection"
                            // isDisabled={true}
                            />
                            {validation.values.vendorsArrangement == "" && <p style={{ color: 'rgb(245,116,116)', fontSize: "11px" }} >{validation.errors.vendorsArrangement}</p>}
                          </Col>
                        )}

                        {productSettingObj.guarantee_offer_to_lender && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">Willing to provide any guarantee to the lender?</Label>
                          <div className="d-flex ms-4">
                            <div>
                              <Input
                                type="radio"
                                id="isGuaranteeLender1"
                                value="Yes"
                                onChange={() => { }}
                                checked={selectedGuarantee == 'Yes'}
                                onClick={handleGuaranteeChange}
                                style={{ border: "1px solid black" }}
                              />
                              <Label htmlFor="isGuaranteeLender1" className="ms-2">Yes</Label>
                            </div>
                            <div className="ms-4">
                              <Input
                                type="radio"
                                id="isGuaranteeLender2"
                                value="No"
                                onChange={() => { }}
                                checked={selectedGuarantee == 'No'}
                                onClick={handleGuaranteeChange}
                                style={{ border: "1px solid black" }}
                              />
                              <Label htmlFor="isGuaranteeLender2" className="ms-2">No</Label>
                            </div>
                          </div>
                          {errorGuarantee && <p style={{ color: 'rgb(245,116,116)', fontSize: "11px" }} className="ms-4">{errorGuarantee}</p>}
                        </Col>)}

                        {selectedGuarantee == "Yes" && productSettingObj.guarantee_offer_to_lender && (
                          <Col sm="12" md="6">
                            <Label className="form-label mt-4 grey">Select The Guarantee Type(s)</Label>
                            <Select
                              name="guaranteeTypesLender"
                              value={selectedMulti5}
                              isMulti={true}
                              onChange={handleMulti5}
                              options={entityGuaranteeList}
                              className="select2-selection"
                            // isDisabled={true}
                            />
                            {validation.values.guaranteeTypesLender == "" && <p style={{ color: 'rgb(245,116,116)', fontSize: "11px" }} >{validation.errors.guaranteeTypesLender}</p>}

                          </Col>
                        )}

                        {productSettingObj.monthly_purchases_value && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">What Is The Value Of Monthly Purchases?</Label>
                          <Input
                            name="monthlyPurchases"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.monthlyPurchases || ""}
                            invalid={validation.touched.monthlyPurchases && validation.errors.monthlyPurchases}
                          />
                          {validation.touched.monthlyPurchases && validation.errors.monthlyPurchases ? (
                            <FormFeedback type="invalid">{validation.errors.monthlyPurchases}</FormFeedback>
                          ) : null}
                        </Col>)}

                        {isAdmin && (
                          <>
                            {selectedProducts.includes("Inventory funding") ? null : (
                              <Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">
                            Select Deal Status
                          </Label>
                          <Input
                            name="dealStatus"
                            type="select"
                            placeholder="Select Deal Status"
                            onChange={(e) => {
                              validation.handleChange(e);
                            }}
                            onBlur={validation.handleBlur}
                            value={
                              validation.values.dealStatus || ""
                            }
                            invalid={
                              validation.touched.dealStatus &&
                              validation.errors.dealStatus
                            }
                          >
                            <option value="" disabled>
                              Select Deal Status
                            </option>
                            {dealStatusBucketList.map(
                              (option, index) => (
                                <option
                                  key={option.id}
                                  value={option.displayName}
                                >
                                  {option.displayName}
                                </option>
                              )
                            )}
                          </Input>
                          {validation.touched.dealStatus &&
                            validation.errors.dealStatus ? (
                            <FormFeedback type="invalid">
                              {validation.errors.dealStatus}
                            </FormFeedback>
                          ) : null}
                              </Col>
                            )}
                          </>
                        )}

                        {isAdmin && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">
                            Add Notes
                          </Label>
                          <Input
                            type="textarea"
                            className="form-control"
                            name="dealNotes"
                            placeholder="Enter Notes "
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.dealNotes || ""}
                            invalid={
                              validation.touched.dealNotes &&
                              validation.errors.dealNotes
                            }
                          />
                          {validation.touched.dealNotes &&
                            validation.errors.dealNotes ? (
                            <FormFeedback type="invalid">
                              {validation.errors.dealNotes}
                            </FormFeedback>
                          ) : null}
                        </Col>)}

                        { isAdmin && (
                          <Col sm="12" md="6">
                          <Label className="form-label mt-4 grey" htmlFor="expectedClosureDate">
                            Expected Closure Date * 
                          </Label>

                          <input
                            type="month"
                            value={validation.values.expectedClosureDate ? validation.values.expectedClosureDate : ''}
                            onChange={(e) => handleDateChange(e.target.value)}
                            className={`form-control ${validation.touched.expectedClosureDate && validation.errors.expectedClosureDate ? 'is-invalid' : ''}`}
                            id="expectedClosureDate"
                            placeholder="MM/YYYY"
                          />

                          {validation.touched.expectedClosureDate && validation.errors.expectedClosureDate && (
                            <FormFeedback>
                              {validation.errors.expectedClosureDate}
                            </FormFeedback>
                          )}
                        </Col>
                        )}

                        {isAdmin && (<Col sm="12" md="6">
                         <Label className="form-label mt-4 grey">Select Referred Financier</Label>
                          {isShowRecommendFinancier && (<Col sm="6" >
                            <div className="d-flex gap-2 justify-content-start mb-2 ms-4">
                              <Button
                                type="button"
                                color='primary'
                                className="btn-rounded"
                                style={{ padding: '4px 10px 4px 10px' }}
                                outline
                                onClick={() => {
                                  ReferredFinancierList()
                                }}
                              >
                                Show Recommended Financiers
                              </Button>
                            </div>
                          </Col>)}
                          {/* {validation.touched.financier && (selectedMulti6.length == 0 && selectedMulti7.length == 0 && selectedMulti8.length == 0) ? (
                            <p
                              style={{
                                color: "rgb(245,116,116)",
                                fontSize: "11px",
                              }}
                            >
                              {"Please Select atleast one financier"}
                            </p>
                          ) : null} */}
                          <div className="d-flex ms-4">
                            <div>
                              <Input
                                type="radio"
                                id="selectAllFin1"
                                value="All"
                                onChange={() => { }}
                                style={{ border: "1px solid black" }}
                                checked={selectedFinType == 'All'}
                                onClick={handleFinancierSelect}
                              />
                              <Label htmlFor="selectAllFin1" className="ms-2">Select All</Label>
                            </div>
                            <div className="ms-4">
                              <Input
                                type="radio"
                                id="Select1"
                                value="Select"
                                onChange={() => { }}
                                style={{ border: "1px solid black" }}
                                checked={selectedFinType == 'Select'}
                                onClick={handleFinancierSelect}
                              />
                              <Label htmlFor="Select1" className="ms-2">Select Referred Financier</Label>
                            </div>
                            <div className="ms-4">
                              <Input
                                type="radio"
                                id="SelectExFin1"
                                value="AllExcept"
                                onChange={() => { }}
                                style={{ border: "1px solid black" }}
                                checked={selectedFinType == 'AllExcept'}
                                onClick={handleFinancierSelect}
                              />
                              <Label htmlFor="SelectExFin1" className="ms-2">Select Except</Label>
                            </div>
                          </div>
                          {selectedFinType !== "" && (
                            <div>
                              <span style={{ fontWeight: "500" }}>
                                Public Sector Bank
                              </span>
                              <Select
                                name="financier"
                                value={selectedMulti6}
                                isMulti={true}
                                onChange={handleMulti6}
                                options={publicSectorBankList}
                                className="select2-selection mb-2"
                              // isDisabled={true}
                              />
                              <span style={{ fontWeight: "500" }}>
                                Private Sector Bank
                              </span>
                              <Select
                                name="financier"
                                value={selectedMulti7}
                                isMulti={true}
                                onChange={handleMulti7}
                                options={privateSectorBankList}
                                className="select2-selection mb-2"
                              // isDisabled={true}
                              />
                              <span style={{ fontWeight: "500" }}>
                                NBFCs
                              </span>
                              <Select
                                name="financier"
                                value={selectedMulti8}
                                isMulti={true}
                                onChange={handleMulti8}
                                options={NBFCList}
                                className="select2-selection"
                              // isDisabled={true}
                              />
                            </div>
                          )}
                        </Col>)}
                        <Col sm="12" md="6">
                         <Label className="form-label mt-4 grey">Select Preferred Financier</Label>  
                          <div className="d-flex ms-4">
                            <div>
                              <Input
                                type="radio"
                                id="selectAllPrefFinancier"
                                value="All"
                                onChange={() => { }}
                                style={{ border: "1px solid black" }}
                                checked={selectedPrefFinType == 'All'}
                                onClick={handlePrefFinancierSelect}
                              />
                              <Label htmlFor="selectAllFin1" className="ms-2">Select All</Label>
                            </div>
                            <div className="ms-4">
                              <Input
                                type="radio"
                                id="selectPrefFinancier"
                                value="Select"
                                onChange={() => { }}
                                style={{ border: "1px solid black" }}
                                checked={selectedPrefFinType == 'Select'}
                                onClick={handlePrefFinancierSelect}
                              />
                              <Label htmlFor="Select1" className="ms-2">Select Preferred Financier</Label>
                            </div>
                            <div className="ms-4">
                              <Input
                                type="radio"
                                id="selectExceptPrefFinancier"
                                value="AllExcept"
                                onChange={() => { }}
                                style={{ border: "1px solid black" }}
                                checked={selectedPrefFinType == 'AllExcept'}
                                onClick={handlePrefFinancierSelect}
                              />
                              <Label htmlFor="SelectExFin1" className="ms-2">Select Except</Label>
                            </div>
                          </div>
                          {selectedPrefFinType !== "" && (
                            <div>
                              <span style={{ fontWeight: "500" }}>
                                Public Sector Bank
                              </span>
                              <Select
                                name="preferredFinancier"
                                value={selectedPrefFinancierMulti6}
                                isMulti={true}
                                onChange={handlePrefMulti6}
                                options={publicSectorBankList}
                                className="select2-selection mb-2"
                              // isDisabled={true}
                              />
                              {validation.touched.preferredFinancier && selectedPrefFinancierMulti6.length == 0 &&
                                selectedPrefFinancierMulti7.length == 0 &&
                                selectedPrefFinancierMulti8.length == 0 ? (
                                <p
                                  style={{
                                    color: "rgb(245,116,116)",
                                    fontSize: "11px",
                                  }}
                                >
                                  {"Please Select atleast one financier"}
                                </p>
                              ) : null}

                              <span style={{ fontWeight: "500" }}>
                                Private Sector Bank
                              </span>
                              <Select
                                name="preferredFinancier"
                                value={selectedPrefFinancierMulti7}
                                isMulti={true}
                                onChange={handlePrefMulti7}
                                options={privateSectorBankList}
                                className="select2-selection mb-2"
                              // isDisabled={true}
                              />

                              {validation.touched.preferredFinancier &&
                                selectedPrefFinancierMulti6.length == 0 &&
                                selectedPrefFinancierMulti7.length == 0 &&
                                selectedPrefFinancierMulti8.length == 0 ? (

                                <p
                                  style={{
                                    color: "rgb(245,116,116)",
                                    fontSize: "11px",
                                  }}
                                >
                                  {"Please Select atleast one financier"}
                                </p>
                              ) : null}

                              <span style={{ fontWeight: "500" }}>
                                NBFCs
                              </span>
                              <Select
                                name="preferredFinancier"
                                value={selectedPrefFinancierMulti8}
                                isMulti={true}
                                onChange={handlePrefMulti8}
                                options={NBFCList}
                                className="select2-selection"
                              // isDisabled={true}
                              />
                              {validation.touched.preferredFinancier &&
                                selectedPrefFinancierMulti6.length == 0 &&
                                selectedPrefFinancierMulti7.length == 0 &&
                                selectedPrefFinancierMulti8.length == 0 ? (
                                <p
                                  style={{
                                    color: "rgb(245,116,116)",
                                    fontSize: "11px",
                                  }}
                                >
                                  {"Please Select atleast one financier"}
                                </p>
                              ) : null}
                            </div>
                          )}
                        </Col>
                        
                      </div>

                      <Row>
                        <Col sm="12">
                          <div className="d-flex flex-column flex-md-row gap-1 justify-content-end">
                            <button
                              className="btn btn-outline-secondary"
                              type="button"
                              onClick={handleCancel}
                            >
                              Cancel
                            </button>

                            {isAssignmentPermisssion && entity?.assignedTo !== null && (
                              <button
                                type="button"
                                className="btn btn-outline-success"
                                onClick={() => {
                                  assignFunc(entity)
                                }}
                              >
                                Re Assign
                              </button>
                            )}

                            {/* {for customer} */}
                            {!isApprovePermission && (user.entityType == 'Partner' ? entity?.assignedPartner == user.id : true) && (
                              <button
                                type="button"
                                className="btn btn-warning save-customer"
                                onClick={() => {
                                  let status = 'draftCustomer'
                                  onHandleSaveAsDraft(status)
                                }}
                              >
                                Save
                              </button>
                            )}

                            {/* {for admin} */}
                            {isApprovePermission && (entity?.assignedTo == user.id || entity?.createdBy == user.id 
                            || entity?.assignedToFirm == user.id || entity?.assignedToProgramRm == user.id ) && (
                              <button
                                type="button"
                                className="btn btn-warning save-customer"
                                onClick={() => {
                                  let status
                                  if (entity.status == 4) {
                                    status = 'draftAdmin'
                                  } else {
                                    status = 'draftCustomer'
                                  }
                                  onHandleSaveAsDraft(status)
                                }}
                              >
                                Save
                              </button>
                            )}

                            {isAssignmentPermisssion && entity?.assignedTo == null && (
                              <button
                                type="button"
                                className="btn btn-outline-primary"
                                onClick={() => {
                                  assignFunc(entity)
                                }}
                              >
                                Assign
                              </button>
                            )}

                            {isAssignmentForMePermisssion && entity?.assignedTo == null && (
                              <button
                                type="button"
                                className="btn btn-outline-success"
                                onClick={() => {
                                  assignToMeFunc(entity)
                                }}
                              >
                                Assign To Me
                              </button>
                            )}

                            {/* {for Customer} */}
                            {!isApprovePermission && (user.entityType == 'Partner' ? entity?.assignedPartner == user.id : true) && (
                              <button
                                type="button"
                                className="btn btn-success save-customer"
                                onClick={() => {
                                  let status = 'create'
                                  onHandleSaveAsDraft(status)
                                }}
                              >
                                Submit
                              </button>
                            )}

                            {/* {for admin} */}
                            {isApprovePermission && (entity?.assignedTo == user.id || entity?.createdBy == user.id
                              || entity?.assignedToFirm == user.id || entity?.assignedToProgramRm == user.id
                            ) && (
                              <button
                                type="button"
                                className="btn btn-success save-customer"
                                onClick={() => {
                                  let status = user?.roleName == 'partner' ? 'partner': 'Submit'
                                  onHandleSaveAsDraft(status)
                                }}
                              >
                                Submit
                              </button>
                            )}
                          </div>
                        </Col>
                      </Row>
                    </Form>
                  </FormikProvider>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <Modal
        isOpen={assignmodal}
        role="dialog"
        autoFocus={true}
        centered
        data-toggle="modal"
        toggle={() => {
          setAssignmodal(!assignmodal);
        }}
      >
        <div>
          <ModalHeader
            className="border-bottom-0"
            toggle={() => {
              setAssignmodal(!assignmodal);
            }}
          ></ModalHeader>
        </div>
        <div className="modal-body">
          <div className="text-center mb-4">
            <div className="row justify-content-center">
              <div className="col-xl-10">
                <h4 className="text-success">Select User to Assign Deal</h4>
                <Form
                  onSubmit={e => {
                    e.preventDefault()
                    validation3.handleSubmit()
                    return false
                  }}
                >
                  <Col xl={12} className="mb-3">
                  <Label className="form-label text-start d-block">
                            RM 
                          </Label>
                    <Input
                      name="assignedTo"
                      type="select"
                      onChange={validation3.handleChange}
                      onBlur={validation3.handleBlur}
                      value={validation3.values.assignedTo || null}
                      invalid={
                        validation3.touched.assignedTo && validation3.errors.assignedTo
                      }
                    >
                      <option value="" disabled>Select RM</option>
                      {userList?.map((option) => (
                        <option key={uId()} value={option.id}>
                          {capitalizeFirstLetter(option.firstName) + ' ' + ((option.lastName) ? capitalizeFirstLetter(option.lastName) : '')}
                        </option>
                      ))}

                    </Input>
                    {validation3.touched.assignedTo && validation3.errors.assignedTo ? (
                      <FormFeedback type="invalid">
                        {validation3.errors.assignedTo}
                      </FormFeedback>
                    ) : null}
                  </Col>
                  <Col xl={12} className="mb-3">
                  
                  <Label className="form-label text-start d-block">
                            FI RM 
                          </Label>
                    <Input
                      name="assignedToFirm"
                      type="select"
                      onChange={validation3.handleChange}
                      onBlur={validation3.handleBlur}
                      value={validation3.values.assignedToFirm || null}
                      invalid={
                        validation3.touched.assignedToFirm && validation3.errors.assignedToFirm
                      }
                    >
                      <option value="">Select FI-RM</option>
                      {userList?.map((option) => (
                        <option key={uId()} value={option.id}>
                          {capitalizeFirstLetter(option.firstName) + ' ' + ((option.lastName) ? capitalizeFirstLetter(option.lastName) : '')}
                        </option>
                      ))}

                    </Input>
                    {validation3.touched.assignedToFirm && validation3.errors.assignedToFirm ? (
                      <FormFeedback type="invalid">
                        {validation3.errors.assignedToFirm}
                      </FormFeedback>
                    ) : null}
                  </Col>
                  <Col xl={12} className="mb-3">
                  <Label className="form-label text-start d-block">
                            Program Manager 
                          </Label>
                    <Input
                      name="assignedToProgramRm"
                      type="select"
                      onChange={validation3.handleChange}
                      onBlur={validation3.handleBlur}
                      value={validation3.values.assignedToProgramRm || null}
                      invalid={
                        validation3.touched.assignedToProgramRm && validation3.errors.assignedToProgramRm
                      }
                    >
                      <option value="">Select Program Manager</option>
                      {userList?.map((option) => (
                        <option key={uId()} value={option.id}>
                          {capitalizeFirstLetter(option.firstName) + ' ' + ((option.lastName) ? capitalizeFirstLetter(option.lastName) : '')}
                        </option>
                      ))}

                    </Input>
                    {validation3.touched.assignedToProgramRm && validation3.errors.assignedToProgramRm ? (
                      <FormFeedback type="invalid">
                        {validation3.errors.assignedToProgramRm}
                      </FormFeedback>
                    ) : null}
                  </Col>
                  <Row>
                    <Col sm="12" >
                      <div className="d-flex gap-3 justify-content-end">
                        <button
                          type="submit"
                          className="btn btn-success save-customer mt-2"
                        >
                          Assign
                        </button>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        isOpen={modal}
        role="<dialog>"
        autoFocus={true}
        centered={true}
        className="exampleModal"
        tabIndex="-1"
        toggle={() => {
          setModal(!modal);
        }}
      >
      </Modal>

      <Modal
        isOpen={refferedFinModal}
        role="<dialog>"
        autoFocus={true}
        centered
        data-toggle="modal"
        toggle={() => {
          setRefferedFinModal(!refferedFinModal);
        }}
      >
        <div>
          <ModalHeader
            className="border-bottom-0"
            toggle={() => {
              setRefferedFinModal(!refferedFinModal);
            }}
          ></ModalHeader>
        </div>
        <div className="modal-body vertical-scroll" style={{ height: "550px" }}>
          {referredFinancierList.length > 0 && (<div>
            <div className="text-success font-size-18" style={{ marginBottom: '-12px', marginTop: '-10px' }}>Recommended Financiers</div>
            <ul>
              {referredFinancierList?.map((ele, index) => (
                <li className={`font-size-16 ${index == 0 ? 'mt-3' : 'mt-2'}`} key={uId()}>{ele?.entityName}
                </li>
              ))}
            </ul>
          </div>)}
          {(referredFinancierList.length == 0) && (
            <div className="text-success font-size-18 text-center">No data found</div>
          )}
        </div>
      </Modal>
      <Loader show={loader} type="box" message="Saving deal" />
      <ToastDialog
        message={toastInfo.message || ""}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      ></ToastDialog>
    </React.Fragment>
  )
}


export default withRouter(EditDeal);

EditDeal.propTypes = {
  history: PropTypes.object,
};

function downloadFile(base64String, ext, fileName) {
  let source = ""
  if (ext == "zip") {
    source = `data:application/zip;base64,${base64String}`
    const link = document.createElement("a")
    link.href = source
    link.download = fileName
    link.click()
  } else {
    source = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${base64String}`
    const link = document.createElement("a")
    link.href = source
    link.download = fileName
    link.click()
  }
}

const DynamicFileUploadInput = ({ label, inputName, onDropHandler, validation, uploadProgress, errorMessage, deal }) => {
  const [toastInfo, setToastInfo] = useState({ showToast: false });

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: onDropHandler
  });

  const fileName = (filename) => {
    const fileName = filename?.substring(filename.lastIndexOf("/") + 1);
    return fileName
  }

  const handleToast = (info) => {
    setToastInfo(info);
  };

  return (
    <div>
      <Label
        htmlFor={inputName}
        className="col-sm-6 col-form-label mt-3 grey"
      >
        {label}
      </Label>
      <div style={{
        display: "table",
        width: "100%",
        backgroundColor: "#fff",
        border: "dotted 2px #21aa47",
        borderRadius: "5px"
      }}>
        <div {...getRootProps()} className="text-wrapper">
          <div className="centered">
            <Input
              type="file"
              name={inputName}
              id={inputName}
              accept=".jpg, .png, .jpeg, .pdf, .xlsx, .xls"
              {...getInputProps()}
            />
            <label
              style={{
                marginBottom: 0,
                fontSize: "14px",
              }}
              htmlFor={inputName}
            >
              <img
                src="https://scfuat.cashinvoice.in/frontend/assets/themes/image/icon/cloud.png"
                className="img-fluid"
                style={{ width: "30px" }}
                alt="Upload"
              />
              {isDragActive && <p className="textLink">Drop here</p>}
              <span className="textLink" style={{ cursor: "pointer", padding: "5px" }}>
                Browse files to attach
              </span>
              {' '}
              or Drop
            </label>
          </div>
        </div>
        {deal?.[inputName] && (
          <i
            className="mdi mdi-download"
            style={{ fontSize: '18px', cursor: 'pointer' }}
            onKeyUp={() => { }}
            onClick={() => {
              formatFunction(deal?.[inputName], handleToast)
            }}
          ></i>
        )}
      </div>
      {validation.touched[inputName] &&
        validation.errors[inputName] && (
          <p className="text-danger font-size-11">
            {validation.errors[inputName]}
          </p>
        )}
      <span className="mt-2">{fileName(validation.values[inputName])}</span>
      {uploadProgress > 0 && !errorMessage && (
        <div className="progress mt-4">
          <div
            className="progress-bar bg-success"
            style={{ width: `${uploadProgress}%` }}
            aria-valuenow="0"
            aria-valuemin="0"
            aria-valuemax="100"
          >
            {`${uploadProgress}%`}
          </div>
        </div>
      )}
      {errorMessage && (
        <div className="alert alert-danger mt-4">
          {errorMessage}
        </div>
      )}
      <ToastDialog
        message={toastInfo.message || ""}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      ></ToastDialog>
    </div>

  );
}

const TableRow = ({ onDelete, index, validation, entity }) => {
  const [natureOfPropList, setNatureOfPropList] = useState([]);
  const [statusOfPropList, setStatusOfPropList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);

  const [uploadProgressParentDeed, setUploadProgressParentDeed] = useState(0)
  const [uploadProgressSaleDeed, setUploadProgressSaleDeed] = useState(0)
  const [uploadProgressUtilityBills, setUploadProgressUtilityBills] = useState(0)
  const [uploadProgressPropertyTax, setUploadProgressPropertyTax] = useState(0)


  const [errorMessageParentDeed, setErrorMessageParentDeed] = useState(null)
  const [errorMessageSaleDeed, setErrorMessageSaleDeed] = useState(null)
  const [errorMessageUtilityBills, setErrorMessageUtilityBills] = useState(null)
  const [errorMessagePropertyTax, setErrorMessagePropertyTax] = useState(null)

  useEffect(() => {
    getDropDownList({ dropdownName: "nature_of_property" })
      .then((response) => {
        const dropdownValues = response.data?.rows?.find((dv) => dv.dropdownName == "nature_of_property")?.dropdownValues || []
        setNatureOfPropList(dropdownValues);
      })
      .catch((error) => {
        console.log(error);
      });
    getDropDownList({ dropdownName: "status_of_property" })
      .then((response) => {
        const dropdownValues = response.data?.rows?.find((dv) => dv.dropdownName == "status_of_property")?.dropdownValues || []
        setStatusOfPropList(dropdownValues);
      })
      .catch((error) => {
        console.log(error);
      });
    callGetState()
      .then((response) => {
        if (response.code == "200") {
          setStateList(response.data);
        }
      })
      .catch((error) => { });
    if (validation.values.propertyInfo?.[index].state) {
      const value = validation.values.propertyInfo[index].state
      getCityList(value)
    }

  }, []);

  const createOnDropHandler = async (acceptedFiles, cb) => {
    if (acceptedFiles[0]) {
      cb({ percentage: 0 })
      let formData = new FormData();
      formData.append("upl", acceptedFiles[0]);
      const config = {
        onUploadProgress: progressEvent => {
          const percentage = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          cb({ percentage })
        },
      };
      try {
        const response = await axios.post(
          `${API_URL}/s3/uploadSystemConfigFiles`,
          formData,
          config
        );
        if (response.status === 200) {
          cb({ file: response.data[0].fileName })
        } else {
          cb({ error: response.data.message })
        }
      } catch (error) {
        cb({ error: error.response.data.message })
      }
    }
  };

  const onDropForInput1 = useCallback(async (docType, acceptedFiles) => {
    await createOnDropHandler(acceptedFiles, (result) => {
      setUploadProgressParentDeed(result.percentage);
      setErrorMessageParentDeed(result.error)
      validation.setFieldValue(`propertyInfo.${index}.${docType}`, result.file);
    });
  });

  const onDropForInput2 = useCallback(async (docType, acceptedFiles) => {
    await createOnDropHandler(acceptedFiles, (result) => {
      setUploadProgressSaleDeed(result.percentage);
      setErrorMessageSaleDeed(result.error)
      validation.setFieldValue(`propertyInfo.${index}.${docType}`, result.file);
    });
  });

  const onDropForInput3 = useCallback(async (docType, acceptedFiles) => {
    await createOnDropHandler(acceptedFiles, (result) => {
      setUploadProgressUtilityBills(result.percentage);
      setErrorMessageUtilityBills(result.error)
      validation.setFieldValue(`propertyInfo.${index}.${docType}`, result.file);
    });
  });

  const onDropForInput4 = useCallback(async (docType, acceptedFiles) => {
    await createOnDropHandler(acceptedFiles, (result) => {
      setUploadProgressPropertyTax(result.percentage);
      setErrorMessagePropertyTax(result.error)
      validation.setFieldValue(`propertyInfo.${index}.${docType}`, result.file);
    });
  });

  const handleInputChange = (index, field, value) => {
    validation.setFieldValue(`propertyInfo.${index}.${field}`, value);
    if (field == 'state') {
      validation.setFieldValue(`propertyInfo.${index}.city`, "")
      getCityList(value)
    }
  };

  const getCityList = (value) => {
    callGetCity({ state: value })
      .then((response) => {
        if (response.status) {
          setCityList(response?.data)
        }
      })
      .catch((error) => {
        console.log(error)
      })
  }
  return (
    <Card className="mt-4">
      <CardBody>
        {validation.values?.propertyInfo?.length > 1 && (
          <div className="text-end">
            <i
              className="bx bx-x-circle text-danger"
              onKeyUp={() => { }}
              onClick={() => onDelete(index)}
              style={{ cursor: "pointer", fontSize: "17px" }}
            />
          </div>
        )}
        <Row>
          <Col sm="12" md="6">
            <Label className="form-label mt-3 grey">Select Nature Of Property</Label>
            <Input
              type="select"
              placeholder="Select Nature Of Property"
              name={`file[${index}].name`}
              id={`file[${index}].name`}
              value={validation.values.propertyInfo[index].propertyNature}
              onChange={(e) =>
                handleInputChange(index, "propertyNature", e.target.value)
              }
              invalid={
                !!(validation.touched.propertyInfo?.[index]?.propertyNature &&
                  validation.errors.propertyInfo?.[index]?.propertyNature)
              }
            >
              <option value="" disabled>Select Nature Of Property</option>
              {natureOfPropList.map((option, index) => (
                <option key={option.id} value={option.dropdownValue}>
                  {option.displayName}
                </option>
              ))}
            </Input>

            {validation.touched.propertyInfo?.[index]?.propertyNature &&
              validation.errors.propertyInfo?.[index]?.propertyNature && (
                <FormFeedback>
                  {validation.errors.propertyInfo[index].propertyNature}
                </FormFeedback>
              )}
          </Col>
          <Col sm="12" md="6">
            <Label className="form-label mt-3 grey">Enter Owner of the property</Label>
            <Input
              type="text"
              placeholder="Enter Owner of the property"
              name={`file[${index}].name`}
              id={`file[${index}].name`}
              value={validation.values.propertyInfo[index].propertyOwner}
              onChange={(e) =>
                handleInputChange(index, "propertyOwner", e.target.value)
              }
              invalid={
                !!(validation.touched.propertyInfo?.[index]?.propertyOwner &&
                  validation.errors.propertyInfo?.[index]?.propertyOwner)
              }
            />
            {validation.touched.propertyInfo?.[index]?.propertyOwner &&
              validation.errors.propertyInfo?.[index]?.propertyOwner && (
                <FormFeedback>
                  {validation.errors.propertyInfo[index].propertyOwner}
                </FormFeedback>
              )}
          </Col>
          <Col sm="12" md="6">
            <Label className="form-label mt-3 grey">Select Status of the property</Label>
            <Input
              type="select"
              placeholder="Select Status of the property"
              name={`file[${index}].name`}
              id={`file[${index}].name`}
              value={validation.values.propertyInfo[index].propertyStatus}
              onChange={(e) =>
                handleInputChange(index, "propertyStatus", e.target.value)
              }
              invalid={
                !!(validation.touched.propertyInfo?.[index]?.propertyStatus &&
                  validation.errors.propertyInfo?.[index]?.propertyStatus)
              }
            >
              <option value="" disabled>Select Nature Of Property</option>
              {statusOfPropList.map((option, index) => (
                <option key={option.id} value={option.dropdownValue}>
                  {option.displayName}
                </option>
              ))}
            </Input>

            {validation.touched.propertyInfo?.[index]?.propertyStatus &&
              validation.errors.propertyInfo?.[index]?.propertyStatus && (
                <FormFeedback>
                  {validation.errors.propertyInfo[index].propertyStatus}
                </FormFeedback>
              )}
          </Col>
          <Col sm="12" md="6">
            <Label className="form-label mt-3 grey">Approximate value of the property</Label>
            <Input
              type="text"
              placeholder="Enter Approximate value of the property"
              name={`file[${index}].name`}
              id={`file[${index}].name`}
              value={validation.values.propertyInfo[index].propertyValue}
              onChange={(e) =>
                handleInputChange(index, "propertyValue", e.target.value)
              }
              invalid={
                !!(validation.touched.propertyInfo?.[index]?.propertyValue &&
                  validation.errors.propertyInfo?.[index]?.propertyValue)
              }
            />
            {validation.touched.propertyInfo?.[index]?.propertyValue &&
              validation.errors.propertyInfo?.[index]?.propertyValue && (
                <FormFeedback>
                  {validation.errors.propertyInfo[index].propertyValue}
                </FormFeedback>
              )}
          </Col>
          <Col sm="12" md="6">
            <Label className="form-label mt-3 grey">Age of the property(Year)</Label>
            <Input
              type="text"
              placeholder="Enter Age of the property(Year)"
              name={`file[${index}].name`}
              id={`file[${index}].name`}
              value={validation.values.propertyInfo[index].propertyAge}
              onChange={(e) =>
                handleInputChange(index, "propertyAge", e.target.value)
              }
              invalid={
                !!(validation.touched.propertyInfo?.[index]?.propertyAge &&
                  validation.errors.propertyInfo?.[index]?.propertyAge)
              }
            />
            {validation.touched.propertyInfo?.[index]?.propertyAge &&
              validation.errors.propertyInfo?.[index]?.propertyAge && (
                <FormFeedback>
                  {validation.errors.propertyInfo[index].propertyAge}
                </FormFeedback>
              )}
          </Col>
          <Col sm="12" md="6">
            <Label className="form-label mt-3 grey">Enter Property Address</Label>
            <Input
              type="text"
              placeholder="Enter Property Address"
              name={`file[${index}].name`}
              id={`file[${index}].name`}
              value={validation.values.propertyInfo[index].address}
              onChange={(e) =>
                handleInputChange(index, "address", e.target.value)
              }
              invalid={
                !!(validation.touched.propertyInfo?.[index]?.address &&
                  validation.errors.propertyInfo?.[index]?.address)
              }
            />
            {validation.touched.propertyInfo?.[index]?.address &&
              validation.errors.propertyInfo?.[index]?.address && (
                <FormFeedback>
                  {validation.errors.propertyInfo[index].address}
                </FormFeedback>
              )}
          </Col>
          <Col sm="12" md="6">
            <Label className="form-label mt-3 grey">Enter Property Pincode</Label>
            <Input
              type="text"
              placeholder="Enter Property Pincode"
              name={`file[${index}].name`}
              id={`file[${index}].name`}
              value={validation.values.propertyInfo[index].pincode}
              onChange={(e) =>
                handleInputChange(index, "pincode", e.target.value)
              }
              invalid={
                !!(validation.touched.propertyInfo?.[index]?.pincode &&
                  validation.errors.propertyInfo?.[index]?.pincode)
              }
            />
            {validation.touched.propertyInfo?.[index]?.pincode &&
              validation.errors.propertyInfo?.[index]?.pincode && (
                <FormFeedback>
                  {validation.errors.propertyInfo[index].pincode}
                </FormFeedback>
              )}
          </Col>
          <Col sm="12" md="6">
            <Label className="form-label mt-3 grey">Select State</Label>
            <Select
              options={stateList.map((option, index) => ({
                label: option.name,
                value: option.name,
              }))}
              className={`select-dropdown ${validation.touched.propertyInfo?.[index]?.state &&
                validation.errors.propertyInfo?.[index]?.state
                ? "is-invalid"
                : ""
                }`}
              name="state"
              id="state"
              placeholder={"Select State"}
              value={validation.values.propertyInfo[index].state ? { label: validation.values.propertyInfo[index].state, value: validation.values.propertyInfo[index].state } : ''}
              onChange={(e) =>
                handleInputChange(index, "state", e.value)
              }
            />
            {validation.touched.propertyInfo?.[index]?.state &&
              validation.errors.propertyInfo?.[index]?.state && (
                <FormFeedback>
                  {validation.errors.propertyInfo?.[index]?.state}
                </FormFeedback>
              )}
          </Col>
          <Col sm="12" md="6">
            <Label className="form-label mt-4 grey">Select City</Label>
            <Select
              options={cityList.map((option) => ({
                label: option.cityName,
                value: option.cityName,
              }))}
              className={`select-dropdown ${validation.touched.propertyInfo?.[index]?.city &&
                validation.errors.propertyInfo?.[index]?.city
                ? "is-invalid"
                : ""
                }`}
              name="city"
              id="city"
              onChange={(e) => handleInputChange(index, "city", e.value)}
              value={
                validation.values.propertyInfo?.[index].city
                  ? {
                    label: validation.values.propertyInfo[index]?.city,
                    value: validation.values.propertyInfo[index]?.city,
                  }
                  : ""
              }
            />
            {validation.touched.propertyInfo?.[index]?.city && validation.errors.propertyInfo?.[index]?.city ? (
              <FormFeedback type="invalid">{validation.errors.propertyInfo?.[index]?.city}</FormFeedback>
            ) : null}
          </Col>

          <Col sm="12" md="6" >
            <DynamicFileUploadInputForTableRow
              label={'Parent Deed'}
              inputName={'parentDeed'}
              onDropHandler={(acceptedFiles) => onDropForInput1('parentDeed', acceptedFiles)}
              isDragActive={true}
              validation={validation}
              uploadProgress={uploadProgressParentDeed}
              errorMessage={errorMessageParentDeed}
              index={index}
              deal={entity}
            />
          </Col>
          <Col sm="12" md="6" >
            <DynamicFileUploadInputForTableRow
              label={'Sale Deed'}
              inputName={'saleDeed'}
              onDropHandler={(acceptedFiles) => onDropForInput2('saleDeed', acceptedFiles)}
              isDragActive={true}
              validation={validation}
              uploadProgress={uploadProgressSaleDeed}
              errorMessage={errorMessageSaleDeed}
              index={index}
              deal={entity}
            />
          </Col>
          <Col sm="12" md="6" >
            <DynamicFileUploadInputForTableRow
              label={'Utility Bills'}
              inputName={'utilityBills'}
              onDropHandler={(acceptedFiles) => onDropForInput3('utilityBills', acceptedFiles)}
              isDragActive={true}
              validation={validation}
              uploadProgress={uploadProgressUtilityBills}
              errorMessage={errorMessageUtilityBills}
              index={index}
              deal={entity}
            />
          </Col>
          <Col sm="12" md="6" >
            <DynamicFileUploadInputForTableRow
              label={'Property Tax'}
              inputName={'propertyTax'}
              onDropHandler={(acceptedFiles) => onDropForInput4('propertyTax', acceptedFiles)}
              isDragActive={true}
              validation={validation}
              uploadProgress={uploadProgressPropertyTax}
              errorMessage={errorMessagePropertyTax}
              index={index}
              deal={entity}
            />
          </Col>
        </Row>
      </CardBody>
    </Card>
  );

};

const DynamicFileUploadInputForTableRow = ({ label, inputName, onDropHandler, validation, uploadProgress, errorMessage, index, deal }) => {
  const [toastInfo, setToastInfo] = useState({ showToast: false });

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: onDropHandler
  });

  const handleToast = (info) => {
    setToastInfo(info);
  };

  const fileName = (filename) => {
    const fileName = filename?.substring(filename.lastIndexOf("/") + 1);
    return fileName
  }
  return (
    <div>
      <Label
        htmlFor={inputName}
        className="col-sm-6 col-form-label mt-3 grey"
      >
        {label}
      </Label>
      <div style={{
        display: "table",
        width: "100%",
        backgroundColor: "#fff",
        border: "dotted 2px #21aa47",
        borderRadius: "5px"
      }}>
        <div {...getRootProps()} className="text-wrapper">
          <div className="centered">
            <Input
              type="file"
              name={`${inputName}-${index}`}
              id={`${inputName}-${index}`}
              accept=".jpg, .png, .jpeg, .pdf, .xlsx, .xls"
              {...getInputProps({
                onClick: (event) => {
                  event.stopPropagation();
                },
              })}
            />
            <label
              style={{
                marginBottom: 0,
                fontSize: "14px",
              }}
              htmlFor={inputName}
            >
              <img
                src="https://scfuat.cashinvoice.in/frontend/assets/themes/image/icon/cloud.png"
                className="img-fluid"
                style={{ width: "30px" }}
                alt="Upload"
              />
              {isDragActive && <p className="textLink">Drop here</p>}
              <span className="textLink" style={{ cursor: "pointer", padding: "5px" }}>
                Browse files to attach
              </span>
              or Drop
              {' '}
            </label>
          </div>
        </div>
        {deal?.propertyInfo?.[index]?.[inputName] && (
          <i
            className="mdi mdi-download"
            style={{ fontSize: '18px', cursor: 'pointer' }}
            onKeyUp={() => { }}
            onClick={() => {
              formatFunction(deal?.propertyInfo?.[index]?.[inputName], handleToast)
            }}
          ></i>
        )}
      </div>
      {validation.touched.propertyInfo?.[index]?.[inputName] &&
        validation.errors.propertyInfo?.[index]?.[inputName] && (
          <p className="text-danger font-size-11">
            {validation.errors.propertyInfo[index]?.[inputName]}
          </p>
        )}
      <span className="mt-2">{fileName(validation.values.propertyInfo[index]?.[inputName])} </span>
      {uploadProgress > 0 && !errorMessage && (
        <div className="progress mt-4">
          <div
            className="progress-bar bg-success"
            style={{ width: `${uploadProgress}%` }}
            aria-valuenow="0"
            aria-valuemin="0"
            aria-valuemax="100"
          >
            {`${uploadProgress}%`}
          </div>
        </div>
      )}
      {errorMessage && (
        <div className="alert alert-danger mt-4">
          {errorMessage}
        </div>
      )}
      <ToastDialog
        message={toastInfo.message || ""}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      ></ToastDialog>
    </div>
  );
}

function formatFunction(file, showToastCallback) {
  const str = file.substring(file.indexOf("com") + 4);
  const filename = file.substring(file.lastIndexOf("/") + 1);
  const ext = str.split(".").pop();
  const obj = {
    fileName: str,
  };

  downloadSystemConfigFile(obj)
    .then((response) => {
      if (response.code === 200) {
        downloadFile(response.result, ext, filename);
        showToastCallback({
          message: 'Downloading file',
          showToast: true,
          role: "success",
        });
      } else {
        showToastCallback({
          message: response.message,
          showToast: true,
          role: "error",
        });
      }
    })
    .catch((error) => {
      // Handle errors here
    });
}

const ProductRow = ({ onDelete, index, validation, change, changeType, commercialFieldsData,isAdmin }) => {
  const handleInputChange = (index, field, value) => {
    validation.setFieldValue(`productInfoList.${index}.${field}`, value);
  };

  const handleInputChangeSetNull = (index, field, value) => {
    validation.setFieldValue(`productInfoList.${index}.${field}`, '');
  };

  const selectedData = (datalist, data) => {
    if (data) {
      const newData = [];
      let dataValues = data.split(', ')
      for (const value of dataValues) {
        const foundItem = datalist.find((item) => item.value == value);
        if (foundItem) {
          newData.push(foundItem);
        }
      }

      return newData;
    }

    return [];
  };

  const [productTypeList, setProductTypeList] = useState([]);
  const [isProductSelected, setIsProductSelected] = useState(false);
  const [productList, setProductList] = useState([]);
  const [isProductType, setIsProductType] = useState(false);
  const [subProductList, setSubProductList] = useState([]);
  const [isShowSubProduct, setIsShowSubProduct] = useState(false);
  const [showCommercials, setShowCommercials] = useState(false);
  const [isNVGSelected, setIsNVGSelected] = useState(false);
  const [selectedMultiSubProduct, setSelectedMultiSubProduct] = useState(
    validation.values.productInfoList?.[index]?.subProduct || []
  );

  let commonDropdown = ['Flat', 'Percentage']

  let platformDropdown = ['NVG', 'Throughput', 'Flat', 'Sanctioned Limit']

  const handleMultiSubProductChange = (selectedOptions) => {
    setSelectedMultiSubProduct(selectedOptions);
    const newData = [];
    selectedOptions.forEach((ele) => {
      newData.push(ele.value);
    });
    handleInputChange(index, "subProduct", newData);
  };

  useEffect(() => {
    setShowCommercials(true)
    getDropDownList({ dropdownName: "Product type" })
      .then((response) => {
        const dropdownValues =
          response.data?.rows?.find((dv) => dv.dropdownName == "Product type")
            ?.dropdownValues || [];
        setProductTypeList(dropdownValues);
      })
      .catch((error) => { });

    getDropDownList({ dropdownName: validation.values.productInfoList?.[index]?.productType })
      .then((response) => {
        const dropdownValues =
          response.data?.rows?.find(
            (dv) => dv.dropdownName == validation.values.productInfoList?.[index]?.productType
          )?.dropdownValues || [];
        setProductList(dropdownValues);
        setIsProductType(true);
      })
      .catch((error) => { });
    if (validation.values.productInfoList?.[index]?.product == "Payable Financing" || validation.values.productInfoList?.[index]?.product == "Receivable Financing"
      || validation.values.productInfoList?.[index]?.product == "CC/OD" || validation.values.productInfoList?.[index]?.product == "Debetures" || validation.values.productInfoList?.[index]?.product == "Inventory funding"
    ) {
      getDropDownList({
        dropdownName: validation.values.productInfoList?.[index]?.product,
      })
        .then((response) => {
          const dropdownValues =
            response.data?.rows?.find(
              (dv) =>
                dv.dropdownName == validation.values.productInfoList?.[index]?.product
            )?.dropdownValues || [];
          const formattedDropdownValues = dropdownValues.map((dv) => ({
            label: dv.displayName,
            value: dv.dropdownValue,
          }));
          setSubProductList(formattedDropdownValues);
          setSelectedMultiSubProduct(selectedData(formattedDropdownValues, validation.values.productInfoList?.[index]?.subProduct));
          let subProductValue = validation.values.productInfoList?.[index]?.subProduct?.split(', ') || []
          handleInputChange(index, "subProduct", subProductValue);
        })
        .catch((error) => { });
      setIsProductSelected(true);
      setIsShowSubProduct(true)
    } else {
      setIsProductSelected(false);
      setIsShowSubProduct(false)
    }
    
    validation.values.productInfoList?.[index]?.commercials?.map((ele) => {
      handleInputChange(index, `integrationFeesFrequency`, ele?.integrationFees?.Frequency)
      handleInputChange(index, `integrationFeesType`, ele?.integrationFees?.Type)
      handleInputChange(index, `integrationFeesValue`, ele?.integrationFees?.Value)
      handleInputChange(index, `integrationFeesOccurrence`, ele?.integrationFees?.Occurrence)
      handleInputChange(index, `syndicationFeesFrequency`, ele?.syndicationFees?.Frequency)
      handleInputChange(index, `syndicationFeesType`, ele?.syndicationFees?.Type)
      handleInputChange(index, `syndicationFeesValue`, ele?.syndicationFees?.Value)
      handleInputChange(index, `syndicationFeesOccurrence`, ele?.syndicationFees?.Occurrence)
      
      handleInputChange(index, `platformChargesType`, ele?.platformCharges?.Type)
      handleInputChange(index, `platformChargesFrequency`, ele?.platformCharges?.Frequency)
      handleInputChange(index, `platformChargesOccurrence`, ele?.platformCharges?.Occurrence)
      handleInputChange(index, `platformChargesValue`, ele?.platformCharges?.Value)
      handleInputChange(index, `platformChargesBenchmarkRate`, ele?.platformCharges?.BenchmarkRate)
      handleInputChange(index, `platformChargesBenchmark`, ele?.platformCharges?.Benchmark)
      handleInputChange(index, `platformChargesMarkupOverBenchmark`, ele?.platformCharges?.MarkupOverBenchmark)
      handleInputChange(index, `platformChargesNVG`, ele?.platformCharges?.NVG)

      if (validation?.values?.productInfoList[index]?.commercials[0]?.platformCharges?.Type == 'NVG') {
        setIsNVGSelected(true)
      } else {
        setIsNVGSelected(false)
      }
    })
  }, [])
  return (
    <Card className="mt-4">
      <CardBody>
        {validation.values?.productInfoList?.length > 1 && (
          <div className="text-end">
            <i
              className="bx bx-x-circle text-danger"
              onKeyUp={() => { }}
              onClick={() => onDelete(index)}
              style={{ cursor: "pointer", fontSize: "17px" }}
            />
          </div>
        )}

        <Row>
          <Col sm="12" md="6">
            <Label className="form-label mt-0 grey">
              Product Type*
            </Label>
            <Input
              name={`file[${index}].name`}
              id={`file[${index}].name`}
              value={validation.values.productInfoList[index].productType}
              type="select"
              onChange={(e) => {
                handleInputChange(index, "productType", e.target.value)
                setIsProductSelected(false);
                getDropDownList({ dropdownName: e.target.value })
                  .then((response) => {
                    const dropdownValues =
                      response.data?.rows?.find(
                        (dv) => dv.dropdownName == e.target.value
                      )?.dropdownValues || [];
                    setProductList(dropdownValues);
                    setIsProductType(true);
                  })
                  .catch((error) => { });
                changeType(null, e.target.value, null, index)
                handleInputChangeSetNull(index, "product", e.target.value)
                handleInputChangeSetNull(index, "subProduct", e.target.value)
              }}
              invalid={
                validation.touched.productInfoList?.[index]?.productType &&
                validation.errors.productInfoList?.[index]?.productType
              }
            >
              <option value="" disabled>
                Select Product type
              </option>
              {productTypeList.map((option, index) => (
                <option
                  key={option.id}
                  value={option.dropdownValue}
                >
                  {option.displayName}
                </option>
              ))}
            </Input>
            {validation.touched.productInfoList?.[index]?.productType &&
              validation.errors.productInfoList?.[index]?.productType ? (
              <FormFeedback type="invalid">
                {validation.errors.productInfoList?.[index]?.productType}
              </FormFeedback>
            ) : null}
          </Col>

            <Col sm="12" md="6">
              <Label className="form-label mt-mobile grey">
                Select Product*
              </Label>
              <Input
                name={`file[${index}].name`}
                id={`file[${index}].name`}
                type="select"
                onChange={(e) => {
                  handleInputChange(index, "product", e.target.value)
                  setShowCommercials(true);
                  setSelectedMultiSubProduct([]);
                  if (
                    e.target.value == "Payable Financing" ||
                    e.target.value == "Receivable Financing" ||
                    e.target.value == "Inventory funding" ||
                    e.target.value == "CC/OD" ||
                    e.target.value == "Debentures"
                  ) {
                    getDropDownList({
                      dropdownName: e.target.value,
                    })
                      .then((response) => {
                        const dropdownValues =
                          response.data?.rows?.find(
                            (dv) =>
                              dv.dropdownName == e.target.value
                          )?.dropdownValues || [];
                        const formattedDropdownValues = dropdownValues.map((dv) => ({
                          label: dv.displayName,
                          value: dv.dropdownValue,
                        }));
                        setSubProductList(formattedDropdownValues);
                      })
                      .catch((error) => { });
                    setIsProductSelected(true);
                    setIsShowSubProduct(true)
                  } else {
                    setIsProductSelected(false);
                    setIsShowSubProduct(false)
                  }

                  if (e.target.value == "Equity") {
                    callShareholdingApi();
                  }

                  change(e.target.value, null, null, index)
                  handleInputChangeSetNull(index, "subProduct", e.target.value)
                }}
                value={validation.values.productInfoList[index].product}
                invalid={
                  validation.touched.productInfoList?.[index]?.product &&
                  validation.errors.productInfoList?.[index]?.product
                }
              >
                <option value="" disabled>
                  Select Product
                </option>
                {productList.map((option, index) => (
                  <option
                    key={option.id}
                    value={option.dropdownValue}
                  >
                    {option.displayName}
                  </option>
                ))}
              </Input>
              {validation.touched.productInfoList?.[index]?.product &&
                validation.errors.productInfoList?.[index]?.product ? (
                <FormFeedback type="invalid">
                  {validation.errors.productInfoList?.[index]?.product}
                </FormFeedback>
              ) : null}
            </Col>
          
          {isShowSubProduct && (
            <Col sm="12" md="6">
              <Label className="form-label mt-3 grey">
                Select Sub Product*
              </Label>
              <Select
                name={`file[${index}].subProduct`}
                id={`file[${index}].subProduct`}
                value={selectedMultiSubProduct}
                isMulti={true}
                onChange={handleMultiSubProductChange}
                options={subProductList}
                className="select2-selection mb-2"
              />
              {validation.touched.productInfoList?.[index]?.subProduct &&
                validation.errors.productInfoList?.[index]?.subProduct ? (
                <p style={{ color: "rgb(245,116,116)", fontSize: "11px" }}>
                  {validation.errors.productInfoList?.[index]?.subProduct}
                </p>
              ) : null}
            </Col>
          )}

          <hr></hr>
          {showCommercials && isAdmin && (<Col sm="12" md="6">
            <Label className="form-label mt-2 font-size-14">
              Commercials
            </Label>
          </Col>
          )}

          {showCommercials && isAdmin && commercialFieldsData?.map((field,i) => (
            <>
             {i == 0 &&( <Label className="form-label font-size-12 text-success">
              {`${(field.fieldName === "syndicationFees" && validation.values.productInfoList[index].product === "Inventory funding") ? "Gross PF" :
           (field.fieldName === "integrationFees" && validation.values.productInfoList[index].product === "Inventory funding") ? "Net PF" :
           field.fieldLabel}`}
              </Label>)}

              {i !== 0 &&( <Label className="form-label mt-4 font-size-12 text-success">
                {`${(field.fieldName === "syndicationFees" && validation.values.productInfoList[index].product === "Inventory funding") ? "Gross PF" :
           (field.fieldName === "integrationFees" && validation.values.productInfoList[index].product === "Inventory funding") ? "Net PF" :
           field.fieldLabel}`}
              </Label>)}

              <Col sm="12" md="3">
                <Label className="form-label mt-2 font-size-12 grey">
                  Type{validation.values.productInfoList?.[index]?.product === "Inventory funding" && field.fieldName !== 'platformCharges' && (
                    <span>*</span>
                  )}
                </Label>
                <Input
                  name={`${field.fieldName}Type`}
                  id={`${field.fieldName}Type_${index}`}
                  type="select"
                  placeholder={`Select ${field.fieldLabel} Type`}
                  onBlur={() => validation.setFieldTouched(`productInfoList[${index}].${field.fieldName}Type`, true)}
                  onChange={(e) => {
                    handleInputChange(index, `${field.fieldName}Type`, e.target.value)
                    if (e.target.value == 'NVG' && field.fieldName == 'platformCharges') {
                      setIsNVGSelected(true)
                    } else if(field.fieldName == 'platformCharges' && e.target.value != 'NVG'){
                      setIsNVGSelected(false)
                    }
                  }} // Let Formik handle the change
                  // onBlur={validation.handleBlur}
                  value={
                    validation.values.productInfoList?.[index]?.[`${field.fieldName}Type`] ||
                    ""
                  }
                  invalid={
                    !!(validation.touched.productInfoList?.[index]?.[
                      `${field.fieldName}Type`
                    ] &&
                      validation.errors.productInfoList?.[index]?.[`${field.fieldName}Type`])
                  }
                  disabled={validation.values.prospectiveProduct === 'TradEasy' && validation.values.productInfoList?.[index]?.[`${field.fieldName}Type`] === 'Percentage'}
                >
                  <option value="" disabled>Select</option>
                  {field.fieldName == 'platformCharges' ? platformDropdown.map(option => (
                    <option key={option} value={option} disabled={validation.values.prospectiveProduct === 'TradEasy' && option !== 'Flat'}>
                      {option}</option>
                  )): commonDropdown.map(option => (
                    <option key={option} value={option} disabled={validation.values.prospectiveProduct === 'TradEasy' && option === 'Percentage'}>
                      {option}</option>
                  ))}
                </Input>
                {validation.touched.productInfoList?.[index]?.[`${field.fieldName}Type`] &&
                  validation.errors.productInfoList?.[index]?.[`${field.fieldName}Type`] ? (
                  <FormFeedback type="invalid">
                    {validation.errors.productInfoList?.[index]?.[`${field.fieldName}Type`]}
                  </FormFeedback>
                ) : null}
              </Col>

              {field.fieldName == 'platformCharges' && (<>
                {isNVGSelected && (
                  <>
                    <Col sm="12" md="3">
                      <Label className="form-label mt-2 grey">
                        Benchmark
                      </Label>
                      <Input
                        name={`${field.fieldName}Benchmark`}
                        type="text"
                        placeholder={`Enter Benchmark`}
                        onChange={(e) => { handleInputChange(index, `${field.fieldName}Benchmark`, e.target.value) }}
                        onBlur={() => validation.setFieldTouched(`productInfoList[${index}].${field.fieldName}Benchmark`, true)}
                        value={
                          validation.values.productInfoList?.[index]?.[
                          `${field.fieldName}Benchmark`
                          ] || ""
                        }
                        invalid={
                          !!(validation.touched.productInfoList?.[index]?.[
                            `${field.fieldName}Benchmark`
                          ] &&
                            validation.errors.productInfoList?.[index]?.[`${field.fieldName}Benchmark`])
                        }
                      />
                      {validation.touched.productInfoList?.[index]?.[`${field.fieldName}Benchmark`] &&
                        validation.errors.productInfoList?.[index]?.[`${field.fieldName}Benchmark`] ? (
                        <FormFeedback type="invalid">
                          {validation.errors.productInfoList?.[index]?.[`${field.fieldName}Benchmark`]}
                        </FormFeedback>
                      ) : null}
                    </Col>

                    <Col sm="12" md="3">
                      <Label className="form-label mt-2 grey">
                        Benchmark Rate (%)
                      </Label>
                      <Input
                        name={`${field.fieldName}BenchmarkRate`}
                        type="text"
                        placeholder={`Enter Benchmark Rate`}
                        onChange={(e) => { handleInputChange(index, `${field.fieldName}BenchmarkRate`, e.target.value) }}
                        onBlur={() => validation.setFieldTouched(`productInfoList[${index}].${field.fieldName}BenchmarkRate`, true)}
                        value={
                          validation.values.productInfoList?.[index]?.[
                          `${field.fieldName}BenchmarkRate`
                          ] || ""
                        }
                        invalid={
                          !!(validation.touched.productInfoList?.[index]?.[
                            `${field.fieldName}BenchmarkRate`
                          ] &&
                            validation.errors.productInfoList?.[index]?.[`${field.fieldName}BenchmarkRate`])
                        }
                      />
                      {validation.touched.productInfoList?.[index]?.[`${field.fieldName}BenchmarkRate`] &&
                        validation.errors.productInfoList?.[index]?.[`${field.fieldName}BenchmarkRate`] ? (
                        <FormFeedback type="invalid">
                          {validation.errors.productInfoList?.[index]?.[`${field.fieldName}BenchmarkRate`]}
                        </FormFeedback>
                      ) : null}
                    </Col>

                    <Col sm="12" md="3">
                      <Label className="form-label mt-2 grey">
                        Markup over benchmark (%)
                      </Label>
                      <Input
                        name={`${field.fieldName}MarkupOverBenchmark`}
                        type="text"
                        placeholder={`Enter Markup over benchmark`}
                        onChange={(e) => { handleInputChange(index, `${field.fieldName}MarkupOverBenchmark`, e.target.value) }}
                        onBlur={() => validation.setFieldTouched(`productInfoList[${index}].${field.fieldName}MarkupOverBenchmark`, true)}
                        value={
                          validation.values.productInfoList?.[index]?.[
                          `${field.fieldName}MarkupOverBenchmark`
                          ] || ""
                        }
                        invalid={
                          !!(validation.touched.productInfoList?.[index]?.[
                            `${field.fieldName}MarkupOverBenchmark`
                          ] &&
                            validation.errors.productInfoList?.[index]?.[`${field.fieldName}MarkupOverBenchmark`])
                        }
                      />
                      {validation.touched.productInfoList?.[index]?.[`${field.fieldName}MarkupOverBenchmark`] &&
                        validation.errors.productInfoList?.[index]?.[`${field.fieldName}MarkupOverBenchmark`] ? (
                        <FormFeedback type="invalid">
                          {validation.errors.productInfoList?.[index]?.[`${field.fieldName}MarkupOverBenchmark`]}
                        </FormFeedback>
                      ) : null}
                    </Col>
                  </>
                )}

                <Col sm="12" md="3">
                  <Label className="form-label mt-2 grey">
                    Frequency
                  </Label>
                  <Input
                    name={`${field.fieldName}Frequency`}
                    id={`${field.fieldName}Type_${index}`}
                    type="select"
                    placeholder={`Select ${field.fieldLabel} Frequency`}
                    onChange={(e) => { handleInputChange(index, `${field.fieldName}Frequency`, e.target.value) }} // Let Formik handle the change
                    onBlur={() => validation.setFieldTouched(`productInfoList[${index}].${field.fieldName}Frequency`, true)}
                    value={
                      validation.values.productInfoList?.[index]?.[`${field.fieldName}Frequency`] ||
                      ""
                    }
                    invalid={
                      !!(validation.touched.productInfoList?.[index]?.[
                        `${field.fieldName}Frequency`
                      ] &&
                        validation.errors.productInfoList?.[index]?.[`${field.fieldName}Frequency`])
                    }
                  >
                    <option value="" disabled>Select</option>
                    <option value="Recurring" disabled={validation.values.prospectiveProduct === 'TradEasy'}>Recurring</option>
                    <option value="One time">One time</option>
                  </Input>
                  {validation.touched.productInfoList?.[index]?.[`${field.fieldName}Frequency`] &&
                    validation.errors.productInfoList?.[index]?.[`${field.fieldName}Frequency`] ? (
                    <FormFeedback type="invalid">
                      {validation.errors.productInfoList?.[index]?.[`${field.fieldName}Frequency`]}
                    </FormFeedback>
                  ) : null}
                </Col>

                <Col sm="12" md="3">
                  <Label className="form-label mt-2 grey">
                    Occurrence
                  </Label>
                  <Input
                    name={`${field.fieldName}Occurrence`}
                    id={`${field.fieldName}Type_${index}`}
                    type="select"
                    placeholder={
                      validation.values.productInfoList?.[index]?.[`${field.fieldName}Time`] === "One Time"
                        ? "Not Applicable"
                        : `Select ${field.fieldLabel} Occurrence`
                    }
                    onChange={(e) => { handleInputChange(index, `${field.fieldName}Occurrence`, e.target.value) }}
                    onBlur={() => validation.setFieldTouched(`productInfoList[${index}].${field.fieldName}Occurrence`, true)}
                    value={
                      validation.values.productInfoList?.[index]?.[`${field.fieldName}Frequency`] === "One time"
                        ? ""
                        : validation.values.productInfoList?.[index]?.[`${field.fieldName}Occurrence`] || ""
                    }
                    invalid={
                      !!(validation.touched.productInfoList?.[index]?.[
                        `${field.fieldName}Occurrence`
                      ] &&
                        validation.errors.productInfoList?.[index]?.[`${field.fieldName}Occurrence`])
                    }
                    disabled={validation.values.productInfoList?.[index]?.[`${field.fieldName}Frequency`] === "One time"}
                  >
                    <option value="" disabled>{
                      validation.values[`${field.fieldName}Frequency`] === "One time"
                        ? "Not Applicable"
                        : `Select`
                    }</option>
                    <option value="Per Annum">Per Annum</option>
                    <option value="Per Month">Per Month</option>
                    <option value="At Invoice">At Invoice</option>
                    <option value="AUM">AUM</option>
                    <option value="Quarterly">Quarterly</option>
                  </Input>
                  {validation.touched.productInfoList?.[index]?.[`${field.fieldName}Occurrence`] &&
                    validation.errors.productInfoList?.[index]?.[`${field.fieldName}Occurrence`] ? (
                    <FormFeedback type="invalid">
                      {validation.errors.productInfoList?.[index]?.[`${field.fieldName}Occurrence`]}
                    </FormFeedback>
                  ) : null}
                </Col>

                {isNVGSelected && (<Col sm="12" md="3">
                  <Label className="form-label mt-2 grey">
                    % of NVG
                  </Label>
                  <Input
                    name={`${field.fieldName}NVG`}
                    type="text"
                    // step="0.01"
                    placeholder={`Enter ${field.fieldLabel}`}
                    onChange={(e) => { handleInputChange(index, `${field.fieldName}NVG`, e.target.value) }}
                    onBlur={() => validation.setFieldTouched(`productInfoList[${index}].${field.fieldName}NVG`, true)}
                    value={
                      validation.values.productInfoList?.[index]?.[
                      `${field.fieldName}NVG`
                      ] || ""
                    }
                    invalid={
                      !!(validation.touched.productInfoList?.[index]?.[
                        `${field.fieldName}NVG`
                      ] &&
                        validation.errors.productInfoList?.[index]?.[`${field.fieldName}NVG`])
                    }
                  />
                  {validation.touched.productInfoList?.[index]?.[`${field.fieldName}NVG`] &&
                    validation.errors.productInfoList?.[index]?.[`${field.fieldName}NVG`] ? (
                    <FormFeedback type="invalid">
                      {validation.errors.productInfoList?.[index]?.[`${field.fieldName}NVG`]}
                    </FormFeedback>
                  ) : null}
                </Col>)}

                {!isNVGSelected && (<Col sm="12" md="3">
                  <Label className="form-label mt-2 grey">
                    Value
                    {(validation.values.productInfoList?.[index]?.[`${field.fieldName}Type`] === 'Throughput') && ' (%)'}
                  </Label>
                  <Input
                    name={`${field.fieldName}Value`}
                    type="text"
                    id={`${field.fieldName}Type_${index}`}
                    placeholder={`Enter ${field.fieldLabel}`}
                    onChange={(e) => { handleInputChange(index, `${field.fieldName}Value`, e.target.value) }}
                    onBlur={() => validation.setFieldTouched(`productInfoList[${index}].${field.fieldName}Value`, true)}
                    value={
                      validation.values.productInfoList?.[index]?.[
                      `${field.fieldName}Value`
                      ] || ""
                    }
                    invalid={
                      !!(validation.touched.productInfoList?.[index]?.[
                        `${field.fieldName}Value`
                      ] &&
                        validation.errors.productInfoList?.[index]?.[`${field.fieldName}Value`])
                    }
                  />
                  {validation.touched.productInfoList?.[index]?.[`${field.fieldName}Value`] &&
                    validation.errors.productInfoList?.[index]?.[`${field.fieldName}Value`] ? (
                    <FormFeedback type="invalid">
                      {validation.errors.productInfoList?.[index]?.[`${field.fieldName}Value`]}
                    </FormFeedback>
                  ) : null}
                </Col>)}
              </>)}

              {field.fieldName !== 'platformCharges' && (<>
                <Col sm="12" md="3">
                  <Label className="form-label mt-2 grey">
                    Frequency{validation.values.productInfoList?.[index]?.product === "Inventory funding" && (
                      <span>*</span>
                    )}
                  </Label>
                  <Input
                    name={`${field.fieldName}Frequency`}
                    id={`${field.fieldName}Type_${index}`}
                    type="select"
                    placeholder={`Select ${field.fieldLabel} Frequency`}
                    onChange={(e) => { handleInputChange(index, `${field.fieldName}Frequency`, e.target.value) }} // Let Formik handle the change
                    onBlur={() => validation.setFieldTouched(`productInfoList[${index}].${field.fieldName}Frequency`, true)}
                    value={
                      validation.values.productInfoList?.[index]?.[`${field.fieldName}Frequency`] ||
                      ""
                    }
                    invalid={
                      !!(validation.touched.productInfoList?.[index]?.[
                        `${field.fieldName}Frequency`
                      ] &&
                        validation.errors.productInfoList?.[index]?.[`${field.fieldName}Frequency`])
                    }
                  >
                    <option value="" disabled>Select</option>
                    <option value="Recurring" disabled={validation.values.prospectiveProduct === 'TradEasy'}>Recurring</option>
                    <option value="One time">One time</option>
                  </Input>
                  {validation.touched.productInfoList?.[index]?.[`${field.fieldName}Frequency`] &&
                    validation.errors.productInfoList?.[index]?.[`${field.fieldName}Frequency`] ? (
                    <FormFeedback type="invalid">
                      {validation.errors.productInfoList?.[index]?.[`${field.fieldName}Frequency`]}
                    </FormFeedback>
                  ) : null}
                </Col>

                <Col sm="12" md="3">
                  <Label className="form-label mt-2 grey">
                    Occurrence{validation.values.productInfoList?.[index]?.product === "Inventory funding" && (
                      <span>*</span>
                    )}
                  </Label>
                  <Input
                    name={`${field.fieldName}Occurrence`}
                    id={`${field.fieldName}Type_${index}`}
                    type="select"
                    placeholder={
                      validation.values.productInfoList?.[index]?.[`${field.fieldName}Time`] === "One Time"
                        ? "Not Applicable"
                        : `Select ${field.fieldLabel} Occurrence`
                    }
                    onChange={(e) => { handleInputChange(index, `${field.fieldName}Occurrence`, e.target.value) }}
                    onBlur={() => validation.setFieldTouched(`productInfoList[${index}].${field.fieldName}Occurrence`, true)}
                    value={
                      validation.values.productInfoList?.[index]?.[`${field.fieldName}Frequency`] === "One time"
                        ? ""
                        : validation.values.productInfoList?.[index]?.[`${field.fieldName}Occurrence`] || ""
                    }
                    invalid={
                      !!(validation.touched.productInfoList?.[index]?.[
                        `${field.fieldName}Occurrence`
                      ] &&
                        validation.errors.productInfoList?.[index]?.[`${field.fieldName}Occurrence`])
                    }
                    disabled={validation.values.productInfoList?.[index]?.[`${field.fieldName}Frequency`] === "One time"}
                  >
                    <option value="" disabled>{
                      validation.values[`${field.fieldName}Frequency`] === "One time"
                        ? "Not Applicable"
                        : `Select`
                    }</option>
                    <option value="Per Annum">Per Annum</option>
                    <option value="Per Month">Per Month</option>
                    <option value="At Invoice">At Invoice</option>
                    <option value="AUM">AUM</option>
                    <option value="Quarterly">Quarterly</option>
                  </Input>
                  {validation.touched.productInfoList?.[index]?.[`${field.fieldName}Occurrence`] &&
                    validation.errors.productInfoList?.[index]?.[`${field.fieldName}Occurrence`] ? (
                    <FormFeedback type="invalid">
                      {validation.errors.productInfoList?.[index]?.[`${field.fieldName}Occurrence`]}
                    </FormFeedback>
                  ) : null}
                </Col>

                <Col sm="12" md="3">
                  <Label className="form-label mt-2 grey">
                    Value
                    {(validation.values.productInfoList?.[index]?.[`${field.fieldName}Type`] === 'Percentage') && ' (%)'}
                    {validation.values.productInfoList?.[index]?.product === "Inventory funding" && (
                      <span>*</span>
                    )}
                  </Label>
                  <Input
                    name={`${field.fieldName}Value`}
                    type="text"
                    id={`${field.fieldName}Type_${index}`}
                    placeholder={
                      validation.values.productInfoList[index].product === "Inventory funding" 
                        ? (field.fieldLabel === "Syndication Charges" ? "Enter Gross PF" : 
                           field.fieldLabel === "Integration Fees" ? "Enter Net PF" : `Enter ${field.fieldLabel}`)
                        : `Enter ${field.fieldLabel}`
                    }
                    onChange={(e) => { handleInputChange(index, `${field.fieldName}Value`, e.target.value) }}
                    onBlur={() => validation.setFieldTouched(`productInfoList[${index}].${field.fieldName}Value`, true)}
                    value={
                      validation.values.productInfoList?.[index]?.[
                      `${field.fieldName}Value`
                      ] || ""
                    }
                    invalid={
                      !!(validation.touched.productInfoList?.[index]?.[
                        `${field.fieldName}Value`
                      ] &&
                        validation.errors.productInfoList?.[index]?.[`${field.fieldName}Value`])
                    }
                  />
                  {validation.touched.productInfoList?.[index]?.[`${field.fieldName}Value`] &&
                    validation.errors.productInfoList?.[index]?.[`${field.fieldName}Value`] ? (
                    <FormFeedback type="invalid">
                      {validation.errors.productInfoList?.[index]?.[`${field.fieldName}Value`]}
                    </FormFeedback>
                  ) : null}
                </Col>
              </>)}
            </>
          ))}
        </Row>

      </CardBody>
    </Card>
  );
};

const TableRowShareHolding = ({
  onDelete,
  index,
  validation,
  percentageholdingValue,
}) => {
  const [shareholderType, setShareholderType] = useState([]);

  useEffect(() => {
    getDropDownList({ dropdownName: "shareholder" })
      .then((response) => {
        const dropdownValues =
          response.data?.rows?.find((dv) => dv.dropdownName == "shareholder")
            ?.dropdownValues || [];
        setShareholderType(dropdownValues);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const handleInputChange = (index, field, value) => {
    validation.setFieldValue(`shareholderList.${index}.${field}`, value);
    if (field == "percentageHolding") {
      percentageholdingValue(+value);
    }
  };

  return (
    <tr>
      <td>
        <Input
          type="text"
          placeholder="Enter Shareholder Name"
          name={`shareholder[${index}].shareholderName`}
          id={`shareholder[${index}].shareholderName`}
          value={validation.values.shareholderList[index].shareholderName}
          onChange={(event) => {
            handleInputChange(index, "shareholderName", event.target.value);
          }}
        />
      </td>
      <td style={{ width: "30%" }}>
        <Select
          options={shareholderType.map((option, index) => ({
            label: option.displayName,
            value: option.dropdownValue,
          }))}
          className={`${
            validation.touched.shareholderList?.[index]?.shareholderType &&
            validation.errors.shareholderList?.[index]?.shareholderType
              ? "is-invalid"
              : ""
          }`}
          name={`shareholder[${index}].shareholderType`}
          id={`shareholder[${index}].shareholderType`}
          onChange={(selectedOption) => {
            handleInputChange(index, "shareholderType", selectedOption.value);
          }}
          value={setshareholdingType(
            shareholderType,
            validation.values.shareholderList[index].shareholderType
          )}
        />
        {validation.touched.shareholderList?.[index]?.shareholderType &&
          validation.errors.shareholderList?.[index]?.shareholderType && (
            <FormFeedback>
              {validation.errors.shareholderList?.[index]?.shareholderType}
            </FormFeedback>
          )}
      </td>
      <td>
        <Input
          type="number"
          placeholder="Enter Shareholding Percentage"
          name={`shareholder[${index}].percentageHolding`}
          id={`shareholder[${index}].percentageHolding`}
          value={validation.values.shareholderList[index].percentageHolding}
          onChange={(event) => {
            handleInputChange(index, "percentageHolding", event.target.value);
          }}
          invalid={
            validation.touched?.shareholderList?.[index]?.percentageHolding &&
            validation.errors?.shareholderList?.[index]?.percentageHolding
              ? true
              : false
          }
        />

        {validation.touched.shareholderList?.[index]?.percentageHolding &&
          validation.errors.shareholderList?.[index]?.percentageHolding && (
            <FormFeedback>
              {validation.errors.shareholderList?.[index]?.percentageHolding}
            </FormFeedback>
          )}
      </td>
      <td>
        {validation.values?.shareholderList?.length > 1 && (
          <i
            className="bx bx-x-circle text-danger"
            onClick={() => onDelete(index)}
            style={{ cursor: "pointer", fontSize: "17px", marginTop: "10px" }}
          />
        )}
      </td>
    </tr>
  );

  function setshareholdingType(data, shareholdingType) {
    if (shareholdingType) {
      for (const item of data) {
        if (item.dropdownValue === shareholdingType) {
          const value = {
            label: `${item.displayName}`,
            value: shareholdingType,
          };
          return value;
        }
      }
    }
  }
};

let commercialFieldsData = [
  {
    id: 3,
    fieldName: "platformCharges",
    fieldLabel: "Platform Charges",
  },
  {
    id: 2,
    fieldName: "syndicationFees",
    fieldLabel: "Syndication Charges",
  },
  {
    id: 1,
    fieldName: "integrationFees",
    fieldLabel: "Integration Fees",
  },
  // {
  //   id: 4,
  //   fieldName: "financesCharges",
  //   fieldLabel: "Finances Charges",
  // },
  // {
  //   id: 4,
  //   fieldName: "selfFinanaces",
  //   fieldLabel: "Self Finances / Early Payment",
  // },
];
